let isAppDashboard = window.location.hash === '#app-dashboard';
if (window.location.hash === '#app-dashboard') {
  window.location.hash = '';
  if (typeof state !== 'undefined') {
    state.route = 'dashboard';
    state.dashTab = 'home';
  }
}

import { auth, db, doc, getDoc, setDoc, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, sendPasswordResetEmail, collection, query, where, getDocs, signOut, deleteDoc, signInWithCustomToken } from './firebase.js';
import { SAMPLE_OPPORTUNITIES, CATEGORIES as OPPORTUNITY_CATEGORIES, TAG_COLORS as OPPORTUNITY_TAG_COLORS, daysUntilDeadline, timeAgo } from './opportunities.js';

window.firebase = {
  auth: () => ({
    signInWithCustomToken: (token) => signInWithCustomToken(auth, token)
  })
};

const urlParams = new URLSearchParams(window.location.search);
const appToken = urlParams.get('app_token');
const appUid = urlParams.get('app_uid');
const appLogin = urlParams.get('app_login');
if (appToken && appLogin === 'true') {
  localStorage.setItem('tb_auth_token', appToken);
  if (appUid) localStorage.setItem('tb_user_id', appUid);
  localStorage.setItem('tb_native_app_session', 'true');
  isAppDashboard = true;
  window.history.replaceState({}, '', '/#app-dashboard');
}

const isNativeAppSession = () =>
  localStorage.getItem('tb_native_app_session') === 'true' &&
  Boolean(localStorage.getItem('tb_auth_token'));

const syncNativeAppChrome = () => {
  document.body.classList.toggle('is-native-app', isNativeAppSession());
};
syncNativeAppChrome();

// ── PWA Service Worker Registration ──
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => console.log('[PWA] Service Worker registered:', reg.scope))
      .catch((err) => console.warn('[PWA] SW registration failed:', err));
  });
}

// ── APK Install Prompt (Triggered after login) ──

window.handleApkDownload = function() {
  window.location.href = '/taskbridge.apk';
};

window.showApkInstallPopup = function() {
  if (document.getElementById('apk-install-overlay')) return;
  const overlay = document.createElement('div');
  overlay.id = 'apk-install-overlay';
  overlay.style.position = 'fixed';
  overlay.style.inset = '0';
  overlay.style.background = 'rgba(0,0,0,0.7)';
  overlay.style.zIndex = '9999';
  overlay.style.display = 'flex';
  overlay.style.alignItems = 'center';
  overlay.style.justifyContent = 'center';
  overlay.style.padding = '20px';
  overlay.innerHTML = `
    <div style="background: var(--bg, #0f172a); border: 1px solid var(--border, rgba(255,255,255,0.1)); border-radius: 20px; padding: 24px; max-width: 400px; width: 100%; text-align: center; box-shadow: 0 10px 30px rgba(0,0,0,0.5);">
      <img src="./logo192.png" style="width: 64px; height: 64px; border-radius: 16px; margin-bottom: 16px;">
      <h2 style="margin: 0 0 8px; font-size: 1.5rem; color: white;">Install Taskbridge App</h2>
      <p style="color: #94a3b8; font-size: 0.95rem; margin-bottom: 24px; line-height: 1.5;">Get the official Android app for a faster, smoother experience. (You may need to allow "Install unknown apps").</p>
      <div style="display: flex; gap: 12px;">
        <button onclick="document.getElementById('apk-install-overlay').remove()" style="flex: 1; padding: 12px; background: rgba(255,255,255,0.1); color: white; border: none; border-radius: 12px; font-weight: 600; cursor: pointer;">Not Now</button>
        <button onclick="document.getElementById('apk-install-overlay').remove(); window.handleApkDownload();" style="flex: 1; padding: 12px; background: #22c55e; color: #0f172a; border: none; border-radius: 12px; font-weight: 700; cursor: pointer;">Install App</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);
};

window.handleAvatarUpload = function(event) {
  const file = event.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = function(e) {
    profile.customAvatar = e.target.result;
    saveProfile().then(() => {
      render();
      if(typeof showToast === 'function') showToast("Profile picture updated!");
    });
  };
  reader.readAsDataURL(file);
};

window.showNotificationsModal = function() {
  if (document.getElementById('notifications-modal')) return;
  const overlay = document.createElement('div');
  overlay.id = 'notifications-modal';
  overlay.style.position = 'fixed';
  overlay.style.inset = '0';
  overlay.style.background = 'rgba(0,0,0,0.5)';
  overlay.style.zIndex = '9999';
  overlay.style.display = 'flex';
  overlay.style.alignItems = 'flex-start';
  overlay.style.justifyContent = 'center';
  overlay.style.padding = '80px 20px 20px';
  
  const notifications = profile.notifications || [
    { title: 'Welcome to Taskbridge!', body: 'Start exploring opportunities in your dashboard.', time: new Date() }
  ];
  
  const listHtml = notifications.map(n => `
    <div style="padding: 12px; border-bottom: 1px solid rgba(255,255,255,0.1); text-align: left;">
      <h4 style="margin: 0 0 4px; color: white; font-size: 0.95rem;">${escapeHtml(n.title)}</h4>
      <p style="margin: 0; color: #94a3b8; font-size: 0.85rem;">${escapeHtml(n.body)}</p>
    </div>
  `).join('');
  
  overlay.innerHTML = `
    <div style="background: var(--bg, #0f172a); border: 1px solid var(--border, rgba(255,255,255,0.1)); border-radius: 16px; max-width: 400px; width: 100%; box-shadow: 0 10px 40px rgba(0,0,0,0.6); overflow: hidden; display: flex; flex-direction: column; max-height: 80vh;">
      <div style="padding: 16px; border-bottom: 1px solid rgba(255,255,255,0.1); display: flex; justify-content: space-between; align-items: center; background: rgba(0,0,0,0.2);">
        <h3 style="margin: 0; color: white;">Notifications</h3>
        <button onclick="document.getElementById('notifications-modal').remove()" style="background: none; border: none; color: white; font-size: 20px; cursor: pointer;">&times;</button>
      </div>
      <div style="padding: 0; overflow-y: auto;">
        ${listHtml || '<div style="padding: 24px; text-align: center; color: #64748b;">No new notifications.</div>'}
      </div>
    </div>
  `;
  document.body.appendChild(overlay);
};

const DAY_MS = 24 * 60 * 60 * 1000;
const ADMIN_EMAILS = ["pkiachmathias9@gmail.com", "taskbridge.co.ke@gmail.com"];
const REVIEW_WINDOW_TEXT = "Assignment and task reviews are done between 6am and 11am every day.";
const REFERRAL_PAYOUT = 50;
const API_BASE_URL = new URLSearchParams(window.location.search).get("api") || (window.location.hostname.includes("taskbridge.co.ke") || window.location.hostname.includes("pages.dev") ? "https://taskbridge.co.ke" : "") || import.meta.env.VITE_BACKEND_URL || "https://taskbridge.co.ke";

const categories = [
  {
    name: "AI Training",
    icon: "brain",
    glow: ["#3b82f6", "#60a5fa"],
    tasks: ["Train RLHF Chatbot on Logical Reasoning", "Label Complex Coding Prompts", "Evaluate Conversational Tone Refinements", "Correct Hallucinated Output in Model Responses"],
    instruction: "Critically review prompt responses, score logical pathways, and annotate structured answers to improve LLM generation.",
  },
  {
    name: "Data Entry",
    icon: "keyboard",
    glow: ["#10b981", "#34d399"],
    tasks: ["Format Inventory Spreadsheets", "Extract Contact Details from Invoices", "Clean Messy Customer Lead Logs", "Migrate Legacy Client Records to Database"],
    instruction: "Transcribe, format, and organize raw text and numbers into clean structured datasets with high attention to detail.",
  },
  {
    name: "Image Annotation",
    icon: "photo",
    glow: ["#f59e0b", "#fbbf24"],
    tasks: ["Draw Bounding Boxes on Street Scene Elements", "Semantic Segmentation of Medical Scans", "Polygon Labeling of Satellite Imagery", "Tag Facial Keypoints for Expression Training"],
    instruction: "Identify and outline specific visual objects or keypoints in images using bounding boxes, polygons, or classification tags.",
  },
  {
    name: "Video Annotation",
    icon: "video",
    glow: ["#ef4444", "#f87171"],
    tasks: ["Track Moving Vehicles in Traffic Video", "Label Pedestrian Trajectories at Intersections", "Tag Dynamic Action Segments in Sports Clips", "Annotate Robotic Arm Movements Frame by Frame"],
    instruction: "Review short videos frame-by-frame or tag temporal segments to train visual dynamic systems.",
  },
  {
    name: "Audio Tasks",
    icon: "volume",
    glow: ["#8b5cf6", "#a78bfa"],
    tasks: ["Transcribe Short Dialect Audio Snippets", "Label Audio Noise and Background Interference", "Evaluate Text-to-Speech Output Naturalness", "Identify Speaker Shifts in Multi-Party Chats"],
    instruction: "Listen to voice clips, transcribe words, or rate voice quality and naturalness.",
  },
  {
    name: "OCR Correction",
    icon: "file-text",
    glow: ["#06b6d4", "#22d3ee"],
    tasks: ["Correct Extracted Text from Hand-written Recipes", "Verify OCR Scans of Historical Newspaper Articles", "Fix Extracted Data on Distorted Receipts", "Format Scanned PDF Output into Clean Markdown"],
    instruction: "Compare scanned document images with extracted OCR text and manually correct alignment, spelling, and format errors.",
  },
  {
    name: "Prompt Writing",
    icon: "message-plus",
    glow: ["#ec4899", "#f472b6"],
    tasks: ["Write 10 Diverse Prompts for Creative Writing", "Formulate Coding Scenarios for API Debugging", "Draft Challenging Math Prompts with Solutions", "Create Realistic Customer Support Scenarios"],
    instruction: "Create creative, clear, and diverse prompt queries for artificial intelligence models across specific domains.",
  },
  {
    name: "Prompt Evaluation",
    icon: "stars",
    glow: ["#14b8a6", "#2dd4bf"],
    tasks: ["Compare Model Output Side-by-Side", "Grade LLM Code Output Efficiency", "Rate Safety and Toxicity Levels in Responses", "Review Model Alignment to Original Persona"],
    instruction: "Compare multiple model outputs, rank them by quality, correctness, safety, and helpfulness, and provide brief feedback.",
  },
  {
    name: "Fact Checking",
    icon: "shield-check",
    glow: ["#6366f1", "#818cf8"],
    tasks: ["Verify Political Claims with Credible Sources", "Confirm Scientific References in AI Drafts", "Cross-Reference Historical Dates in Text", "Audit Product Spec Tables Against Official Sites"],
    instruction: "Audit factual claims in generated text against verified, reliable primary sources.",
  },
  {
    name: "Grammar Review",
    icon: "spellcheck",
    glow: ["#0ea5e9", "#38bdf8"],
    tasks: ["Proofread Technical Documentation Drafts", "Correct ESL Student Creative Essays", "Review Tone Consistency in Corporate Letters", "Fix Punctuation and Structure in Blog Articles"],
    instruction: "Review text copy, correct grammatical errors, fix syntax, and improve structural readability and tone.",
  },
  {
    name: "Translation Review",
    icon: "language",
    glow: ["#22c55e", "#4ade80"],
    tasks: ["Verify English to Swahili Technical Translation", "Review Spanish to English Translation Accuracy", "Audit Machine-translated Product Descriptions", "Review Localized UI Strings for App Interfaces"],
    instruction: "Evaluate translated text against the original source to verify accuracy, cultural nuances, and language flow.",
  },
  {
    name: "Search Rating",
    icon: "search",
    glow: ["#64748b", "#94a3b8"],
    tasks: ["Rate Search Query Relevance to Landing Page", "Verify Query Intent Matches Local Business Info", "Assess Search Result Authority and Trustworthiness", "Evaluate Image Search Result Match Accuracy"],
    instruction: "Evaluate search queries against web results, rating how well the results satisfy user intent and geographical context.",
  },
  {
    name: "Ad Rating",
    icon: "speakerphone",
    glow: ["#f43f5e", "#fb7185"],
    tasks: ["Rate Social Media Ad Copy Alignment to Image", "Verify Ad Target Landing Page Safety", "Assess Search Ad Relevance to Query", "Categorize Ad Creative Content Appropriateness"],
    instruction: "Evaluate online advertisements to ensure they are safe, relevant to search queries, and high quality.",
  },
  {
    name: "Map Validation",
    icon: "map-pin",
    glow: ["#eab308", "#facc15"],
    tasks: ["Verify Business Operating Hours on Map", "Check Road Segment Connectivity in Satellite View", "Validate New Store Coordinates Against Photo Evidence", "Update Missing Business Category Information"],
    instruction: "Validate geographical points of interest, road connections, and address coordinates using satellite imagery and business listings.",
  },
  {
    name: "Business Verification",
    icon: "building-store",
    glow: ["#84cc16", "#a3e635"],
    tasks: ["Verify Restaurant Phone Number and Active Status", "Confirm Retail Store Physical Address Details", "Check Business License Registry Online", "Validate Company Service Catalog Offerings"],
    instruction: "Contact or research local businesses online to confirm details, active status, contact info, and catalog items.",
  },
  {
    name: "Product Categorization",
    icon: "tags",
    glow: ["#a855f7", "#c084fc"],
    tasks: ["Assign E-commerce Items to Exact Categories", "Tag Product Materials and Attributes", "Match Items with Universal Product Codes (UPCs)", "Filter Out-of-Stock E-commerce Variants"],
    instruction: "Organize retail products into exact taxonomy structures and assign attributes (color, material, type).",
  },
  {
    name: "Duplicate Detection",
    icon: "copy",
    glow: ["#06b6d4", "#22d3ee"],
    tasks: ["Identify Duplicate E-commerce Product Listings", "Flag Repeated News Articles in Feeds", "Find Identical Profiles in User Directory", "Merge Similar Contact Records in CRM Logs"],
    instruction: "Compare items, listings, or text records side-by-side to determine if they represent duplicates or unique items.",
  },
  {
    name: "Survey Tasks",
    icon: "forms",
    glow: ["#10b981", "#34d399"],
    tasks: ["Share Feedback on New App Feature UI", "Respond to Consumer Preference Questionnaire", "Participate in Academic Focus Group Survey", "Review Video Streaming Platform Service Quality"],
    instruction: "Complete demographics, service preferences, and feedback surveys honestly and thoroughly.",
  },
  {
    name: "Website Testing",
    icon: "device-laptop",
    glow: ["#4f46e5", "#6366f1"],
    tasks: ["Test E-commerce Checkout Flow for Layout Bugs", "Verify Link Behavior and Navigation Options", "Test Light/Dark Mode Color Contrast Compliance", "Verify Multi-device Responsiveness on Safari/Chrome"],
    instruction: "Navigate test websites, perform specified actions, and report UI glitches, bugs, or performance issues.",
  },
  {
    name: "Mobile Testing",
    icon: "device-mobile",
    glow: ["#0ea5e9", "#38bdf8"],
    tasks: ["Verify iOS Sign-up Flow Success", "Test Android Push Notification Clicks", "Check Native Video Player Crash Events", "Verify Offline Mode Synchronization Behavior"],
    instruction: "Install and test mobile application packages (.apk / TestFlight), verifying specified features and recording performance anomalies.",
  },
  {
    name: "Content Moderation",
    icon: "alert-triangle",
    glow: ["#dc2626", "#ef4444"],
    tasks: ["Filter Offensive Comments in Chat Forum", "Flag Inappropriate Image Uploads", "Review Profile Names for Terms Violation", "Moderate Spam Messages in Community Channel"],
    instruction: "Screen user submissions, messages, and files against community guidelines, flagging violation material.",
  },
  {
    name: "Chat Evaluation",
    icon: "message-circle",
    glow: ["#d946ef", "#f472b6"],
    tasks: ["Evaluate Customer Support Chat Transcript Helpful", "Grade AI Assistant Tone and Politeness", "Verify Chat Bot Followed Procedural Guidelines", "Assess Resolution Success in Live Log"],
    instruction: "Audit chat logs between users and human/AI agents, scoring support quality, prompt response, and issue resolution.",
  },
  {
    name: "Voice Recording",
    icon: "microphone",
    glow: ["#14b8a6", "#2dd4bf"],
    tasks: ["Record Short Commands (e.g. 'Hey TaskBridge')", "Read Paragraph Out Loud in Clear English", "Record Casual Swahili Dialogues with Partner", "Record Command Phrases in Noisy Environment"],
    instruction: "Use the built-in recorder to capture specified phrases, stories, or commands in clean audio format.",
  },
  {
    name: "Photo Collection",
    icon: "camera",
    glow: ["#ea580c", "#f97316"],
    tasks: ["Take Photos of 5 Different Houseplants", "Capture Images of local Street Signs", "Take Photos of Grocery Receipt Items", "Submit Selfie Photos with Varying Backgrounds"],
    instruction: "Take and upload custom photographs matching specified parameters (objects, lighting, resolution).",
  },
  {
    name: "Document Collection",
    icon: "file-zip",
    glow: ["#475569", "#64748b"],
    tasks: ["Submit Anonymized Utility Bill Samples", "Collect Local Newspaper Front Pages", "Gather Public SME Financial Balance Sheets", "Collate Free Academic PDFs on Specific Topics"],
    instruction: "Upload or gather publicly available files or documents matching specific research constraints.",
  },
  {
    name: "Code Review",
    icon: "code",
    glow: ["#0f172a", "#1e293b"],
    tasks: ["Audit Python script for Security Vulnerabilities", "Review JavaScript React Component Performance", "Check SQL Queries for Syntax Optimization", "Evaluate HTML Structure for Accessibility Guidelines"],
    instruction: "Verify functional correctness, check performance bugs, security vulnerabilities, and formatting of submitted code files.",
  },
  {
    name: "Math Evaluation",
    icon: "math-symbols",
    glow: ["#ca8a04", "#eab308"],
    tasks: ["Verify Algebra Solved Explanations", "Grade Calculus Homework Responses", "Validate Statistics Problem Solutions", "Explain Errors in Geometrical Proof Drafts"],
    instruction: "Review mathematically formatted steps and verify accuracy of formulas, equations, and explanatory proofs.",
  },
  {
    name: "Medical Annotation",
    icon: "heart-handshake",
    glow: ["#be123c", "#e11d48"],
    tasks: ["Label Clinical Symptoms in Doctor Notes", "Verify Anonymized EHR Diagnosis Tagging", "Identify Key Anatomical Structures on Scans", "Highlight Drug Interaction Warnings in Documents"],
    instruction: "Add structured diagnostic tags or annotations to medical texts, notes, and imaging files.",
  },
  {
    name: "Legal Review",
    icon: "gavel",
    glow: ["#b45309", "#d97706"],
    tasks: ["Identify Liabilities in Vendor Agreements", "Tag NDA Clausal Obligations", "Cross-Reference Precedent Case Dates", "Summarize Patent Claims for Quick Review"],
    instruction: "Analyze legal documentation to extract critical entities, highlight liabilities, or summarize clauses.",
  },
  {
    name: "Research",
    icon: "search-list",
    glow: ["#0369a1", "#0284c7"],
    tasks: ["Compile Competitor Product Pricing Lists", "Research Academic Citations for Topic", "Gather Industry Reports on Clean Energy", "List Top Active Non-Profits in East Africa"],
    instruction: "Perform open web search queries to collect, summarize, and reference detailed information regarding target topics.",
  },
  {
    name: "Custom Tasks",
    icon: "settings-automation",
    glow: ["#090d16", "#1e293b"],
    tasks: ["Custom User Interface Survey", "Dynamic Form Field Collection", "Miscellaneous Annotation Request", "General System Feedback Task"],
    instruction: "Complete custom tasks configured dynamically by platform administrators or clients.",
  }
];

const specialCategory = {
  name: "Crypto and Blockchain Ambassadorship",
  icon: "blocks",
  glow: ["#38bdf8", "#2563eb"],
  title: "Crypto and Blockchain Ambassadorship Application",
  instruction: "Applications are open for crypto and blockchain ambassador roles. Admin will add the application link and description here.",
  externalLink: "",
  external: true,
};

const defaultEcosystemLinks = [
  { id: "eco-whatsapp", title: "WhatsApp Channel", url: "", description: "Official TASKBRIDGE updates and announcements." },
  { id: "eco-telegram", title: "Telegram Group", url: "", description: "Community discussions, updates, and support." },
];

const thumbnailImages = [
  "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=800&q=70", // 0  AI Training – AI brain/neural
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=70", // 1  Data Entry – spreadsheet/laptop
  "https://images.unsplash.com/photo-1561557944-6e7860d1a7eb?auto=format&fit=crop&w=800&q=70", // 2  Image Annotation – tagged photo
  "https://images.unsplash.com/photo-1536240478700-b869070f9279?auto=format&fit=crop&w=800&q=70", // 3  Video Annotation – video editing
  "https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=800&q=70", // 4  Audio Tasks – music/audio studio
  "https://images.unsplash.com/photo-1586953208448-b95a79798f07?auto=format&fit=crop&w=800&q=70", // 5  OCR Correction – document scanning
  "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=70", // 6  Prompt Writing – writing/pen
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=70", // 7  Prompt Evaluation – analytics/charts
  "https://images.unsplash.com/photo-1504711434969-e33886168d3c?auto=format&fit=crop&w=800&q=70", // 8  Fact Checking – magnifying glass/research
  "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=800&q=70", // 9  Grammar Review – book/writing
  "https://images.unsplash.com/photo-1451226428352-cf66bf8a0317?auto=format&fit=crop&w=800&q=70", // 10 Translation Review – globe/language
  "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?auto=format&fit=crop&w=800&q=70", // 11 Search Rating – search/code screen
  "https://images.unsplash.com/photo-1563986768609-322da13575f2?auto=format&fit=crop&w=800&q=70", // 12 Ad Rating – marketing/social ads
  "https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&w=800&q=70", // 13 Map Validation – satellite map
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=800&q=70", // 14 Business Verification – office/business
  "https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&w=800&q=70", // 15 Product Categorization – retail/shopping
  "https://images.unsplash.com/photo-1558655146-d09347e92766?auto=format&fit=crop&w=800&q=70", // 16 Duplicate Detection – digital patterns
  "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=800&q=70", // 17 Survey Tasks – clipboard/forms
  "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=70", // 18 Website Testing – laptop/web dev
  "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=70", // 19 Mobile Testing – mobile phone app
  "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?auto=format&fit=crop&w=800&q=70", // 20 Content Moderation – security/shield
  "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?auto=format&fit=crop&w=800&q=70", // 21 Chat Evaluation – chat/messaging
  "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?auto=format&fit=crop&w=800&q=70", // 22 Voice Recording – microphone/voice
  "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?auto=format&fit=crop&w=800&q=70", // 23 Photo Collection – camera/photo
  "https://images.unsplash.com/photo-1568667256549-094345857637?auto=format&fit=crop&w=800&q=70", // 24 Document Collection – library/documents
  "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=70", // 25 Code Review – code on screen
  "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=800&q=70", // 26 Math Evaluation – math equations
  "https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=800&q=70", // 27 Medical Annotation – medical/stethoscope
  "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=800&q=70", // 28 Legal Review – law/gavel
  "https://images.unsplash.com/photo-1532153975070-2e9ab71f1b14?auto=format&fit=crop&w=800&q=70", // 29 Research – research/library
  "https://images.unsplash.com/photo-1642104704074-907c0698cbd9?auto=format&fit=crop&w=800&q=70", // 30 Custom Tasks – settings/gears
];

const storeKey = "taskbridge-marketplace-state";
const referralStoreKey = "taskbridge-referral-registry";

const defaultProfile = {
  name: "",
  username: "",
  email: "",
  phone: "",
  active: false,
  joinedAt: "",
  isOnline: true,
  isAdmin: false,
  unlockedTasks: {},
  submissions: [],
  customTasks: [],
  ecosystemLinks: defaultEcosystemLinks,
  specialTask: {
    description: specialCategory.instruction,
    applicationLink: "",
  },
  transactions: [],
  paymentDetails: {
    mpesaName: "",
    mpesaPhone: "",
    withdrawalNote: "",
  },
  wallet: {
    taskEarnings: 0,
    referralEarnings: 0,
    checkinRewards: 0,
    pendingWithdrawals: 0,
  },
  successfulReferrals: 0,
  referralClicks: 0,
  referralCode: "",
  referredBy: "",
  referredUsers: [],
  referralPaidOut: [],
  lastCheckIn: null,
  portalCode: "",
};

const state = {
  route: (isNativeAppSession() || isAppDashboard) ? "dashboard" : "home",
  heroMode: "work",
  menuOpen: false,
  dashTab: "home",
  adminTab: "reviews",
  activeCategory: "All",
  filterDifficulty: "all",
  filterDuration: "all",
  filterCountry: "all",
  filterLevel: "all",
  jobsFilter: "all",
  jobsSearch: "",
  jobsMenuExpanded: false,
  financeMenuExpanded: false,
  txHistoryExpanded: false,
  academyCourses: null,
  loadingAcademyCourses: false,
  search: "",
  sort: "hot",
  selectedTaskId: "",
  editTaskId: "",
  editEcosystemId: "",
  welcomeMessage: "",
  inviterInfo: null,
  resolvedReferralCode: "",
  theme: localStorage.getItem('theme') || 'dark',
  pendingRedirect: null,
};

let profile = loadProfile();
let isFirebaseInitialized = false;
let allOpportunities = [];

async function loadOpportunities() {
  try {
    const querySnapshot = await getDocs(collection(db, "opportunities"));
    if (querySnapshot.empty) {
      // Seed Firestore with SAMPLE_OPPORTUNITIES
      for (const opp of SAMPLE_OPPORTUNITIES) {
        await setDoc(doc(db, "opportunities", opp.id), opp);
      }
      allOpportunities = [...SAMPLE_OPPORTUNITIES];
    } else {
      allOpportunities = [];
      querySnapshot.forEach((doc) => {
        allOpportunities.push(doc.data());
      });
    }
  } catch (err) {
    console.error("Error loading opportunities:", err);
    allOpportunities = [...SAMPLE_OPPORTUNITIES];
  }
}

// ── Global shared config (admin edits go here, visible to ALL users) ──
let globalConfig = {
  maintenanceMode: false,
  customTasks: [],
  hiddenTasks: [],
  customProducts: {},
  specialTask: {},
  ecosystemLinks: typeof defaultEcosystemLinks !== 'undefined' ? defaultEcosystemLinks : []
};

async function loadGlobalConfig() {
  try {
    const ref = doc(db, 'settings', 'global');
    const snap = await getDoc(ref);
    if (snap.exists()) {
      const data = snap.data();
      globalConfig = {
        maintenanceMode: data.maintenanceMode || false,
        customTasks: data.customTasks || [],
        hiddenTasks: data.hiddenTasks || [],
        customProducts: data.customProducts || {},
        specialTask: data.specialTask || {},
        ecosystemLinks: data.ecosystemLinks || (typeof defaultEcosystemLinks !== 'undefined' ? defaultEcosystemLinks : [])
      };
    }
  } catch (e) {
    console.error('Failed to load global config:', e);
  }
}

async function saveGlobalConfig() {
  try {
    const ref = doc(db, 'settings', 'global');
    await setDoc(ref, globalConfig, { merge: true });
  } catch (e) {
    console.error('Failed to save global config:', e);
  }
}
onAuthStateChanged(auth, async (user) => {
  await loadGlobalConfig();
  await loadOpportunities();
  if (user) {
    const docRef = doc(db, 'users', user.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      profile = mergeProfile(defaultProfile, docSnap.data());
      localStorage.setItem(storeKey, JSON.stringify(profile));
    } else {
      await setDoc(docRef, profile);
    }

    // Sync to academy learner state
    const learnerData = {
      full_name: profile.name || user.displayName || 'Learner',
      email: profile.email || user.email,
      phone: profile.phone || '',
      id: user.uid
    };
    localStorage.setItem('taskbridgeAcademyLearner', JSON.stringify(learnerData));
    if (!isNativeAppSession()) {
      localStorage.removeItem('tb_auth_token');
      localStorage.removeItem('tb_user_id');
      localStorage.removeItem('tb_native_app_session');
    }

    // Redirect back after login/auth if intended URL exists
    const redirectUrl = localStorage.getItem('redirectAfterAuth');
    if (redirectUrl) {
      localStorage.removeItem('redirectAfterAuth');
      window.location.href = redirectUrl;
      return;
    }
  } else {
    const tbToken = isNativeAppSession() ? localStorage.getItem('tb_auth_token') : null;
    const tbUserId = localStorage.getItem('tb_user_id');
    if (tbToken) {
      state.route = 'dashboard';
      state.dashTab = 'home';
      profile.active = true;

      try {
        if (tbUserId) {
          const docRef = doc(db, 'users', tbUserId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            profile = mergeProfile(defaultProfile, docSnap.data());
            profile.active = true;
          }
        }
      } catch (e) {
        console.warn('[TB-App] WebView auto-login failed:', e);
      }

      localStorage.setItem(storeKey, JSON.stringify(profile));
    } else {
      // Route Guard for unauthenticated user trying to access protected route on load
      const protectedRoutes = ["dashboard", "app-dashboard", "task", "productPayment"];
      if (protectedRoutes.includes(state.route)) {
        localStorage.setItem('redirectAfterAuth', window.location.origin + window.location.pathname + window.location.hash);
        localStorage.setItem('authMessage', "To access opportunities on TaskBridge, please create an account or sign in first.");
        state.route = "login";
      }
    }
  }
  isFirebaseInitialized = true;
  render();

  // Show auth message toast if set
  const authMsg = localStorage.getItem('authMessage');
  if (authMsg && (state.route === "login" || state.route === "signup")) {
    localStorage.removeItem('authMessage');
    setTimeout(() => {
      showToast(authMsg);
    }, 500);
  }
});

function loadProfile() {
  try {
    return mergeProfile(defaultProfile, JSON.parse(localStorage.getItem(storeKey)) || {});
  } catch {
    return structuredClone(defaultProfile);
  }
}

function mergeProfile(base, saved) {
  const localProfile = (function() { try { return JSON.parse(localStorage.getItem(storeKey)) || {}; } catch(e) { return {}; } })();
  const isActuallyActive = saved.active === true || saved.status === 'active' || localProfile.active === true;
  
  // If we are migrating a local active user to firestore, we should probably save it later, 
  // but for now just setting it in the merged profile ensures they don't get locked out.
  
  return {
    ...structuredClone(base),
    ...saved,
    active: isActuallyActive,
    paymentDetails: { ...base.paymentDetails, ...(saved.paymentDetails || {}) },
    wallet: { ...base.wallet, ...(saved.wallet || {}) },
    ecosystemLinks: saved.ecosystemLinks || structuredClone(base.ecosystemLinks),
    specialTask: { ...base.specialTask, ...(saved.specialTask || {}) },
  };
}

async function saveProfile() {
  localStorage.setItem(storeKey, JSON.stringify(profile));
  if (auth.currentUser) {
    try {
      const docRef = doc(db, 'users', auth.currentUser.uid);
      await setDoc(docRef, profile);
    } catch (e) {
      console.error("Error saving to Firebase:", e);
    }
  }
}

const DIFFICULTY_LEVELS = ["Beginner", "Intermediate", "Advanced", "Expert"];
const DURATION_BUCKETS = ["5–10 min", "10–20 min", "20–40 min", "40–60 min", "1–2 hrs"];
const WORKER_LEVELS = ["Starter", "Junior", "Intermediate", "Senior", "Expert"];
const TASK_COUNTRIES = ["Kenya"];
const ANSWER_TYPES = ["Multiple Choice", "Yes/No", "Text Response", "Rating (1–5)", "Ranking", "File Upload", "Bounding Box", "OCR Correction", "Spreadsheet", "Radio Buttons", "Canvas Drawing"];

function generateTaskContent(categoryName, taskTitle) {
  if (taskTitle.includes("Train RLHF Chatbot")) {
    return {
      contentType: "conversation",
      contentPayload: [
        { role: "user", text: "If a train travels 60mph and leaves at 3pm, what time is it when it travels 120 miles?", timestamp: "10:00 AM" },
        { role: "assistant", text: "At 60 mph, traveling 120 miles takes 2 hours. Therefore, the time would be 5:00 PM.", timestamp: "10:01 AM" }
      ],
      answerTemplate: "custom_dynamic_form",
      answerSchema: {
        fields: [
          { name: "logical_accuracy", label: "Logical Accuracy (1-5)", type: "number", min: 1, max: 5, required: true },
          { name: "tone", label: "Tone Evaluation", type: "select", options: ["Helpful", "Neutral", "Rude"], required: true },
          { name: "justification", label: "Justification", type: "text", required: true }
        ]
      }
    };
  } else if (categoryName === "Data Annotation" || categoryName === "Image Labeling") {
    return {
      contentType: "image",
      contentPayload: "https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=800&q=80",
      answerTemplate: "bounding_box",
      answerSchema: { labels: ["Vehicle", "Pedestrian", "Sign"] }
    };
  } else if (categoryName === "Audio Transcription") {
    return {
      contentType: "audio",
      contentPayload: "https://actions.google.com/sounds/v1/alarms/digital_watch_alarm_long.ogg",
      answerTemplate: "text_response",
      answerSchema: { minLength: 10 }
    };
  } else {
    // Generic fallback for others so they are not hidden
    return {
      contentType: "text",
      contentPayload: "Please review the standard operating procedures provided and extract the key terms.",
      answerTemplate: "text_response",
      answerSchema: {}
    };
  }
}

function taskSeed() {
  const generated = categories.flatMap((category, categoryIndex) => {
    return Array.from({ length: 20 }, (_, index) => {
      const base = category.tasks[index % category.tasks.length];
      const cycle = Math.floor(index / category.tasks.length);
      const fee = 9;
      const hot = index % 3 === 0;
      const id = `${slug(category.name)}-${index + 1}`;
      const diffIdx = (categoryIndex + index) % DIFFICULTY_LEVELS.length;
      const durIdx = (categoryIndex * 3 + index) % DURATION_BUCKETS.length;
      const levelIdx = Math.min(diffIdx, WORKER_LEVELS.length - 1);
      const countryIdx = (categoryIndex + index * 2) % TASK_COUNTRIES.length;
      const answerIdx = (categoryIndex * 2 + index) % ANSWER_TYPES.length;
      const questionCount = 5 + ((categoryIndex * 7 + index * 3) % 46);
      const requiredAccuracy = 70 + ((categoryIndex * 5 + index * 2) % 26);
      const availableSlots = 50 + ((categoryIndex * 23 + index * 11) % 451);
      return {
        id,
        category: category.name,
        title: cycle ? `${base} ${cycle + 1}` : base,
        unlockFee: fee,
        reward: diffIdx === 0 ? 1200 : diffIdx === 1 ? 1800 : diffIdx === 2 ? 2500 : 5000,
        participants: 130 + categoryIndex * 57 + index * 19,
        badge: hot ? "HOT" : index % 5 === 0 ? "DISCOUNT" : "NEW",
        image: thumbnailImages[categoryIndex % thumbnailImages.length],
        icon: category.icon,
        glow: category.glow,
        instruction: category.instruction,
        difficulty: DIFFICULTY_LEVELS[diffIdx],
        estimatedTime: DURATION_BUCKETS[durIdx],
        requiredAccuracy,
        workerLevel: WORKER_LEVELS[levelIdx],
        country: TASK_COUNTRIES[countryIdx],
        availableSlots,
        questionCount,
        answerType: ANSWER_TYPES[answerIdx],
        verificationRequired: true,
        externalLink:
          category.external && index % 3 === 0
            ? "https://developer.safaricom.co.ke/"
            : "",
        custom: false,
        ...generateTaskContent(category.name, cycle ? `${base} ${cycle + 1}` : base)
      };
    });
  });
  
  const hidden = new Set(globalConfig.hiddenTasks || []);
  const customMap = new Map((globalConfig.customTasks || []).map(t => [t.id, t]));
  const result = [];
  
  for (const gen of generated) {
    if (hidden.has(gen.id)) continue;
    if (customMap.has(gen.id)) {
      result.push(customMap.get(gen.id));
      customMap.delete(gen.id);
    } else {
      result.push(gen);
    }
  }
  
  for (const cust of customMap.values()) {
    if (!hidden.has(cust.id)) {
      result.push(cust);
    }
  }
  
  return result;
}

function payoutForTask(categoryIndex, index) {
  const value = 400 + ((categoryIndex * 170 + index * 85) % 1601);
  return Math.min(2000, Math.max(400, Math.round(value / 50) * 50));
}

const defaultProducts = [
  { id: "prod-crypto", title: "CRYPTO MARKET ANALYSIS & SIGNALS", fee: 200, defaultDesc: "Get daily analysis and profitable signals. Only For 18+", defaultImage: "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=400&q=80", url: "#" },
  { id: "prod-forex", title: "FOREX MARKET ANALYSIS & SIGNALS CHANNEL", fee: 200, defaultDesc: "Professional forex signals and setups. Only For 18+", defaultImage: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&q=80", url: "#" },
  { id: "prod-darkweb", title: "ACCESS THE DARK WEB", fee: 300, defaultDesc: "Here you will be Guided with Everything you need to access the other part of the world.\nThe dark web itself isn’t illegal, but some sites and activities are. Use it carefully and only for legal purposes. Do not harm anyone with the information you consume there.\nOnly For 18+", defaultImage: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=400&q=80", url: "#" },
  { id: "prod-dating1", title: "DATING SITE FOR MEN & WOMEN", fee: 150, defaultDesc: "Connect with genuine people looking for relationships. Only For 18+", defaultImage: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=400&q=80", url: "#" },
  { id: "prod-dating2", title: "DATING SITE FOR GAY & LESBIANS", fee: 150, defaultDesc: "A safe space to meet matches in the LGBTQ+ community. Only For 18+", defaultImage: "https://images.unsplash.com/photo-1573331519317-30b24326bb9a?w=400&q=80", url: "#" },
  { id: "prod-chat", title: "CHAT WITH FOREIGNERS FOR PAY", fee: 150, defaultDesc: "Get paid to chat with people around the world. Only For 18+", defaultImage: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=400&q=80", url: "#" }
];

function productsSeed() {
  return defaultProducts.map(prod => {
    const custom = (globalConfig.customProducts || {})[prod.id] || {};
    return {
      ...prod,
      desc: custom.desc || prod.defaultDesc,
      image: custom.image || prod.defaultImage,
      url: custom.url || prod.url,
      unlocked: Boolean((profile.unlockedProducts || {})[prod.id] || isAdmin()),
    };
  });
}

function getProduct(id) {
  return productsSeed().find(p => p.id === id);
}

function specialTaskData() {
  return {
    id: "special-crypto-blockchain-ambassadorship",
    category: specialCategory.name,
    title: specialCategory.title,
    unlockFee: 9,
    reward: 50000,
    payoutLabel: "KES 15,000 to KES 50,000 per month",
    participants: 0,
    badge: "SPECIAL",
    image: thumbnailImages[9],
    icon: specialCategory.icon,
    glow: specialCategory.glow,
    instruction: globalConfig.specialTask?.description || specialCategory.instruction,
    externalLink: globalConfig.specialTask?.applicationLink || specialCategory.externalLink,
    custom: false,
    special: true,
  };
}

function getTask(id) {
  if (id === specialTaskData().id) return specialTaskData();
  return taskSeed().find((task) => task.id === id) || taskSeed()[0];
}

function icon(name) {
  const fallback = {
    "arrow-left": "<",
    "arrow-right": ">",
    "badge-check": "OK",
    "banknote": "$",
    "briefcase-business": "B",
    "blocks": "#",
    "check": "OK",
    "clock": "T",
    "clock-3": "T",
    "coins": "$",
    "copy": "CP",
    "globe-2": "WEB",
    "help-circle": "?",
    "external-link": "EX",
    "film": "F",
    "gift": "+",
    "home": "H",
    "languages": "A",
    "layout-dashboard": "[]",
    "lock-keyhole": "L",
    "lock-keyhole-open": "U",
    "megaphone": "M",
    "message-circle": "MSG",
    "mic-2": "VO",
    "monitor-smartphone": "UI",
    "music": "M",
    "palette": "P",
    "paperclip": "CL",
    "pen-tool": "W",
    "pencil": "E",
    "play-circle": ">",
    "radio-tower": "STK",
    "receipt": "R",
    "rocket": "^",
    "save": "S",
    "search": "?",
    "send": ">",
    "shield": "S",
    "shield-check": "OK",
    "smartphone": "MP",
    "sparkles": "*",
    "store": "S",
    "tag": "#",
    "trash-2": "X",
    "trending-up": "+",
    "unlock": "U",
    "user": "U",
    "user-plus": "+",
    "users": "2",
    "wallet": "W",
    "x": "X",
    "zap": "Z",
    "sun": "*",
    "moon": "*",
  }[name] || "*";
  return `<span class="icon-wrap" aria-hidden="true"><i data-lucide="${name}"></i><span class="icon-fallback">${fallback}</span></span>`;
}

function refreshIcons() {
  if (window.lucide) {
    window.lucide.createIcons();
    document.body.classList.add("icons-ready");
  }
}

function money(value) {
  return `KES ${Number(value || 0).toLocaleString("en-KE")}`;
}

function payoutText(task) {
  return task.payoutLabel || money(task.reward);
}

function isAdmin() {
  const email = String(profile.email || auth.currentUser?.email || "").trim().toLowerCase();
  return Boolean(profile.isAdmin || ADMIN_EMAILS.includes(email));
}

function displayName() {
  return profile.username || profile.name || profile.email || "TaskBridge member";
}

function welcomeUser() {
  state.dashTab = "home";
}

function loadReferralRegistry() {
  try {
    return JSON.parse(localStorage.getItem(referralStoreKey)) || { codes: {} };
  } catch {
    return { codes: {} };
  }
}

function saveReferralRegistry(registry) {
  localStorage.setItem(referralStoreKey, JSON.stringify(registry));
}

function getReferralCode() {
  if (!profile.referralCode) {
    const seed = profile.username || profile.phone || profile.email || `TB${Date.now()}`;
    profile.referralCode = slug(seed).replaceAll("-", "").toUpperCase().slice(0, 14) || `TB${Date.now()}`;
  }
  registerReferralOwner();
  return profile.referralCode;
}

function referralLink() {
  const url = new URL(window.location.href);
  url.search = "";
  url.hash = "";
  url.searchParams.set("ref", getReferralCode());
  return url.toString();
}

function registerReferralOwner() {
  if (!profile.referralCode) return;
  const registry = loadReferralRegistry();
  registry.codes[profile.referralCode] = {
    ownerName: displayName(),
    ownerEmail: profile.email || "",
    signups: registry.codes[profile.referralCode]?.signups || [],
  };
  saveReferralRegistry(registry);
}

function pendingReferralCode() {
  return new URLSearchParams(window.location.search).get("ref") || "";
}

async function resolveReferralCode() {
  const code = pendingReferralCode();
  if (code && state.resolvedReferralCode !== code) {
    state.resolvedReferralCode = code;
    try {
      const q = query(collection(db, "users"), where("referralCode", "==", code));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const inviterDoc = querySnapshot.docs[0].data();
        state.inviterInfo = {
          uid: querySnapshot.docs[0].id,
          username: inviterDoc.username,
          name: inviterDoc.name || inviterDoc.username,
        };
        render();
      }
    } catch (err) {
      console.warn("Could not query inviter details from Firestore:", err);
    }
  }
}

function pendingReferralOwner() {
  const code = pendingReferralCode();
  if (!code) return null;
  return state.inviterInfo || { ownerName: code };
}

function recordReferralSignup() {
  const code = pendingReferralCode();
  if (!code || code === getReferralCode()) return;
  const registry = loadReferralRegistry();
  const entry = registry.codes[code] || { ownerName: code, ownerEmail: "", signups: [] };
  const invitedEmail = profile.email || "";
  const invitedName = displayName();
  const alreadyRecorded = entry.signups.some((item) => item.email && invitedEmail && item.email === invitedEmail);
  if (!alreadyRecorded) {
    entry.signups.push({
      name: invitedName,
      email: invitedEmail,
      codeUsed: code,
      amount: REFERRAL_PAYOUT,
      at: new Date().toISOString(),
    });
  }
  registry.codes[code] = entry;
  saveReferralRegistry(registry);
  profile.referredBy = code;
}

function referralSignupKey(item) {
  return item.email || `${item.name}-${item.at}`;
}

function syncReferralEarnings() {
  const code = getReferralCode();
  const entry = loadReferralRegistry().codes[code];
  const signups = entry?.signups || [];
  const paidOut = new Set(profile.referralPaidOut || []);
  profile.referredUsers = signups;
  profile.successfulReferrals = signups.length;
  profile.wallet.referralEarnings = signups
    .filter((item) => !paidOut.has(referralSignupKey(item)))
    .reduce((total, item) => total + Number(item.amount || REFERRAL_PAYOUT), 0);
}

async function syncReferralsFromFirestore() {
  if (!auth.currentUser) return;
  const myCode = getReferralCode();
  try {
    const q = query(collection(db, "users"), where("referredBy", "==", myCode));
    const querySnapshot = await getDocs(q);
    const signups = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      signups.push({
        name: data.name || data.username || "Referred User",
        email: data.email || "",
        username: data.username || "",
        at: data.joinedAt || new Date().toISOString(),
        amount: REFERRAL_PAYOUT,
      });
    });
    profile.referredUsers = signups;
    profile.successfulReferrals = signups.length;
    
    const paidOut = new Set(profile.referralPaidOut || []);
    profile.wallet.referralEarnings = signups
      .filter((item) => !paidOut.has(referralSignupKey(item)))
      .reduce((total, item) => total + Number(item.amount || REFERRAL_PAYOUT), 0);
  } catch (err) {
    console.error("Error syncing referrals from Firestore:", err);
  }
}

/**
 * If the user clicked "Taskbridge Institute" before logging in,
 * state.pendingRedirect will be 'academy'. After auth succeeds,
 * call this to open the academy and clear the intent.
 * Returns true if a redirect was performed (caller should return early).
 */
function consumePendingAcademyRedirect() {
  if (state.pendingRedirect !== 'academy') return false;
  state.pendingRedirect = null;
  // Sync learner details so the academy page recognises them
  localStorage.setItem('taskbridgeAcademyLearner', JSON.stringify({
    full_name: profile.name || '',
    email: profile.email || '',
    phone: profile.phone || '',
    id: profile.uid || auth.currentUser?.uid || 'local-user'
  }));
  window.location.href = '/academy/';
  // Still land the user on the dashboard in the background
  setRoute('dashboard');
  return true;
}

function setRoute(route, options = {}) {
  const protectedRoutes = ["dashboard", "app-dashboard", "task", "productPayment"];
  if (protectedRoutes.includes(route) && !auth.currentUser && !isNativeAppSession()) {
    localStorage.setItem('redirectAfterAuth', window.location.origin + window.location.pathname + "#" + route);
    localStorage.setItem('authMessage', "To access opportunities on TaskBridge, please create an account or sign in first.");
    state.route = "login";
    render();
    setTimeout(() => {
      showToast("To access opportunities on TaskBridge, please create an account or sign in first.");
    }, 100);
    return;
  }

  state.route = route;
  state.menuOpen = false;
  if (options.taskId) state.selectedTaskId = options.taskId;
  
  if (route === "dashboard") {
    document.body.classList.add("is-dashboard");
  } else {
    document.body.classList.remove("is-dashboard");
  }

  if (state.theme === "dark") {
    document.body.classList.add("is-dark");
    document.body.classList.remove("is-light");
  } else {
    document.body.classList.add("is-light");
    document.body.classList.remove("is-dark");
  }
  
  window.scrollTo({ top: 0, behavior: "smooth" });
  render();
}

function slug(value) {
  return String(value)
    .toLowerCase()
    .replaceAll("&", "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function escapeAttr(value) {
  return escapeHtml(value);
}

function landingView() {
  const heroTitle = "Find Work. Build Skills. Get Paid.";
  const heroSub = "Discover flexible freelance opportunities and lucrative affiliate jobs across Africa. Start earning and growing today.";

  const opportunities = [
    { title: "Government Jobs", image: "/government-jobs.png" },
    { title: "NGO Vacancies", image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=400&q=80" },
    { title: "Private Sector Roles", image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&q=80" },
    { title: "International Careers", image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&q=80" },
    { title: "Internships & Attachments", image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&q=80" },
    { title: "Scholarships", image: "/scholarships.png" },
    { title: "Side Hustles", image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=400&q=80" }
  ];

  const reviews = [
    { name: "Kevin Odhiambo", location: "Nairobi, Kenya", text: "I completed the Web Development course at Taskbridge Institute and got a web design internship within two weeks. Outstanding program!" },
    { name: "Mwangi Kamau", location: "Nairobi, Kenya", text: "TaskBridge has completely changed how I find freelance design gigs. I get paid via M-Pesa instantly! Highly recommended." },
    { name: "Brian Onyango", location: "Kisumu, Kenya", text: "Finding side hustles to support my studies used to be tough. Taskbridge makes it easy to find verified micro-tasks that pay instantly." },
    { name: "Achieng Onyango", location: "Kisumu, Kenya", text: "I started as an affiliate marketer on TaskBridge three months ago. The onboarding was seamless, and the support team is super responsive." },
    { name: "Dennis Ochieng", location: "Mombasa, Kenya", text: "Through Taskbridge, I landed a private sector role as a data entry specialist. The secure escrow payment gave me complete peace of mind." },
    { name: "Njuguna Ndung'u", location: "Thika, Kenya", text: "The contract jobs here are highly rewarding. I love how secure the payments are. Best freelance platform in Kenya." },
    { name: "Victor Njoroge", location: "Nakuru, Kenya", text: "Taskbridge Institute's digital marketing course was a game changer. I'm now running ads for international clients and earning in USD." },
    { name: "Fatuma Hassan", location: "Mombasa, Kenya", text: "I've been writing articles on TaskBridge and earning daily. The platform is simple to use and has great job options." },
    { name: "Cynthia Wanjiku", location: "Nyeri, Kenya", text: "I applied for a government attachment through the platform and got accepted! It's the best resource for students looking for real work experience." },
    { name: "Fredrick Mititi", location: "Narok, Kenya", text: "TaskBridge is very transparent. I have been doing contract jobs here and getting my payments via M-Pesa immediately." },
    { name: "Sharon Akinyi", location: "Eldoret, Kenya", text: "NGO vacancies are finally accessible. I applied for a communications role on Taskbridge and started last month. Highly recommended!" },
    { name: "Brian Mutua", location: "Machakos, Kenya", text: "Excellent affiliate program. The marketing banners and links are easy to share, and my commissions arrive on time." },
    { name: "Mercy Atieno", location: "Kisumu, Kenya", text: "I love the flexibility of the side hustles here. I do translation tasks in my free time and get paid straight to my M-Pesa." },
    { name: "Hezron Kiprotich", location: "Bomet, Kenya", text: "Finding micro-tasks that match my schedule has never been easier. Truly a lifesaver for student freelancers." },
    { name: "Diana Chebet", location: "Kericho, Kenya", text: "Securing an internship at a top firm seemed impossible until I joined Taskbridge. They bridged the gap between my skills and the market." },
    { name: "Wafula Rosemary", location: "Kakamega, Kenya", text: "Highly professional platform. The client support helped me resolve a withdrawal issue within minutes. Love it!" },
    { name: "Kelvin Kiprotich", location: "Eldoret, Kenya", text: "The training at Taskbridge Institute is practical and relevant. It helped me build my portfolio and qualify for high-paying remote roles." },
    { name: "Wangare Elizabeth", location: "Kisii, Kenya", text: "I recommend TaskBridge to anyone looking to monetize their digital skills. The tutorials are a huge help too." },
    { name: "Emmanuel Musyoka", location: "Kitui, Kenya", text: "From local attachments to international remote gigs, Taskbridge has it all. I've been earning consistently since I completed my certification." },
    { name: "Lang'at Kiptoo Festus", location: "Homabay, Kenya", text: "I earn by writing articles and translating texts. The payout system is fast, secure, and very convenient." },
    { name: "Luka Ekadong", location: "Samburu, Kenya", text: "The remote opportunities here allow me to work from anywhere. Very user-friendly dashboard." },
    { name: "James Mutua", location: "Laikipia, Kenya", text: "Great source of online jobs. I started part-time but now doing full-time tasks on TaskBridge." },
    { name: "Cheptoo Faith Rotich", location: "Keiyo, Kenya", text: "I enjoy completing research surveys and verification tasks. The rewards are credited instantly to my wallet." },
    { name: "Abdul Samatar", location: "Wajir, Kenya", text: "A reliable and trustworthy marketplace. I've recommended it to all my friends who want to earn online." }
  ];

  return `
    <section class="new-hero-section">
      <!-- Background Elements -->
      <div class="kenyan-flag-bg">
        <div class="kenyan-flag-overlay"></div>
      </div>

      <div class="hero-container hero-centered">
        <!-- Center Column -->
        <div class="hero-copy-col">
          <div class="hero-kicker">LEADING AFRICAN FREELANCE MARKETPLACE</div>
          <h1 class="new-hero-h1">${heroTitle}</h1>
          <p class="new-hero-sub">${heroSub}</p>
          <div class="new-hero-actions">
            <button class="btn btn-primary btn-signup" data-action="signup">Sign Up</button>
            <button class="btn btn-secondary btn-signin" data-action="login">Sign In</button>
          </div>
          
          <!-- Sub-hero Links Bar -->
          <div class="sub-hero-links">
            <a href="#terms" class="sub-hero-link">Terms of Service</a>
            <a href="/taskbridge.apk" class="sub-hero-link btn-install" download>
              ${icon('smartphone')} Install App
            </a>
            <a href="#privacy" class="sub-hero-link">Data Protection Policy</a>
            <a href="https://wa.me/254719105828" target="_blank" class="sub-hero-link">Help Desk</a>
          </div>
        </div>
      </div>
    </section>

    <!-- Categories Grid / Pills -->
    <div class="category-pill-container">
      <div class="category-pill" data-action="signup">${icon('monitor-smartphone')} Programming & Tech</div>
      <div class="category-pill" data-action="signup">${icon('palette')} Graphics & Design</div>
      <div class="category-pill" data-action="signup">${icon('smartphone')} Digital Marketing</div>
      <div class="category-pill" data-action="signup">${icon('languages')} Writing & Translation</div>
      <div class="category-pill" data-action="signup">${icon('film')} Video & Animation</div>
      <div class="category-pill" data-action="signup">${icon('sparkles')} AI Services</div>
      <div class="category-pill" data-action="signup">${icon('music')} Music & Audio</div>
      <div class="category-pill" data-action="signup">${icon('briefcase-business')} Business</div>
      <div class="category-pill" data-action="signup">${icon('badge-check')} Consulting</div>
    </div>

    <!-- Unlock Career & Income Opportunities Section -->
    <section class="opportunities-section">
      <div class="opportunities-header">
        <h2>Unlock Career & Income Opportunities</h2>
        <p>Explore verified Government Jobs, NGO Vacancies, Private Sector Roles, International Careers, Internships, Attachments, Scholarships, and Side Hustles—all in one place.</p>
      </div>
      <div class="opportunities-grid">
        ${opportunities.map(opp => `
          <div class="opportunity-card">
            <div class="opportunity-card-title">${opp.title}</div>
            <div class="opportunity-card-image-wrap">
              <img src="${opp.image}" alt="${opp.title}" loading="lazy">
            </div>
          </div>
        `).join('')}
      </div>
    </section>

    <!-- Make it all happen on Taskbridge -->
    <section class="happen-section">
      <div class="happen-header">
        <h2>Make it all happen on Taskbridge</h2>
        <button class="btn btn-join" data-action="signup">Join now</button>
      </div>
      <div class="happen-grid">
        <div class="happen-col">
          <div class="happen-icon">${icon('briefcase-business')}</div>
          <div class="happen-text">Access verified career opportunities and academic advancements across multiple sectors.</div>
        </div>
        <div class="happen-col">
          <div class="happen-icon">${icon('users')}</div>
          <div class="happen-text">Enjoy a simple, easy-to-use matching and application experience.</div>
        </div>
        <div class="happen-col">
          <div class="happen-icon">${icon('zap')}</div>
          <div class="happen-text">Get connections to employers quickly and start building your career path.</div>
        </div>
        <div class="happen-col">
          <div class="happen-icon">${icon('wallet')}</div>
          <div class="happen-text">Unlock flexible side hustles and secure digital gigs directly paid via M-Pesa.</div>
        </div>
      </div>
    </section>

    <!-- Live Freelancer Showcase Section -->
    <section class="live-banner-section">
      <div class="live-banner-container">
        <div class="live-banner-content">
          <h2>Empowering Africa's Ambition</h2>
          <p>Taskbridge connects ambitious African digital talents with global employers and local opportunities. Whether you are working from a comfortable sofa or your dedicated desk, we make it happen.</p>
          <button class="btn btn-primary btn-signup" data-action="signup" style="border-radius: 30px; padding: 12px 28px;">Get Started</button>
        </div>
        <div class="live-slider-container">
          <div class="live-slide active" data-slide="0">
            <img src="/freelancer-girl.jpg" alt="Freelancer Girl on Sofa">
            <div class="live-slide-caption">
              <h4>Amina Wanjiku</h4>
              <span>Content Creator & Research Intern</span>
            </div>
          </div>
          <div class="live-slide" data-slide="1">
            <img src="/freelancer-boy.png" alt="Freelancer Boy with Headphones">
            <div class="live-slide-caption">
              <h4>David Odhiambo</h4>
              <span>AI Tutor & Tech Enthusiast</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Reviews Section -->
    <section class="new-reviews-section">
      <h2 class="new-reviews-title">What Our Users Say on Trustpilot</h2>
      <p class="new-reviews-subtitle">Real experiences from our active digital talent across Kenya.</p>
      
      <div class="reviews-carousel">
        ${reviews.map(rev => `
          <div class="review-card">
            <div>
              <div class="review-rating">
                ${icon('star')}${icon('star')}${icon('star')}${icon('star')}${icon('star')}
              </div>
              <p class="review-text">"${rev.text}"</p>
            </div>
            <div class="review-user">
              <img class="review-avatar" src="https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(rev.name)}" alt="${rev.name}">
              <div class="review-info">
                <h4>${rev.name}</h4>
                <span>${rev.location}</span>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    </section>
  `;
}

function loginView() {
  const forAcademy = state.pendingRedirect === 'academy';
  return `
    <section class="auth-page">
      <div class="kenyan-flag-bg">
        <div class="kenyan-flag-overlay"></div>
      </div>
      <div class="auth-shell">
        <div class="auth-copy">
          <p class="section-kicker">${forAcademy ? 'One step to Taskbridge Institute' : 'Access Your Taskbridge Portal'}</p>
          <h1>${forAcademy ? 'Log in to continue.' : 'Log in.'}</h1>
          <p class="auth-subtext">${forAcademy ? 'Log in or create an account to access Taskbridge Institute — your gateway to certified digital skills.' : 'Log in to view active contracts, manage course enrollments, and access secure payments.'}</p>
          <ul class="auth-bullet-list">
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>View project dashboards</span>
            </li>
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Access course materials</span>
            </li>
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Check payment status</span>
            </li>
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Manage account settings</span>
            </li>
          </ul>
        </div>
        <form class="glass-form" data-form="login">
          <button class="btn btn-ghost btn-wide btn-google" type="button" data-action="googleAuth">
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg" style="margin-right:8px; vertical-align:middle;">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" fill="#EA4335"/>
            </svg>
            Continue with Google
          </button>
          <div class="auth-divider"><span>or</span></div>
          
          <div class="field-grid">
            <div class="field">
              <label for="loginEmail">Email Address / Primary Identifier</label>
              <input class="input" id="loginEmail" name="email" type="email" autocomplete="email" required placeholder="name@email.com" />
            </div>
            <div class="field">
              <label for="loginUsername">Username</label>
              <input class="input" id="loginUsername" name="username" type="text" placeholder="username" />
            </div>
          </div>
          
          <div class="field">
            <label for="loginPhone">Phone Number</label>
            <input class="input" id="loginPhone" name="phone" type="tel" placeholder="e.g. 0712345678" />
          </div>
          
          <div class="field">
            <label for="loginPortalCode">Personal Portal Code</label>
            <input class="input" id="loginPortalCode" name="portal_code" type="text" placeholder="Enter portal code" />
          </div>
          
          <div class="field">
            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom: 6px;">
              <label for="loginPassword" style="margin-bottom:0;">Password</label>
              <button class="text-btn" type="button" data-action="forgotPassword" style="font-size: 13px; color: #60a5fa; opacity: 0.85; padding:0; border:none; cursor:pointer;">Forgot Password?</button>
            </div>
            <div class="password-input-wrapper" style="position:relative;">
              <input class="input" id="loginPassword" name="password" type="password" required placeholder="••••••••" style="padding-right:45px !important;" />
              <button type="button" class="btn-toggle-password" data-action="togglePassword" style="position:absolute; right:12px; top:50%; transform:translateY(-50%); background:none; border:none; color:#94a3b8; cursor:pointer; padding:4px; display:flex; align-items:center; justify-content:center;">
                ${icon('eye')}
              </button>
            </div>
          </div>
          
          <div class="field-checkbox" style="display:flex; align-items:center; gap:8px; margin-bottom:20px;">
            <input type="checkbox" id="rememberMe" name="remember" style="width:16px; height:16px; accent-color:#2563eb;" />
            <label for="rememberMe" style="color:#e2e8f0; font-size:0.9rem; cursor:pointer;">Remember me</label>
          </div>
          
          <button class="btn btn-primary btn-glow btn-wide" type="submit" style="background:#2563eb; color:white; border:none; border-radius:12px; font-weight:700;">
            ${icon("arrow-right")} Log In
          </button>
          
          <div class="auth-redirect" style="text-align:center; margin-top:20px; font-size:0.9rem; color:#94a3b8;">
            Need an account? <button class="text-btn" type="button" data-action="signup" style="color:#60a5fa; border:none; background:none; padding:0; cursor:pointer; font-weight:700;">Sign Up</button>
          </div>
        </form>
      </div>
    </section>
    </section>
  `;
}

function resetPasswordView() {
  const tokenMatch = window.location.hash.match(/token=([^&]+)/);
  const token = tokenMatch ? tokenMatch[1] : '';
  if (!token) {
    return `<div style="padding: 100px; text-align: center; color: white;"><h2>Invalid or missing reset token.</h2><br><a href="/#login" style="color: #14b8a6;">Go to Login</a></div>`;
  }
  return `
    <section class="auth-page">
      <div class="kenyan-flag-bg"><div class="kenyan-flag-overlay"></div></div>
      <div class="auth-shell">
        <div class="auth-copy">
          <p class="section-kicker">Secure Your Account</p>
          <h1>Create New Password.</h1>
          <p class="auth-subtext">Enter a new strong password below to regain access to your TaskBridge account.</p>
        </div>
        <form class="glass-form" data-form="resetPassword">
          <input type="hidden" name="token" value="${escapeAttr(token)}" />
          <div class="field">
            <label>New Password</label>
            <input class="input" name="newPassword" type="password" required placeholder="••••••••" minlength="6" />
          </div>
          <div class="field">
            <label>Confirm Password</label>
            <input class="input" name="confirmPassword" type="password" required placeholder="••••••••" minlength="6" />
          </div>
          <button class="btn btn-primary btn-glow btn-wide" type="submit" style="background:#14b8a6; color:#0a1628; border:none; border-radius:12px; font-weight:700;">Update Password</button>
        </form>
      </div>
    </section>
  `;
}

function signupView() {
  const inviter = pendingReferralOwner();
  const forAcademy = state.pendingRedirect === 'academy';
  return `
    <section class="auth-page">
      <div class="kenyan-flag-bg">
        <div class="kenyan-flag-overlay"></div>
      </div>
      <div class="auth-shell">
        <div class="auth-copy">
          <p class="section-kicker">${forAcademy ? 'One step to Taskbridge Institute' : 'Get Started'}</p>
          <h1>${forAcademy ? 'Create your account.' : 'Create your account.'}</h1>
          <p class="auth-subtext">${forAcademy ? 'Create a free account to access Taskbridge Institute — certified digital skills courses for Africa\'s workforce.' : 'Join a community of professionals and accelerate your career.'}</p>
          ${inviter ? `<div class="info-box">${icon("users")} <p>You were invited by <strong>${escapeHtml(inviter.ownerName)}</strong>.</p></div>` : ""}
          
          <ul class="auth-bullet-list">
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Find global project roles</span>
            </li>
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Connect with verified talent</span>
            </li>
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Access specialized training</span>
            </li>
            <li class="auth-bullet-item">
              <span class="auth-bullet-icon">${icon('check')}</span>
              <span>Secure platform & tools</span>
            </li>
          </ul>
        </div>
        <form class="glass-form" data-form="signup">
          <button class="btn btn-ghost btn-wide btn-google" type="button" data-action="googleAuth">
            <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg" style="margin-right:8px; vertical-align:middle;">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" fill="#EA4335"/>
            </svg>
            Sign up with Google
          </button>
          <div class="auth-divider"><span>or</span></div>
          
          <div class="field-grid">
            <div class="field">
              <label for="name">Full Name</label>
              <input class="input" id="name" name="name" autocomplete="name" required value="${escapeAttr(profile.name)}" placeholder="Full Name" />
            </div>
            <div class="field">
              <label for="username">Username</label>
              <input class="input" id="username" name="username" required value="${escapeAttr(profile.username || '')}" placeholder="Unique username" />
            </div>
          </div>
          
          <div class="field">
            <label for="email">Email</label>
            <input class="input" id="email" name="email" type="email" autocomplete="email" required value="${escapeAttr(profile.email)}" placeholder="name@email.com" />
          </div>
          
          <div class="field">
            <label for="phone">Phone Number</label>
            <input class="input" id="phone" name="phone" autocomplete="tel" inputmode="tel" required placeholder="e.g. 0712345678" value="${escapeAttr(profile.phone)}" />
          </div>
          
          <div class="field">
            <label for="password">Password</label>
            <div class="password-input-wrapper" style="position:relative;">
              <input class="input" id="password" name="password" type="password" required placeholder="Create a password" style="padding-right:45px !important;" />
              <button type="button" class="btn-toggle-password" data-action="togglePassword" style="position:absolute; right:12px; top:50%; transform:translateY(-50%); background:none; border:none; color:#94a3b8; cursor:pointer; padding:4px; display:flex; align-items:center; justify-content:center;">
                ${icon('eye')}
              </button>
            </div>
          </div>
          
          <div class="field-checkbox" style="display:flex; align-items:flex-start; gap:8px; margin-bottom:20px;">
            <input type="checkbox" id="termsCheckbox" name="terms" required style="width:16px; height:16px; margin-top:2px; accent-color:#2563eb;" />
            <label for="termsCheckbox" style="color:#e2e8f0; font-size:0.85rem; cursor:pointer; line-height:1.4;">
              I agree to the <a href="#terms" target="_blank" style="color:#60a5fa; text-decoration:underline;">Terms of Service</a> and <a href="#privacy" target="_blank" style="color:#60a5fa; text-decoration:underline;">Data Protection Policy</a>.
            </label>
          </div>
          
          <button class="btn btn-primary btn-glow btn-wide" type="submit" style="background:#2563eb; color:white; border:none; border-radius:12px; font-weight:700;">
            ${icon("arrow-right")} Activate account
          </button>
          
          <div class="auth-redirect" style="text-align:center; margin-top:20px; font-size:0.9rem; color:#94a3b8;">
            Already have an account? <button class="text-btn" type="button" data-action="login" style="color:#60a5fa; border:none; background:none; padding:0; cursor:pointer; font-weight:700;">Log In</button>
          </div>
        </form>
      </div>
    </section>
  `;
}

function accessView() {
  return `
    <section class="auth-page">
      <div class="kenyan-flag-bg">
        <div class="kenyan-flag-overlay"></div>
      </div>
      <div class="payment-stage">
        <div class="payment-visual">
          <span class="payment-icon">${icon("smartphone")}</span>
          <p class="section-kicker">Lifetime access fee</p>
          <h1 class="access-fee-text">KES 100</h1>
          <p>This Payment is done to activate your affiliate account.</p>
        </div>
        <form class="glass-form" data-form="accessPayment">
          <div class="field">
            <label for="payPhone">M-Pesa Number</label>
            <input class="input" id="payPhone" name="payPhone" inputmode="tel" required value="${escapeAttr(profile.phone)}" placeholder="Enter your M-Pesa number" />
          </div>
          <p class="muted" style="text-align: center; margin: 0.5rem 0 1rem;">Ksh 100 will be deducted from your M-Pesa. Click "PAY NOW" to continue.</p>
          <button class="btn btn-primary btn-glow btn-wide" type="submit">${icon("send")} PAY NOW</button>
          <button class="btn btn-ghost btn-wide" type="button" data-action="signup">${icon("arrow-left")} Back to Signup</button>
        </form>
      </div>
    </section>
  `;
}

function mobileAppDashboardView() {
  const name = displayName();
  const firstName = name.split(' ')[0] || "Mathew";
  const greeting = getKenyanGreeting();
  
  // Stats
  const activeTalents = "14,200+";
  const jobsConnected = "20,000+";
  
  // Category Dynamic Counts from Firestore (allOpportunities)
  const getCatCount = (catId, defaultCount) => {
    const count = allOpportunities.filter(o => o.category === catId).length;
    return count > 0 ? count : defaultCount;
  };
  
  const counts = {
    'government': getCatCount('government', 12),
    'private': getCatCount('private', 24),
    'ngo': getCatCount('ngo', 8),
    'international': getCatCount('international', 15),
    'internship': getCatCount('internship', 30),
    'attachment': getCatCount('attachment', 18),
    'scholarship': getCatCount('scholarship', 6),
    'remote': getCatCount('remote', 45) // Side Hustle Gigs
  };

  // Bottom Navigation Active Tabs
  const currentTab = state.dashTab || 'home';
  
  // Hamburger menu state
  const isMenuOpen = state.mobileMenuOpen || false;
  
  // Selected category in detail panel
  const selectedCatName = state.mobileSelectedCategory || null;
  const detailActive = selectedCatName ? 'active' : '';
  
  // Detail panel job list & count
  let detailJobsHtml = '';
  let detailJobsCount = 0;
  let detailIconHtml = '';
  let detailCatColor = '';
  
  if (selectedCatName) {
    // Map selectedCatName to database category ID
    const catMap = {
      'Government Jobs': { id: 'government', icon: 'ti-building', color: 'rgba(80, 110, 145, 0.55)', iconcol: '#c0d4e8' },
      'Private Sector': { id: 'private', icon: 'ti-building-skyscraper', color: 'rgba(140, 100, 65, 0.55)', iconcol: '#e0c4a0' },
      'NGOs': { id: 'ngo', icon: 'ti-heart-handshake', color: 'rgba(60, 150, 110, 0.50)', iconcol: '#a0e8d0' },
      'International Jobs': { id: 'international', icon: 'ti-world', color: 'rgba(120, 80, 180, 0.50)', iconcol: '#d0b8f0' },
      'Internships': { id: 'internship', icon: 'ti-school', color: 'rgba(150, 100, 75, 0.55)', iconcol: '#e0c0a8' },
      'Attachments': { id: 'attachment', icon: 'ti-clipboard-list', color: 'rgba(140, 130, 100, 0.50)', iconcol: '#e0d8c0' },
      'Scholarships': { id: 'scholarship', icon: 'ti-certificate', color: 'rgba(60, 140, 120, 0.50)', iconcol: '#a0e0c8' },
      'Side Hustle': { id: 'remote', icon: 'ti-coin', color: 'rgba(150, 125, 80, 0.55)', iconcol: '#e0d0a8' }
    };
    
    const catInfo = catMap[selectedCatName] || { id: 'all', icon: 'ti-briefcase', color: '#e3f2fd', iconcol: '#1565c0' };
    detailIconHtml = `<i class="ti ${catInfo.icon}" style="color:${catInfo.iconcol};" aria-hidden="true"></i>`;
    detailCatColor = catInfo.color;
    
    // Filter opportunities
    let jobs = allOpportunities.filter(o => catInfo.id === 'all' || o.category === catInfo.id);
    
    // Apply filter chip
    const activeChip = state.mobileDetailFilter || 'All';
    if (activeChip !== 'All') {
      const chipLower = activeChip.toLowerCase();
      jobs = jobs.filter(o => {
        const typeMatch = o.type && o.type.toLowerCase().includes(chipLower);
        const tagMatch = o.tags && o.tags.some(t => t.toLowerCase().includes(chipLower));
        const levelMatch = o.experienceLevel && o.experienceLevel.toLowerCase().includes(chipLower);
        return typeMatch || tagMatch || levelMatch;
      });
    }
    
    detailJobsCount = jobs.length;
    
    detailJobsHtml = jobs.map(j => {
      // Defensive: ensure tags is an array, salary is a string
      const tags = Array.isArray(j.tags) ? j.tags : [];
      const salary = j.salary || '';
      // Find matching tag classes
      const tagsMarkup = tags.map((t, idx) => {
        const colors = ['tag-blue', 'tag-green', 'tag-orange'];
        const tagClass = colors[idx % colors.length];
        return `<span class="tag ${tagClass}">${escapeHtml(t)}</span>`;
      }).join('');
      
      return `
        <div class="job-card" data-action="viewMobileJob" data-jobid="${j.id}">
          <div class="job-card-top">
            <div class="company-logo" style="background:${catInfo.color};"><i class="ti ${catInfo.icon}" style="color:${catInfo.iconcol};" aria-hidden="true"></i></div>
            <div style="flex:1;">
              <div class="job-card-title">${escapeHtml(j.title)}</div>
              <div class="job-card-company">Verified Employer</div>
            </div>
            <div style="font-size:12px;font-weight:600;color:#1976d2;white-space:nowrap;">${escapeHtml(salary)}</div>
          </div>
          <div class="job-card-tags">
            ${tagsMarkup}
            <span class="tag tag-orange" style="margin-left:auto; font-weight:600;">View &amp; Apply</span>
          </div>
        </div>
      `;
    }).join('');
    
    if (jobs.length === 0) {
      detailJobsHtml = `<div style="text-align:center; padding: 40px 20px; color: #777;">No listings available for this filter.</div>`;
    }
  }

  // Define tab navigation active classes
  const tabActive = (tabName) => currentTab === tabName ? 'active' : '';

  // Render correct panel inside home screen
  let tabContentHtml = '';
  if (currentTab === 'home') {
    tabContentHtml = `
      <div class="welcome-card">
        <div class="welcome-heading" style="margin:0 0 4px; font-size:21px; font-weight:700; color:#fff; line-height:1.2; text-align:left;">Welcome to TaskBridge, ${firstName}!</div>
        <div class="welcome-sub" style="margin:0 0 16px; font-size:11px; color:rgba(255,255,255,0.6); line-height:1.5; text-align:left;">Connect. Empower. Grow. The direct pathway to African opportunity.</div>
        
        <!-- Horizontal Scrollable Tasks Carousel -->
        <div class="moving-cards-container">
          <!-- Card 1: New Job -->
          <div class="moving-card new-job-card" data-action="setMobileTab" data-tab="market">
            <div style="display:flex; justify-content:space-between; align-items:flex-start; width:100%;">
              <div class="moving-card-icon-wrap" style="width:40px; height:40px; border-radius:10px; background:rgba(20,184,166,0.1); display:flex; align-items:center; justify-content:center; color:#14b8a6;">
                <i class="ti ti-briefcase" style="font-size:20px;"></i>
              </div>
            </div>
            <h3 class="moving-card-title" style="margin:12px 0 4px; font-size:16px; font-weight:700; color:#fff;">New Job</h3>
            <p class="moving-card-desc" style="margin:0; font-size:11px; color:rgba(255,255,255,0.6); line-height:1.4;">Find free and local talent gigs and project opportunities...</p>
            <button class="moving-card-btn" style="margin-top:auto; align-self:flex-start; background:rgba(255,255,255,0.1); border:none; color:#fff; border-radius:20px; padding:4px 12px; font-size:11px; font-weight:600; cursor:pointer;">Profile</button>
          </div>

          <!-- Card 2: Featured Opportunity (Project Connect - AI and Data Science) -->
          <div class="moving-card featured-card" data-action="setMobileTab" data-tab="market">
            <div class="moving-card-badge" style="font-size:9px; font-weight:700; color:#14b8a6; letter-spacing:0.5px; text-transform:uppercase;">FEATURED OPPORTUNITY:</div>
            <h3 class="moving-card-title-main" style="margin:4px 0 2px; font-size:15px; font-weight:700; color:#fff;">Project Connect</h3>
            <h4 class="moving-card-title-sub" style="margin:0 0 10px; font-size:13px; font-weight:600; color:#e2e8f0; line-height:1.3;">AI and Data Science for HealthTech Solution</h4>
            <div style="font-size:10px; color:rgba(255,255,255,0.5); font-weight:600; margin-bottom:2px;">Required Skills:</div>
            <div class="moving-card-skills" style="font-size:10px; color:#e2e8f0; line-height:1.3;">Machine Learning, Data Analytics, TensorFlow, Health Informatics</div>
            <div class="moving-card-action" style="margin-top:auto; display:flex; align-items:center; gap:6px; color:#c8a882; font-size:11px; font-weight:700; letter-spacing:0.5px; text-transform:uppercase;">
              <span>EXPRESS INTEREST</span> <i class="ti ti-arrow-right"></i>
            </div>
            <!-- Network graphic -->
            <div class="moving-card-graphic" style="position:absolute; right:10px; top:10px; opacity:0.15; pointer-events:none; width:80px; height:80px;">
              <svg viewBox="0 0 100 100" style="width:100%; height:100%;">
                <circle cx="50" cy="50" r="30" fill="none" stroke="#fff" stroke-width="1.5"/>
                <circle cx="50" cy="50" r="8" fill="#14b8a6"/>
                <line x1="50" y1="50" x2="20" y2="30" stroke="#fff" stroke-width="1.5"/>
                <line x1="50" y1="50" x2="80" y2="30" stroke="#fff" stroke-width="1.5"/>
                <line x1="50" y1="50" x2="30" y2="75" stroke="#fff" stroke-width="1.5"/>
                <line x1="50" y1="50" x2="70" y2="75" stroke="#fff" stroke-width="1.5"/>
                <circle cx="20" cy="30" r="5" fill="#3b82f6"/>
                <circle cx="80" cy="30" r="5" fill="#22c55e"/>
                <circle cx="30" cy="75" r="5" fill="#eab308"/>
                <circle cx="70" cy="75" r="5" fill="#ec4899"/>
              </svg>
            </div>
          </div>

          <!-- Card 3: Success Story -->
          <div class="moving-card success-card" data-action="setMobileTab" data-tab="market">
            <div style="display:flex; justify-content:space-between; align-items:flex-start; width:100%;">
              <div class="moving-card-avatar" style="width:36px; height:36px; border-radius:50%; overflow:hidden; border:2px solid rgba(255,255,255,0.2);">
                <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Felix" style="width:100%; height:100%; object-fit:cover;">
              </div>
            </div>
            <h3 class="moving-card-title" style="margin:12px 0 4px; font-size:16px; font-weight:700; color:#fff;">Success Story</h3>
            <p class="moving-card-desc" style="margin:0 0 12px; font-size:11px; color:rgba(255,255,255,0.6); line-height:1.4;">Empowering African talent through direct connections.</p>
            <div class="moving-card-action" style="margin-top:auto; display:flex; align-items:center; gap:6px; color:#14b8a6; font-size:11px; font-weight:700;">
              <span>Learn More</span> <i class="ti ti-arrow-right"></i>
            </div>
          </div>
        </div>
        
        <!-- Indicator Dots -->
        <div class="moving-cards-dots">
          <span class="dot active"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>

        <!-- Stats Panel -->
        <div class="welcome-stats-container">
          <div class="welcome-stat-box">
            <svg viewBox="0 0 100 50" class="gauge-svg" style="width: 38px; height: 19px; flex-shrink:0; margin-right: 2px;">
              <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="10" stroke-linecap="round"/>
              <path d="M 10 50 A 40 40 0 0 1 80 30" fill="none" stroke="url(#gaugeGrad1)" stroke-width="10" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="75" y2="30" stroke="#fff" stroke-width="4" stroke-linecap="round"/>
              <circle cx="50" cy="50" r="5" fill="#fff"/>
              <defs>
                <linearGradient id="gaugeGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#14b8a6"/>
                  <stop offset="100%" stop-color="#22c55e"/>
                </linearGradient>
              </defs>
            </svg>
            <div class="stat-info-text">
              <span class="stat-label-text">ACTIVE TALENT POOL:</span>
              <span class="stat-value-text">${activeTalents}</span>
            </div>
          </div>
          <div class="welcome-stat-box">
            <svg viewBox="0 0 100 50" class="gauge-svg" style="width: 38px; height: 19px; flex-shrink:0; margin-right: 2px;">
              <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="10" stroke-linecap="round"/>
              <path d="M 10 50 A 40 40 0 0 1 75 22" fill="none" stroke="url(#gaugeGrad2)" stroke-width="10" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="68" y2="25" stroke="#fff" stroke-width="4" stroke-linecap="round"/>
              <circle cx="50" cy="50" r="5" fill="#fff"/>
              <defs>
                <linearGradient id="gaugeGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#3b82f6"/>
                  <stop offset="100%" stop-color="#14b8a6"/>
                </linearGradient>
              </defs>
            </svg>
            <div class="stat-info-text">
              <span class="stat-label-text">DIRECT CONNECTIONS MADE:</span>
              <span class="stat-value-text">${jobsConnected}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-row">
        <span class="sec-title">Explore Opportunities</span>
        <span class="sec-link" data-action="setMobileTab" data-tab="market">View All</span>
      </div>

      <div class="jobs-grid">
        <div class="job-item" data-action="openMobileCategory" data-cat="Government Jobs">
          <div class="job-icon" style="background:rgba(80, 110, 145, 0.55); border: 1px solid rgba(100, 130, 165, 0.4);"><i class="ti ti-building" style="color:#c0d4e8;" aria-hidden="true"></i></div>
          <span class="job-label">Government Jobs</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="Private Sector">
          <div class="job-icon" style="background:rgba(140, 100, 65, 0.55); border: 1px solid rgba(160, 120, 80, 0.4);"><i class="ti ti-building-skyscraper" style="color:#e0c4a0;" aria-hidden="true"></i></div>
          <span class="job-label">Private Sector</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="NGOs">
          <div class="job-icon" style="background:rgba(60, 150, 110, 0.50); border: 1px solid rgba(80, 170, 130, 0.4);"><i class="ti ti-heart-handshake" style="color:#a0e8d0;" aria-hidden="true"></i></div>
          <span class="job-label">NGOs</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="International Jobs">
          <div class="job-icon" style="background:rgba(120, 80, 180, 0.50); border: 1px solid rgba(140, 100, 200, 0.4);"><i class="ti ti-world" style="color:#d0b8f0;" aria-hidden="true"></i></div>
          <span class="job-label">International</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="Internships">
          <div class="job-icon" style="background:rgba(150, 100, 75, 0.55); border: 1px solid rgba(170, 120, 90, 0.4);"><i class="ti ti-school" style="color:#e0c0a8;" aria-hidden="true"></i></div>
          <span class="job-label">Internships</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="Attachments">
          <div class="job-icon" style="background:rgba(140, 130, 100, 0.50); border: 1px solid rgba(160, 150, 120, 0.4);"><i class="ti ti-clipboard-list" style="color:#e0d8c0;" aria-hidden="true"></i></div>
          <span class="job-label">Attachments</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="Scholarships">
          <div class="job-icon" style="background:rgba(60, 140, 120, 0.50); border: 1px solid rgba(80, 160, 140, 0.4);"><i class="ti ti-certificate" style="color:#a0e0c8;" aria-hidden="true"></i></div>
          <span class="job-label">Scholarships</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="Side Hustle">
          <div class="job-icon" style="background:rgba(150, 125, 80, 0.55); border: 1px solid rgba(170, 145, 100, 0.4);"><i class="ti ti-coin" style="color:#e0d0a8;" aria-hidden="true"></i></div>
          <span class="job-label">Side Hustle</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="TaskBridge Institute">
          <div class="job-icon" style="background:rgba(60, 70, 100, 0.60); border: 1px solid rgba(80, 90, 120, 0.4);"><i class="ti ti-award-filled" style="color:#b0b8d0;" aria-hidden="true"></i></div>
          <span class="job-label">TBI</span>
        </div>
        <div class="job-item" data-action="openMobileCategory" data-cat="Remote Jobs">
          <div class="job-icon" style="background:rgba(120, 100, 80, 0.55); border: 1px solid rgba(140, 120, 100, 0.4);"><i class="ti ti-device-laptop" style="color:#d0c0a8;" aria-hidden="true"></i></div>
          <span class="job-label">Remote Jobs</span>
        </div>
      </div>
    `;
  } else if (currentTab === 'institute') {
    tabContentHtml = institutePanel();
  } else if (currentTab === 'market' || currentTab === 'tasks') {
    tabContentHtml = marketplacePanel();
  } else if (currentTab === 'wallet' || currentTab === 'profile') {
    tabContentHtml = walletPanel();
  } else {
    tabContentHtml = marketplacePanel();
  }

  // Drawer menu sections
  const menuItemsHtml = `
    <div class="drawer-section-label">Main</div>
    <button class="drawer-item" data-action="setMobileTab" data-tab="home"><i class="ti ti-home" aria-hidden="true"></i> Home</button>
    <button class="drawer-item" data-action="setMobileTab" data-tab="wallet"><i class="ti ti-user" aria-hidden="true"></i> My Profile</button>
    <button class="drawer-item" data-action="setMobileTab" data-tab="wallet"><i class="ti ti-briefcase" aria-hidden="true"></i> My Applications</button>
    <button class="drawer-item" data-action="setMobileTab" data-tab="wallet"><i class="ti ti-wallet" aria-hidden="true"></i> Wallet</button>
    <button class="drawer-item" data-action="setMobileTab" data-tab="market"><i class="ti ti-checkbox" aria-hidden="true"></i> My Tasks</button>
    
    <div class="drawer-divider"></div>
    <div class="drawer-section-label">Explore</div>
    <button class="drawer-item" data-action="openMobileCategory" data-cat="Government Jobs"><i class="ti ti-building" aria-hidden="true"></i> Government Jobs</button>
    <button class="drawer-item" data-action="openMobileCategory" data-cat="International Jobs"><i class="ti ti-world" aria-hidden="true"></i> International Jobs</button>
    <button class="drawer-item" data-action="openMobileCategory" data-cat="Remote Jobs"><i class="ti ti-device-laptop" aria-hidden="true"></i> Remote Jobs</button>
    <button class="drawer-item" data-action="setMobileTab" data-tab="institute"><i class="ti ti-award" aria-hidden="true"></i> TaskBridge Institute</button>
    
    <div class="drawer-divider"></div>
    <div class="drawer-section-label">Account</div>
    <button class="drawer-item" data-action="setMobileTab" data-tab="wallet"><i class="ti ti-settings" aria-hidden="true"></i> Settings</button>
    <button class="drawer-item" data-action="help"><i class="ti ti-help" aria-hidden="true"></i> Help & Support</button>
    <button class="drawer-item danger" data-action="logout"><i class="ti ti-logout" aria-hidden="true"></i> Log Out</button>
  `;

  return `
    <section class="dashboard-page tb-mobile-app">
      <!-- Main view wrapper -->
      <div class="view active" id="home-view" style="display:flex; flex-direction:column; min-height:100vh;">
        <!-- Mobile Top Bar -->
        <div class="top-bar" style="display:flex; justify-content:space-between; align-items:center; padding:10px 16px; background:rgba(10, 22, 40, 0.75); backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); border-bottom: 1px solid rgba(255, 255, 255, 0.08); box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3); position:sticky; top:0; z-index:90;">
          <button class="hamburger-btn" data-action="openMobileMenu" aria-label="Open menu" style="background:none; border:none; cursor:pointer; padding:4px; display:flex; flex-direction:column; gap:5px; width:30px; height:30px; justify-content:center;">
            <span style="display:block; height:2px; background:#fff; width:100%; border-radius:1px;"></span>
            <span style="display:block; height:2px; background:#fff; width:70%; border-radius:1px;"></span>
            <span style="display:block; height:2px; background:#fff; width:100%; border-radius:1px;"></span>
          </button>
          
          <div class="top-bar-logo" data-action="setMobileTab" data-tab="home" style="display:flex; align-items:center; gap:8px; cursor:pointer;">
            <img src="./logo192.png" alt="TB" style="width:24px; height:24px; border-radius:6px;">
            <span style="font-weight:700; font-size:16px; letter-spacing:0.5px; color:#fff;">TaskBridge</span>
          </div>

          <div class="top-bar-right" style="display:flex; align-items:center; gap:12px;">
            <div class="user-pill" data-action="setMobileTab" data-tab="wallet" style="display:flex; align-items:center; gap:6px; background:rgba(255,255,255,0.06); border:1px solid rgba(200, 168, 130, 0.5); border-radius:20px; padding:3px 10px 3px 4px; cursor:pointer; box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
              <div class="user-pill-avatar" style="width:20px; height:20px; border-radius:50%; background:#c8a882; display:flex; align-items:center; justify-content:center; font-size:11px;">🧑</div>
              <span class="user-pill-name" style="font-size:11px; font-weight:600; color:#fff;">${firstName}</span>
            </div>
            <button class="bell-btn-plain" data-action="showNotifications" onclick="window.showNotificationsModal()" aria-label="Notifications" style="background:none; border:none; color:#fff; font-size:18px; cursor:pointer; padding:0; display:flex; align-items:center;">
              <i class="ti ti-bell"></i>
            </button>
          </div>
        </div>

        <!-- Scrollable tab content panel -->
        <div style="flex: 1; overflow-y: auto; padding-bottom: 110px; position: relative;">
          <!-- World Map / Savannah Background Overlay -->
          <div style="position: absolute; inset: 0; z-index: 0; opacity: 0.28; pointer-events: none; overflow: hidden; display: flex; align-items: flex-end; justify-content: center; padding-bottom: 60px;">
            <svg viewBox="0 0 1440 600" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: auto; min-height: 450px; opacity: 0.7;">
              <!-- Simple dotted map pattern -->
              <path d="M210 600 C220 530 240 490 280 450 C320 410 370 400 420 400 L460 600 Z" fill="rgba(20, 184, 166, 0.15)"/>
              <ellipse cx="280" cy="455" rx="55" ry="8" fill="rgba(20, 184, 166, 0.15)"/>
              <ellipse cx="360" cy="435" rx="75" ry="10" fill="rgba(20, 184, 166, 0.15)"/>
              <ellipse cx="430" cy="420" rx="65" ry="9" fill="rgba(20, 184, 166, 0.15)"/>
              <!-- Dotted globe outline -->
              <circle cx="720" cy="500" r="300" stroke="rgba(255,255,255,0.06)" stroke-width="1.5" stroke-dasharray="4,8"/>
              <circle cx="720" cy="500" r="200" stroke="rgba(255,255,255,0.04)" stroke-width="1.5" stroke-dasharray="2,6"/>
            </svg>
          </div>
          <div style="position: relative; z-index: 1;">
            ${tabContentHtml}
          </div>
        </div>

        <!-- Mobile Bottom Nav -->
        <div class="bottom-nav">
          <button class="nav-tab ${tabActive('home')}" data-action="setMobileTab" data-tab="home">
            <i class="ti ti-home" aria-hidden="true"></i>
            <span>Home</span>
          </button>
          <button class="nav-tab ${tabActive('institute')}" data-action="setMobileTab" data-tab="institute">
            <i class="ti ti-school" aria-hidden="true"></i>
            <span>TIT</span>
          </button>
          <button class="nav-tab ${tabActive('market')}" data-action="setMobileTab" data-tab="market">
            <i class="ti ti-layout-grid" aria-hidden="true"></i>
            <span>Grow</span>
          </button>
          <button class="nav-tab ${tabActive('wallet')}" data-action="setMobileTab" data-tab="wallet">
            <i class="ti ti-user" aria-hidden="true"></i>
            <span>Profile</span>
          </button>
        </div>
      </div>

      <!-- Job Category Detail sliding panel (in-place) -->
      <div class="detail-view ${detailActive}" id="detail-view">
        <div class="detail-header">
          <button class="back-btn" data-action="closeMobileCategory" aria-label="Go back"><i class="ti ti-arrow-left" aria-hidden="true"></i></button>
          <div>
            <div class="detail-title">${escapeHtml(selectedCatName || '')}</div>
            <div class="detail-subtitle">${detailJobsCount} listings available</div>
          </div>
          <div class="detail-icon-big" id="detail-icon-big" style="background:${detailCatColor};">
            ${detailIconHtml}
          </div>
        </div>
        <div class="detail-view-body">
          <div class="filter-row">
            <div class="filter-chip ${state.mobileDetailFilter === 'All' || !state.mobileDetailFilter ? 'active-chip' : ''}" data-action="setMobileDetailFilter" data-filter="All">All</div>
            <div class="filter-chip ${state.mobileDetailFilter === 'Full-time' ? 'active-chip' : ''}" data-action="setMobileDetailFilter" data-filter="Full-time">Full-time</div>
            <div class="filter-chip ${state.mobileDetailFilter === 'Part-time' ? 'active-chip' : ''}" data-action="setMobileDetailFilter" data-filter="Part-time">Part-time</div>
            <div class="filter-chip ${state.mobileDetailFilter === 'Entry level' ? 'active-chip' : ''}" data-action="setMobileDetailFilter" data-filter="Entry level">Entry level</div>
            <div class="filter-chip ${state.mobileDetailFilter === 'Senior' ? 'active-chip' : ''}" data-action="setMobileDetailFilter" data-filter="Senior">Senior</div>
          </div>
          <div id="job-listings">
            ${detailJobsHtml}
          </div>
          <button class="apply-btn" data-action="setMobileTab" data-tab="market">Browse All Listings</button>
        </div>
      </div>

      <!-- Hamburger Drawer overlay and body -->
      <div class="drawer-overlay ${isMenuOpen ? 'open' : ''}" data-action="closeMobileMenu"></div>
      <div class="drawer ${isMenuOpen ? 'open' : ''}">
        <div class="drawer-header" style="position: relative;">
          <!-- Close Button / Exit Arrow -->
          <button data-action="closeMobileMenu" aria-label="Close menu" style="position: absolute; right: 16px; top: 16px; background: none; border: none; color: #fff; font-size: 20px; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 6px; z-index: 10;">
            <i class="ti ti-arrow-left"></i>
          </button>
          <div class="drawer-avatar">🧑</div>
          <div class="drawer-name">${escapeHtml(name)}</div>
          <div class="drawer-email">${escapeHtml(profile.email || '')}</div>
        </div>
        <div class="drawer-menu">
          ${menuItemsHtml}
        </div>
      </div>

    </section>
  `;
}

function dashboardView() {
  if (!profile.active && !isNativeAppSession()) {
    return accessView();
  }

  if (window.innerWidth <= 992) {
    return mobileAppDashboardView();
  }

  const tabs = [
    ["home", "Home", "house"],
    ["overview", "Overview", "layout-dashboard"],
    ["jobs", "Jobs,Attachments&Internships", "briefcase"],
    ["institute", "Taskbridge Institute", "graduation-cap"],
    ["market", "Tasks", "check-square"],
    ["finance", "Finance", "banknote"],
    ["grow", "Grow", "trending-up"],
    ["referrals", "Referrals", "users"],
    isAdmin() ? ["admin", "Admin", "shield-check"] : null,
  ].filter(Boolean);

  return `
    <section class="dashboard-page">
      <!-- Mobile Side Drawer -->
      <div class="dashboard-drawer ${state.menuOpen ? 'open' : ''}">
        <div class="drawer-overlay" data-action="menu"></div>
        <div class="drawer-content">
          <div class="drawer-header">
            <div class="drawer-brand">
              <img src="./logo192.png" alt="TB">
              <span>TASKBRIDGE</span>
            </div>
            <button class="icon-btn mini" data-action="menu" style="background: transparent; border: none; color: white;">${icon('x')}</button>
          </div>
          
          <nav class="drawer-nav">
            ${tabs.map(([key, label, iconName]) => {
              const isJobsBtn = key === 'jobs';
              const isFinanceBtn = key === 'finance';
              
              if (isJobsBtn) {
                const btnMarkup = `
                  <button class="drawer-nav-item ${state.jobsMenuExpanded ? 'is-active' : ''}" data-tab="${key}" style="justify-content: space-between; width: 100%;">
                    <span style="display:flex; align-items:center; gap:10px;">${icon(iconName)} <span>${label}</span></span>
                    <span style="display:flex; align-items:center; transition: transform 0.25s ease; transform: rotate(${state.jobsMenuExpanded ? '180' : '0'}deg); color: #94a3b8; flex-shrink:0;">${icon('chevron-down')}</span>
                  </button>
                `;
                const subMenuMarkup = (state.dashTab === 'jobs' || state.jobsMenuExpanded) ? `
                  <div class="drawer-sub-menu" style="display: flex; flex-direction: column; gap: 4px; padding-left: 28px; margin-top: 2px; margin-bottom: 8px;">
                    ${[
                      ["government", "Government Jobs"],
                      ["private", "Private Sector Jobs"],
                      ["ngo", "NGOs"],
                      ["international", "International Jobs"],
                      ["internship", "Internships"],
                      ["attachment", "Attachments"],
                      ["scholarship", "International Scholarships"],
                      ["remote", "Side Hustle Gigs"]
                    ].map(([id, subLabel]) => `
                      <button class="drawer-sub-item" data-action="filterJobs" data-filter="${id}" style="
                        background: transparent; border: none; color: ${state.jobsFilter === id ? '#22c55e' : '#a3b4ae'};
                        font-size: 13px; text-align: left; padding: 6px 12px; cursor: pointer; border-radius: 6px;
                        display: flex; align-items: center; gap: 8px; font-weight: ${state.jobsFilter === id ? '700' : 'normal'};
                      ">
                        <span style="width: 5px; height: 5px; border-radius: 50%; background: ${state.jobsFilter === id ? '#22c55e' : 'rgba(255,255,255,0.2)'};"></span>
                        ${subLabel}
                      </button>
                    `).join("")}
                  </div>
                ` : "";
                return btnMarkup + subMenuMarkup;
              }
              
              if (isFinanceBtn) {
                const btnMarkup = `
                  <button class="drawer-nav-item ${state.financeMenuExpanded ? 'is-active' : ''}" data-tab="${key}" style="justify-content: space-between; width: 100%;">
                    <span style="display:flex; align-items:center; gap:10px;">${icon(iconName)} <span>${label}</span></span>
                    <span style="display:flex; align-items:center; transition: transform 0.25s ease; transform: rotate(${state.financeMenuExpanded ? '180' : '0'}deg); color: #94a3b8; flex-shrink:0;">${icon('chevron-down')}</span>
                  </button>
                `;
                const subMenuMarkup = (state.financeMenuExpanded) ? `
                  <div class="drawer-sub-menu" style="display: flex; flex-direction: column; gap: 4px; padding-left: 28px; margin-top: 2px; margin-bottom: 8px;">
                    <button class="drawer-sub-item ${state.dashTab === 'wallet' ? 'is-active' : ''}" data-tab="wallet" style="
                      background: transparent; border: none; color: ${state.dashTab === 'wallet' ? '#22c55e' : '#a3b4ae'};
                      font-size: 13px; text-align: left; padding: 6px 12px; cursor: pointer; border-radius: 6px;
                      display: flex; align-items: center; gap: 8px;
                    ">
                      <span style="width: 5px; height: 5px; border-radius: 50%; background: ${state.dashTab === 'wallet' ? '#22c55e' : 'rgba(255,255,255,0.2)'};"></span>
                      Wallet
                    </button>
                    <button class="drawer-sub-item" data-action="focusMpesa" style="
                      background: transparent; border: none; color: #a3b4ae;
                      font-size: 13px; text-align: left; padding: 6px 12px; cursor: pointer; border-radius: 6px;
                      display: flex; align-items: center; gap: 8px;
                    ">
                      <span style="width: 5px; height: 5px; border-radius: 50%; background: rgba(255,255,255,0.2);"></span>
                      M-Pesa Quick Transfer
                    </button>
                  </div>
                ` : "";
                return btnMarkup + subMenuMarkup;
              }
              
              const isEcosystemBtn = key === 'grow';
              const actualKey = isEcosystemBtn ? 'ecosystem' : key;
              return `
                <button class="drawer-nav-item ${state.dashTab === actualKey ? 'is-active' : ''}" data-tab="${actualKey}">
                  ${icon(iconName)} <span>${label}</span>
                </button>
              `;
            }).join('')}
            <button class="drawer-nav-item" data-action="logout" style="color: #f87171; margin-top: auto; border: none; background: transparent; text-align: left; cursor: pointer; display: flex; align-items: center; gap: 12px; padding: 12px 16px;">
              ${icon('lock-keyhole')} <span>Sign Out</span>
            </button>
          </nav>
        </div>
      </div>

      <aside class="dashboard-sidebar">
        <div class="sidebar-brand-top" style="display: flex; align-items: center; gap: 12px; padding: 12px 16px 24px; margin-bottom: 16px; border-bottom: 1px solid rgba(255, 255, 255, 0.05);">
          <img src="./logo192.png" alt="TB" style="width: 32px; height: 32px; border-radius: 8px; box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);">
          <span style="font-weight: 800; font-size: 1.25rem; letter-spacing: 0.5px; color: white;">Taskbridge</span>
        </div>
        <nav class="dashboard-nav" aria-label="Dashboard sections">
          ${tabs
            .map(
              ([key, label, iconName]) => {
                const isJobsBtn = key === 'jobs';
                const isFinanceBtn = key === 'finance';
                
                if (isJobsBtn) {
                  const btnMarkup = `
                    <button class="${state.jobsMenuExpanded ? 'is-active' : ''}" data-tab="${key}" style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 6px; padding: 0 10px;">
                      <span style="display:flex; align-items:center; gap:8px; min-width: 0; flex: 1;">
                        ${icon(iconName)}
                        <span style="font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Jobs/Attachments/Internships</span>
                      </span>
                      <span style="display:flex; align-items:center; transition: transform 0.25s ease; transform: rotate(${state.jobsMenuExpanded ? '180' : '0'}deg); color: #94a3b8; flex-shrink:0;">${icon('chevron-down')}</span>
                    </button>
                  `;
                  const subMenuMarkup = (state.dashTab === 'jobs' || state.jobsMenuExpanded) ? `
                    <div class="sidebar-sub-menu" style="display: flex; flex-direction: column; gap: 4px; padding-left: 24px; margin-top: 4px; margin-bottom: 8px;">
                      ${[
                        ["government", "Government Jobs"],
                        ["private", "Private Sector Jobs"],
                        ["ngo", "NGOs"],
                        ["international", "International Jobs"],
                        ["internship", "Internships"],
                        ["attachment", "Attachments"],
                        ["scholarship", "International Scholarships"],
                        ["remote", "Side Hustle Gigs"]
                      ].map(([id, subLabel]) => `
                        <button class="sub-nav-item" data-action="filterJobs" data-filter="${id}" style="
                          background: transparent; border: none; color: ${state.jobsFilter === id ? '#22c55e' : '#94a3b8'};
                          font-size: 12px; text-align: left; padding: 6px 12px; cursor: pointer; border-radius: 6px;
                          display: flex; align-items: center; gap: 8px; font-weight: ${state.jobsFilter === id ? '700' : 'normal'};
                        ">
                          <span style="width: 4px; height: 4px; border-radius: 50%; background: ${state.jobsFilter === id ? '#22c55e' : 'rgba(255,255,255,0.2)'};"></span>
                          ${subLabel}
                        </button>
                      `).join("")}
                    </div>
                  ` : "";
                  return btnMarkup + subMenuMarkup;
                }

                if (isFinanceBtn) {
                  const btnMarkup = `
                    <button class="${state.financeMenuExpanded ? 'is-active' : ''}" data-tab="${key}" style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 6px; padding: 0 10px;">
                      <span style="display:flex; align-items:center; gap:8px; min-width: 0; flex: 1;">
                        ${icon(iconName)}
                        <span style="font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${label}</span>
                      </span>
                      <span style="display:flex; align-items:center; transition: transform 0.25s ease; transform: rotate(${state.financeMenuExpanded ? '180' : '0'}deg); color: #94a3b8; flex-shrink:0;">${icon('chevron-down')}</span>
                    </button>
                  `;
                  const subMenuMarkup = (state.financeMenuExpanded) ? `
                    <div class="sidebar-sub-menu" style="display: flex; flex-direction: column; gap: 4px; padding-left: 24px; margin-top: 4px; margin-bottom: 8px;">
                      <button class="sub-nav-item ${state.dashTab === 'wallet' ? 'is-active' : ''}" data-tab="wallet" style="
                        background: transparent; border: none; color: ${state.dashTab === 'wallet' ? '#22c55e' : '#94a3b8'};
                        font-size: 12px; text-align: left; padding: 6px 12px; cursor: pointer; border-radius: 6px;
                        display: flex; align-items: center; gap: 8px;
                      ">
                        <span style="width: 4px; height: 4px; border-radius: 50%; background: ${state.dashTab === 'wallet' ? '#22c55e' : 'rgba(255,255,255,0.2)'};"></span>
                        Wallet
                      </button>
                      <button class="sub-nav-item" data-action="focusMpesa" style="
                        background: transparent; border: none; color: #94a3b8;
                        font-size: 12px; text-align: left; padding: 6px 12px; cursor: pointer; border-radius: 6px;
                        display: flex; align-items: center; gap: 8px;
                      ">
                        <span style="width: 4px; height: 4px; border-radius: 50%; background: rgba(255,255,255,0.2);"></span>
                        M-Pesa Quick Transfer
                      </button>
                    </div>
                  ` : "";
                  return btnMarkup + subMenuMarkup;
                }
                
                const isEcosystemBtn = key === 'grow';
                const actualKey = isEcosystemBtn ? 'ecosystem' : key;
                return `
                  <button class="${state.dashTab === actualKey ? "is-active" : ""}" data-tab="${actualKey}">
                    ${icon(iconName)}
                    <span>${label}</span>
                  </button>
                `;
              }
            )
            .join("")}
          <button data-action="help" style="margin-top: auto;">
            ${icon("help-circle")}
            <span>Help Centre</span>
          </button>
          <button data-action="logout" style="margin-top: 10px; color: #f87171;">
            ${icon("lock-keyhole")}
            <span>Sign Out</span>
          </button>
        </nav>
      </aside>
      <main class="dashboard-main" style="padding-top: 0; display: flex; flex-direction: column;">

        <!-- Desktop Header Profile Area -->
        <div class="dashboard-desktop-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px 24px 20px; border-bottom: 1px solid rgba(255,255,255,0.05); margin-bottom: 24px;">
          <!-- Desktop Search Bar -->
          <div style="position: relative; width: 320px; display: flex; align-items: center;">
            <span style="position: absolute; left: 14px; color: #94a3b8; display: flex; align-items: center; pointer-events: none;">
              ${icon('search')}
            </span>
            <input 
              id="global-search-input"
              type="text" 
              placeholder="Search tasks, categories..." 
              value="${escapeAttr(state.search)}" 
              data-input="search" 
              style="
                width: 100%; padding: 10px 16px 10px 42px; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.08);
                border-radius: 20px; color: white; font-size: 0.85rem; outline: none; transition: border-color 0.2s;
              " 
              onfocus="this.style.borderColor='#14b8a6'" 
              onblur="this.style.borderColor='rgba(255,255,255,0.08)'" 
            />
          </div>
          <div style="display: flex; align-items: center; gap: 12px;">
            <div style="width: 42px; height: 42px; border-radius: 50%; background: #475569; overflow: hidden; border: 2px solid #22c55e;">
              <img src="${profile.customAvatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${profile.username || 'Mathias'}`}" style="width: 100%; height: 100%; object-fit: cover;" />
            </div>
            <div style="display: flex; flex-direction: column; text-align: left; line-height: 1.2; margin-right: 12px;">
              <span style="font-weight: 700; color: white; font-size: 14px;">Hi, ${escapeHtml(profile.name.split(' ')[0] || 'Mathias')}</span>
              <span style="color: var(--muted); font-size: 12px;">${escapeHtml(profile.email || 'pkiachmathias9@gmail.com')}</span>
            </div>
            <button data-action="toggleTheme" style="background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 50%; width: 38px; height: 38px; display: flex; align-items: center; justify-content: center; color: white; cursor: pointer; transition: background 0.2s;">
              ${state.theme === 'dark' ? icon('sun') : icon('moon')}
            </button>
          </div>
        </div>

        <div class="dashboard-mobile-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px 20px; background: rgba(10, 14, 26, 0.8); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border-bottom: 1px solid rgba(255,255,255,0.05); position: sticky; top: 0; z-index: 40; margin-bottom: 16px;">
          <button class="icon-btn mini" data-action="menu" style="background: transparent; border: none; font-size: 24px; color: white;">${icon('menu')}</button>
          <div style="display: flex; align-items: center; gap: 8px;">
            <img src="./logo192.png" alt="TB" style="width: 24px; height: 24px; border-radius: 6px;">
            <span style="font-weight: 700; font-size: 16px; letter-spacing: 0.5px; color: white;">TASKBRIDGE</span>
          </div>
          <div style="display: flex; align-items: center; gap: 12px;">
            <button data-action="toggleTheme" style="background: transparent; border: none; color: white; display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; cursor: pointer;">
              ${state.theme === 'dark' ? icon('sun') : icon('moon')}
            </button>
            <button class="icon-btn mini" data-action="dashTab" data-tab="market" style="background: transparent; border: none; color: white;">${icon('search')}</button>
            <div data-action="dashTab" data-tab="wallet" style="width: 28px; height: 28px; border-radius: 50%; background: #475569; overflow: hidden; border: 1px solid rgba(255,255,255,0.1); cursor: pointer;">
              <img src="${profile.customAvatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${profile.username}`}" style="width: 100%; height: 100%; pointer-events: none; object-fit: cover;" />
            </div>
          </div>
        </div>
        
        ${dashboardContent()}
      </main>
    </section>
    <nav class="bottom-nav" aria-label="Mobile dashboard navigation">
      <button class="${state.dashTab === 'home' ? 'active' : ''}" data-action="dashTab" data-tab="home">
        ${icon('house')}
        <span>Home</span>
      </button>
      <button class="${state.dashTab === 'jobs' ? 'active' : ''}" data-action="dashTab" data-tab="jobs">
        ${icon('briefcase')}
        <span>Jobs</span>
      </button>
      <button class="${state.dashTab === 'wallet' ? 'active' : ''}" data-action="dashTab" data-tab="wallet">
        ${icon('wallet')}
        <span>Wallet</span>
      </button>
      <button class="${state.dashTab === 'tasks' || state.dashTab === 'market' ? 'active' : ''}" data-action="dashTab" data-tab="tasks">
        ${icon('check-square')}
        <span>Tasks</span>
      </button>
      <button class="${state.dashTab === 'institute' ? 'active' : ''}" data-action="dashTab" data-tab="institute">
        ${icon('graduation-cap')}
        <span>TIT</span>
      </button>
    </nav>
  `;
}

function dashboardTop() {
  const isOverview = state.dashTab === "overview";
  const hour = new Date(new Date().toLocaleString("en-US", { timeZone: "Africa/Nairobi" })).getHours();
  let greeting = "Good evening";
  if (hour >= 0 && hour < 12) greeting = "Good morning";
  else if (hour >= 12 && hour < 17) greeting = "Good afternoon";

  const title = dashboardTitle();

  return `
    <div class="dashboard-top" style="${!title && state.dashTab !== 'wallet' ? 'display: none;' : ''}">
      ${title ? `
      <div>
        <h1>${title}</h1>
      </div>
      ` : "<div></div>"}
      <div class="top-actions">
        ${state.dashTab === "wallet" ? `
        <button class="btn btn-primary btn-small" data-action="invite">${icon("user-plus")} Invite</button>
        ` : ""}
      </div>
    </div>
    ${isOverview ? `
      <div class="welcome-panel" style="display:flex; flex-direction:column; gap:6px;">
        <h2 style="margin:0; font-size:1.4rem;">${greeting}, ${escapeHtml(displayName().split(' ')[0])}</h2>
      </div>
    ` : ""}
  `;
}

function dashboardTitle() {
  const titles = {
    referrals: "Referral payouts.",
    payments: "Payment details.",
    ecosystem: "TASKBRIDGE ecosystem.",
    admin: "Admin control panel.",
  };
  return titles[state.dashTab] || "";
}

function dashboardContent() {
  const views = {
    home: homePanel,
    overview: overviewPanel,
    market: marketplacePanel,
    tasks: marketplacePanel,
    jobs: jobsPanel,
    institute: institutePanel,
    wallet: walletPanel,
    referrals: referralPanel,
    admin: adminPanel,
  };
  return (views[state.dashTab] || marketplacePanel)();
}

function stats() {
  const walletBalance =
    profile.wallet.taskEarnings + profile.wallet.referralEarnings + profile.wallet.checkinRewards - profile.wallet.pendingWithdrawals;
  const completed = profile.submissions.filter((submission) => submission.status === "approved").length;
  const total = profile.wallet.taskEarnings + profile.wallet.referralEarnings + profile.wallet.checkinRewards;
  return { walletBalance, completed, total };
}

function statCards() {
  const values = stats();
  const cards = [
    ["Total Earnings", money(values.total), "+12%", "trending-up"],
    ["Tasks Completed", values.completed, "+3 this week", "badge-check"],
    ["Referral Earnings", money(profile.wallet.referralEarnings), `${profile.successfulReferrals} referrals`, "users"],
    ["Wallet Balance", money(values.walletBalance), "Available", "wallet"],
    ["Daily Check-in Payouts", money(profile.wallet.checkinRewards), countdownText(), "gift"],
  ];
  return `
    <div class="stat-grid">
      ${cards
        .map(
          ([label, value, trend, iconName]) => `
            <article class="stat-card">
              <span>${icon(iconName)}</span>
              <p>${label}</p>
              <strong>${value}</strong>
              <small>${trend}</small>
            </article>
          `,
        )
        .join("")}
    </div>
  `;
}

function checkInPanel() {
  const available = canCheckIn();
  return `
    <div class="checkin-panel">
      <div>
        <span>${icon("gift")}</span>
        <div>
          <strong>Daily check-in payout</strong>
          <p>${available ? "Claim KES 2 now. One claim is allowed every 24 hours." : `Next payout unlocks in ${countdownText()}.`}</p>
        </div>
      </div>
      <button class="btn ${available ? "btn-primary btn-glow" : "btn-ghost"}" data-action="checkin" ${available ? "" : "disabled"}>
        ${icon("sparkles")}
        <span>${available ? "Claim KES 2" : "Locked"}</span>
      </button>
    </div>
  `;
}

function canCheckIn() {
  if (!profile.lastCheckIn) return true;
  return Date.now() - new Date(profile.lastCheckIn).getTime() >= DAY_MS;
}

function countdownText() {
  if (canCheckIn()) return "Ready";
  const remaining = Math.max(0, DAY_MS - (Date.now() - new Date(profile.lastCheckIn).getTime()));
  const hours = Math.floor(remaining / (60 * 60 * 1000));
  const minutes = Math.ceil((remaining % (60 * 60 * 1000)) / (60 * 1000));
  return `${hours}h ${minutes}m`;
}

function getKenyanGreeting() {
  // Kenya is UTC+3
  const now = new Date();
  const kenyaHour = (now.getUTCHours() + 3) % 24;
  if (kenyaHour >= 5 && kenyaHour < 12) return 'Good Morning';
  if (kenyaHour >= 12 && kenyaHour < 17) return 'Good Afternoon';
  return 'Good Evening';
}

function homePanel() {
  const firstName = escapeHtml((profile.name || profile.username || 'User').split(' ')[0]);
  const greeting = getKenyanGreeting();

  return `
    <div class="new-dashboard-home" style="display: flex; flex-direction: column; gap: 24px; padding: 24px; animation: fadeIn 0.4s ease; position: relative; overflow: hidden; border-radius: 24px; background: rgba(10, 22, 40, 0.25);">
      
      <!-- African Heritage / Kenyan Savannah Background Overlay -->
      <div style="position: absolute; inset: 0; z-index: 0; opacity: 0.18; pointer-events: none; overflow: hidden; border-radius: 24px;">
        <svg viewBox="0 0 1440 600" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%; object-fit: cover;">
          <defs>
            <linearGradient id="kenyanHeritageGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#000000" stop-opacity="0.95"/>
              <stop offset="35%" stop-color="#990000" stop-opacity="0.75"/>
              <stop offset="70%" stop-color="#006600" stop-opacity="0.75"/>
              <stop offset="100%" stop-color="#14b8a6" stop-opacity="0.4"/>
            </linearGradient>
          </defs>
          <rect width="1440" height="600" fill="url(#kenyanHeritageGrad)"/>
          
          <!-- Acacia Tree Silhouettes -->
          <!-- Right side large Acacia -->
          <path d="M1220 600 C1225 510 1215 470 1240 420 C1260 380 1290 360 1330 360 C1390 360 1420 390 1440 410 L1440 600 Z" fill="#000000"/>
          <path d="M1240 420 C1220 410 1190 405 1170 400 C1110 390 1070 400 1030 410 C1000 420 980 430 960 450 L950 455" stroke="#000000" stroke-width="9" stroke-linecap="round"/>
          <ellipse cx="1030" cy="405" rx="85" ry="11" fill="#000000"/>
          <ellipse cx="1130" cy="395" rx="105" ry="14" fill="#000000"/>
          <ellipse cx="1240" cy="385" rx="125" ry="17" fill="#000000"/>
          <ellipse cx="1350" cy="370" rx="115" ry="14" fill="#000000"/>
          
          <!-- Left side small Acacia -->
          <path d="M140 600 C150 530 170 490 210 450 C250 410 300 400 350 400 L390 600 Z" fill="#000000"/>
          <ellipse cx="210" cy="455" rx="55" ry="8" fill="#000000"/>
          <ellipse cx="290" cy="435" rx="75" ry="10" fill="#000000"/>
          <ellipse cx="360" cy="420" rx="65" ry="9" fill="#000000"/>
        </svg>
      </div>

      <!-- HERO HEADER CARD -->
      <div style="position: relative; z-index: 1; background: rgba(255, 255, 255, 0.025); border: 1px solid rgba(255, 255, 255, 0.07); border-radius: 20px; padding: 32px 28px; display: flex; flex-direction: column; gap: 12px; box-shadow: 0 10px 30px rgba(0,0,0,0.25); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
        <div style="display: flex; align-items: center; gap: 8px; color: #14b8a6; font-size: 0.9rem; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase;">
          ${icon('sparkles')} Welcome to Taskbridge Africa
        </div>
        <h1 style="margin: 0; font-size: 2.1rem; font-weight: 900; line-height: 1.2; color: #ffffff;">
          ${greeting}, <span style="background: linear-gradient(90deg, #14b8a6, #22c55e); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">${firstName}</span>!
        </h1>
        <div style="display: inline-flex; align-items: center; gap: 8px; background: rgba(20, 184, 166, 0.1); border: 1px solid rgba(20, 184, 166, 0.25); border-radius: 8px; padding: 6px 12px; margin-top: 4px; max-width: fit-content; z-index: 1;">
          <span style="font-size: 0.8rem; color: #94a3b8; font-weight: 600;">Personal Portal Code:</span>
          <span style="font-family: monospace; font-size: 0.95rem; font-weight: 800; color: #14b8a6; letter-spacing: 1px;">${profile.portalCode || 'TB-XXXXXX'}</span>
        </div>
        <p style="margin: 4px 0 8px; font-size: 1.05rem; color: #94a3b8; line-height: 1.6; max-width: 720px;">
          Empowering African talent by bridging the gap between top employers, specialized skill development, and direct freelance opportunities. Explore our ecosystem below to start earning and learning today.
        </p>
        
        <!-- Trust/Stats bar -->
        <div style="display: flex; gap: 24px; flex-wrap: wrap; margin-top: 12px; border-top: 1px solid rgba(255,255,255,0.06); padding-top: 18px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="color: #14b8a6; display: flex; align-items: center; justify-content: center; background: rgba(20,184,166,0.1); width: 32px; height: 32px; border-radius: 8px;">
              ${icon('users')}
            </span>
            <div>
              <div style="font-size: 0.8rem; color: #64748b; font-weight: 600;">Active Talents</div>
              <div style="font-size: 0.95rem; color: #e2e8f0; font-weight: 700;">14,200+ Members</div>
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="color: #3b82f6; display: flex; align-items: center; justify-content: center; background: rgba(59,130,246,0.1); width: 32px; height: 32px; border-radius: 8px;">
              ${icon('briefcase')}
            </span>
            <div>
              <div style="font-size: 0.8rem; color: #64748b; font-weight: 600;">Jobs Connected</div>
              <div style="font-size: 0.95rem; color: #e2e8f0; font-weight: 700;">20,000+ Connected</div>
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="color: #22c55e; display: flex; align-items: center; justify-content: center; background: rgba(34,197,94,0.1); width: 32px; height: 32px; border-radius: 8px;">
              ${icon('check-circle')}
            </span>
            <div>
              <div style="font-size: 0.8rem; color: #64748b; font-weight: 600;">Tasks Verified</div>
              <div style="font-size: 0.95rem; color: #e2e8f0; font-weight: 700;">38,500+ Completed</div>
            </div>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="color: #eab308; display: flex; align-items: center; justify-content: center; background: rgba(234,179,8,0.1); width: 32px; height: 32px; border-radius: 8px;">
              ${icon('coins')}
            </span>
            <div>
              <div style="font-size: 0.8rem; color: #64748b; font-weight: 600;">Total Payouts</div>
              <div style="font-size: 0.95rem; color: #e2e8f0; font-weight: 700;">KES 2.8M+ Paid</div>
            </div>
          </div>
        </div>
      </div>

      <!-- THREE CORE SERVICES SECTION -->
      <h2 style="position: relative; z-index: 1; margin: 8px 0 0; font-size: 1.35rem; font-weight: 800; color: #ffffff; display: flex; align-items: center; gap: 8px;">
        Explore Our Core Offerings
      </h2>
      
      <div style="position: relative; z-index: 1; display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 20px;">
        
        <!-- CARD 1: JOBS, INTERNSHIPS & ATTACHMENTS -->
        <div class="stat-card" style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 18px; padding: 24px; display: flex; flex-direction: column; justify-content: space-between; transition: all 0.3s; position: relative;">
          <div>
            <div style="width: 48px; height: 48px; border-radius: 12px; background: rgba(20,184,166,0.1); border: 1px solid rgba(20,184,166,0.2); display: flex; align-items: center; justify-content: center; color: #14b8a6; margin-bottom: 20px;">
              ${icon('briefcase')}
            </div>
            <h3 style="margin: 0 0 8px; font-size: 1.25rem; font-weight: 700; color: #ffffff;">Jobs, Internships &amp; Attachments</h3>
            <p style="margin: 0 0 20px; font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Access a hand-picked, curated directory of professional vacancies. From major government tenders, student attachments, and local internships to verified private sector opportunities and international remote roles. We also feature accessible side hustles and digital gigs so that individuals without academic papers can easily find their ideal jobs.
            </p>
          </div>
          <button data-action="goToJobs" style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08); color: #ffffff; padding: 12px; border-radius: 12px; font-weight: 600; font-size: 0.9rem; cursor: pointer; transition: all 0.2s;">
            Browse Vacancies ${icon('arrow-right')}
          </button>
        </div>

        <!-- CARD 2: TASKBRIDGE INSTITUTE (TIT) -->
        <div class="stat-card" style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 18px; padding: 24px; display: flex; flex-direction: column; justify-content: space-between; transition: all 0.3s; position: relative;">
          <div>
            <div style="width: 48px; height: 48px; border-radius: 12px; background: rgba(34,197,94,0.1); border: 1px solid rgba(34,197,94,0.2); display: flex; align-items: center; justify-content: center; color: #22c55e; margin-bottom: 20px;">
              ${icon('graduation-cap')}
            </div>
            <h3 style="margin: 0 0 8px; font-size: 1.25rem; font-weight: 700; color: #ffffff;">Taskbridge Institute</h3>
            <p style="margin: 0 0 20px; font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Elevate your digital capabilities. Our custom-designed curriculum focuses on high-demand practical skills: AI-assisted writing, web development, digital marketing, and freelance career management. The institute is officially verified by the government, and recognized certificates are issued upon course completion.
            </p>
          </div>
          <button data-tab="institute" style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08); color: #ffffff; padding: 12px; border-radius: 12px; font-weight: 600; font-size: 0.9rem; cursor: pointer; transition: all 0.2s;">
            Start Learning Now ${icon('arrow-right')}
          </button>
        </div>

        <!-- CARD 3: TASKS (MICRO-WORK) -->
        <div class="stat-card" style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 18px; padding: 24px; display: flex; flex-direction: column; justify-content: space-between; transition: all 0.3s; position: relative;">
          <div>
            <div style="width: 48px; height: 48px; border-radius: 12px; background: rgba(234,179,8,0.1); border: 1px solid rgba(234,179,8,0.2); display: flex; align-items: center; justify-content: center; color: #eab308; margin-bottom: 20px;">
              ${icon('check-square')}
            </div>
            <h3 style="margin: 0 0 8px; font-size: 1.25rem; font-weight: 700; color: #ffffff;">Managed Tasks</h3>
            <p style="margin: 0 0 20px; font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Earn direct payouts by executing micro-tasks. Employers post assignments anonymously, Taskbridge verifies the funds and task specs, and hands them off directly to qualified talents. Safe, guaranteed payouts upon completion.
            </p>
          </div>
          <button data-tab="market" style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08); color: #ffffff; padding: 12px; border-radius: 12px; font-weight: 600; font-size: 0.9rem; cursor: pointer; transition: all 0.2s;">
            View Task Marketplace ${icon('arrow-right')}
          </button>
        </div>

      </div>

      <!-- HOW IT WORKS INFOGRAPHIC BOX -->
      <div style="position: relative; z-index: 1; background: rgba(255, 255, 255, 0.015); border: 1px solid rgba(255, 255, 255, 0.05); border-radius: 18px; padding: 28px 24px; margin-top: 4px;">
        <h3 style="margin: 0 0 16px; font-size: 1.15rem; font-weight: 700; color: #ffffff; display: flex; align-items: center; gap: 8px;">
          ${icon('git-pull-request')} The Taskbridge Connector Flow
        </h3>
        <p style="margin: 0 0 24px; font-size: 0.9rem; color: #94a3b8; line-height: 1.6; max-width: 800px;">
          We act as the trusted bridge and escrow middleman between employers seeking high-quality output and talented digital freelancers.
        </p>
        
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; position: relative;">
          <!-- Step 1 -->
          <div style="background: rgba(255,255,255,0.015); border: 1px solid rgba(255,255,255,0.04); border-radius: 14px; padding: 20px; text-align: center; position: relative;">
            <div style="width: 32px; height: 32px; border-radius: 50%; background: #14b8a6; color: #0a1628; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px;">1</div>
            <strong style="display: block; color: #ffffff; font-size: 0.95rem; margin-bottom: 6px;">Employer Posts</strong>
            <span style="font-size: 0.8rem; color: #64748b; line-height: 1.4; display: block;">Employers submit tasks and deposit escrow funds anonymously.</span>
          </div>
          
          <!-- Step 2 -->
          <div style="background: rgba(255,255,255,0.015); border: 1px solid rgba(255,255,255,0.04); border-radius: 14px; padding: 20px; text-align: center; position: relative;">
            <div style="width: 32px; height: 32px; border-radius: 50%; background: #22c55e; color: #0a1628; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px;">2</div>
            <strong style="display: block; color: #ffffff; font-size: 0.95rem; margin-bottom: 6px;">Taskbridge Verifies</strong>
            <span style="font-size: 0.8rem; color: #64748b; line-height: 1.4; display: block;">Our team audits task details and locks the payout to guarantee rewards.</span>
          </div>

          <!-- Step 3 -->
          <div style="background: rgba(255,255,255,0.015); border: 1px solid rgba(255,255,255,0.04); border-radius: 14px; padding: 20px; text-align: center; position: relative;">
            <div style="width: 32px; height: 32px; border-radius: 50%; background: #3b82f6; color: #ffffff; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px;">3</div>
            <strong style="display: block; color: #ffffff; font-size: 0.95rem; margin-bottom: 6px;">Talents Deliver</strong>
            <span style="font-size: 0.8rem; color: #64748b; line-height: 1.4; display: block;">Freelancers select and execute tasks following precise instructions.</span>
          </div>

          <!-- Step 4 -->
          <div style="background: rgba(255,255,255,0.015); border: 1px solid rgba(255,255,255,0.04); border-radius: 14px; padding: 20px; text-align: center; position: relative;">
            <div style="width: 32px; height: 32px; border-radius: 50%; background: #eab308; color: #0a1628; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px;">4</div>
            <strong style="display: block; color: #ffffff; font-size: 0.95rem; margin-bottom: 6px;">Guaranteed Payout</strong>
            <span style="font-size: 0.8rem; color: #64748b; line-height: 1.4; display: block;">Completed submissions are reviewed and funds are released to your wallet.</span>
          </div>
        </div>
      </div>

    </div>
  `;
}

function overviewPanel() {
  const values = stats();
  const walletBalance = values.walletBalance;
  const refCount = (profile.referredUsers || []).length;
  const username = escapeHtml(profile.username || profile.name || 'User');
  const firstName = escapeHtml((profile.name || profile.username || 'User').split(' ')[0]);
  const checkinAvailable = canCheckIn();
  const refLink = `taskbridge.co.ke/refer/${profile.referralCode || username}`;
  const refLinkFull = `${window.location.origin}/?ref=${getReferralCode()}`;
  const greeting = getKenyanGreeting();

  // Task Stats & Badges
  const completedTasks = profile.submissions.filter(s => s.status === 'approved').length;
  const pendingTasks = profile.submissions.filter(s => s.status === 'pending').length;
  const isVerified = Boolean(profile.verifiedWorker);
  const workerLevel = completedTasks > 50 ? 'LEVEL 3 PRO' : completedTasks > 10 ? 'LEVEL 2 ACTIVE' : 'LEVEL 1 BEGINNER';
  const averageAccuracy = completedTasks > 0 ? "98%" : "N/A"; // Could be dynamically calculated if score existed

  // Engagement streaks — compute day-of-week completion indicator
  const days = ['Mon','Tue','Wed','Thu','Fri','Sat'];
  const today = new Date();
  const todayDayIndex = today.getDay(); // 0=Sun
  const streakCount = profile.wallet?.checkinRewards ? Math.floor(profile.wallet.checkinRewards / 5) : 0;

  const realReferred = profile.referredUsers || [];
  let referredRowsHtml = "";
  if (realReferred.length > 0) {
    referredRowsHtml = realReferred.slice().reverse().map(item => {
      const nameVal = escapeHtml(item.name || "New user");
      const usernameVal = escapeHtml(item.username || (item.name ? item.name.toLowerCase().replace(/\s+/g,'') : "user"));
      let dateVal = "—";
      try { if (item.at) dateVal = new Date(item.at).toLocaleDateString("en-GB", { day:'2-digit', month:'short', year:'numeric' }); } catch(e){}
      const commissionVal = `KES ${REFERRAL_PAYOUT}`;
      const initialsVal = (item.name || "NU").split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase();
      return `
        <tr style="border-bottom: 1px solid rgba(255,255,255,0.04); font-size: 0.9rem; transition: background 0.15s;">
          <td style="padding: 14px 16px;">
            <div style="display: flex; align-items: center; gap: 12px;">
              <div style="width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, #14b8a6, #0d9488); display: flex; align-items: center; justify-content: center; color: white; font-weight: 700; font-size: 13px; flex-shrink:0;">${initialsVal}</div>
              <span style="color: white; font-weight: 600;">${nameVal}</span>
            </div>
          </td>
          <td style="padding: 14px 16px; color: var(--muted);">@${usernameVal}</td>
          <td style="padding: 14px 16px; color: var(--muted);">${dateVal}</td>
          <td style="padding: 14px 16px; color: #4ade80; font-weight: 600;">${commissionVal}</td>
        </tr>
      `;
    }).join('');
  } else {
    referredRowsHtml = `
      <tr>
        <td colspan="4" style="padding: 40px; text-align: center; color: var(--muted);">
          <div style="display:flex; flex-direction: column; align-items: center; gap: 8px;">
            <span style="font-size: 1.5rem;">🤝</span>
            <strong style="color: rgba(255,255,255,0.5);">You have no referrals yet. Start your journey below!</strong>
            <span style="font-size: 0.85rem;">Share your referral link to earn commissions:</span>
            <a href="${refLinkFull}" style="color: #14b8a6; font-size: 0.85rem; text-decoration: underline;">${refLink}</a>
          </div>
        </td>
      </tr>
    `;
  }

  return `
    <div class="new-dashboard-home">

      <!-- DESKTOP OVERVIEW -->
      <div class="desktop-overview-view" style="display: flex; flex-direction: column; gap: 20px; padding: 0 4px;">

        <!-- TOP: Welcome greeting + user info card -->
        <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px;">
          <div>
            <h1 style="margin: 0 0 4px; font-size: 1.35rem; font-weight: 700; color: #ffffff; line-height: 1.35;">
              ${greeting}, <span style="color: #14b8a6;">${firstName}</span>
            </h1>
            <p style="margin: 0; font-size: 0.85rem; color: #64748b;">Welcome to your Taskbridge Dashboard</p>
          </div>
          <div style="display: flex; align-items: center; gap: 12px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07); border-radius: 14px; padding: 10px 16px;">
            <div style="width: 42px; height: 42px; border-radius: 50%; overflow: hidden; border: 2px solid #22c55e; flex-shrink: 0;">
              <img src="${profile.customAvatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${profile.username || 'User'}`}" style="width:100%;height:100%; object-fit: cover;" />
            </div>
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <span style="font-size: 0.85rem; color: #94a3b8;">Hi, ${firstName}</span>
              <span style="font-size: 0.8rem; color: #64748b;">${escapeHtml(profile.email || '')}</span>
              <div style="display: flex; gap: 6px; margin-top: 4px; flex-wrap: wrap;">
                ${isVerified ? `<span style="background: rgba(34,197,94,0.15); border: 1px solid rgba(34,197,94,0.35); color: #4ade80; padding: 2px 10px; border-radius: 6px; font-weight: 700; font-size: 11px; letter-spacing: 0.5px; display:flex; align-items:center; gap:4px;">✔ VERIFIED WORKER</span>` : ''}
                <span style="background: rgba(14,165,233,0.15); border: 1px solid rgba(14,165,233,0.35); color: #38bdf8; padding: 2px 10px; border-radius: 6px; font-weight: 700; font-size: 11px; letter-spacing: 0.5px;">${workerLevel}</span>
              </div>
            </div>
            <button data-action="copyReferralLink" style="margin-left: 8px; background: rgba(20,184,166,0.15); border: 1px solid rgba(20,184,166,0.35); color: #14b8a6; border-radius: 8px; padding: 8px 14px; font-size: 12px; font-weight: 700; cursor: pointer; white-space: nowrap; transition: all 0.2s;">
              Copy Referral Link
            </button>
          </div>
        </div>

        <!-- STAT CARDS ROW (3 cards) -->
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px;">

          <!-- Card 1: Your Balance -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px 24px; position: relative; overflow: hidden;">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 6px;">
              <span style="font-size: 0.85rem; font-weight: 600; color: #94a3b8;">Your Balance</span>
              <span style="background: rgba(74,222,128,0.15); color: #4ade80; font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 20px; border: 1px solid rgba(74,222,128,0.3);">+${profile.wallet?.checkinRewards ? profile.wallet.checkinRewards : 0}.0 KES Today</span>
            </div>
            <div style="font-size: 2.2rem; font-weight: 800; color: #ffffff; margin: 8px 0 6px;">KES ${walletBalance}</div>
            <div style="font-size: 0.8rem; color: #64748b;">Available Funds</div>
          </div>

          <!-- Card 2: Task Stats -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px 24px;">
            <div style="font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 6px;">Worker Stats</div>
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin: 8px 0 12px;">
              <div>
                <div style="font-size: 2.2rem; font-weight: 800; color: #ffffff; line-height: 1;">${completedTasks}</div>
                <div style="font-size: 0.8rem; color: #64748b; margin-top: 4px;">Completed</div>
              </div>
              <div style="text-align: right;">
                <div style="font-size: 1.5rem; font-weight: 800; color: #4ade80; line-height: 1;">${averageAccuracy}</div>
                <div style="font-size: 0.8rem; color: #64748b; margin-top: 4px;">Accuracy</div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; border-top: 1px solid rgba(255,255,255,0.05); padding-top: 12px;">
              <span style="font-size: 0.8rem; color: #fbbf24;">${pendingTasks} Tasks Pending Review</span>
            </div>
          </div>

          <!-- Card 3: Engagement Streaks -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px 24px; position: relative;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px;">
              <span style="font-size: 0.85rem; font-weight: 600; color: #94a3b8;">Engagement Streaks</span>
              <button data-action="copyReferralLink" style="background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1); color: #94a3b8; border-radius: 8px; padding: 5px 10px; font-size: 11px; cursor: pointer; display: flex; align-items: center; gap: 5px; white-space: nowrap;">
                ${icon('copy')} Copy Referral Link
              </button>
            </div>
            <div style="display: flex; gap: 8px; align-items: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                <div style="width: 32px; height: 32px; border-radius: 50%; background: #14b8a6; display: flex; align-items: center; justify-content: center; color: white; font-size: 14px;">✓</div>
                <span style="font-size: 10px; color: #94a3b8;">Day 1</span>
              </div>
              ${days.map(d => `
                <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                  <div style="width: 32px; height: 32px; border-radius: 50%; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); display: flex; align-items: center; justify-content: center;"></div>
                  <span style="font-size: 10px; color: #64748b;">${d}</span>
                </div>
              `).join('')}
            </div>
          </div>

        </div>

        <!-- MIDDLE ROW: Wallet & Finance Hub + Engagement Center -->
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">

          <!-- Left: Wallet & Finance Hub -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px;">
            <h3 style="margin: 0 0 20px; font-size: 1.05rem; font-weight: 700; color: #ffffff;">Wallet &amp; Finance Hub</h3>
            <div style="display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap;">
              <!-- Balance + Withdraw sub-card -->
              <div style="background: linear-gradient(145deg, rgba(20,184,166,0.18), rgba(13,148,136,0.1)); border: 1px solid rgba(20,184,166,0.25); border-radius: 14px; padding: 18px 20px; min-width: 160px; flex: 1;">
                <div style="font-size: 0.8rem; color: rgba(255,255,255,0.6); margin-bottom: 4px;">Balance</div>
                <div style="font-size: 1.8rem; font-weight: 800; color: #ffffff; margin-bottom: 14px;">KES ${walletBalance}</div>
                <button data-action="withdrawMpesa" style="width:100%; background: #14b8a6; color: #0a1628; font-weight: 800; padding: 11px; border-radius: 10px; border: none; font-size: 14px; cursor: pointer; transition: all 0.2s; letter-spacing: 0.3px;">
                  Withdraw to M-Pesa
                </button>
                <p style="margin: 8px 0 0; text-align: center; color: rgba(255,255,255,0.45); font-size: 0.75rem;">Minimum KES 150</p>
              </div>
              <!-- M-Pesa Quick Transfer -->
              <div style="flex: 1.2; min-width: 160px; display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
                <div>
                  <div style="font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 10px;">M-Pesa Quick Transfer</div>
                  <div style="display: flex; gap: 8px; align-items: center;">
                    <input id="mpesa-quick-input" placeholder="Input" style="flex: 1; min-width: 0; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 10px 14px; color: white; font-size: 0.9rem; outline: none;" />
                    <button data-action="withdrawMpesa" style="width: 40px; height: 40px; background: #14b8a6; border: none; border-radius: 10px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #0a1628; font-weight: 700; flex-shrink: 0;">
                      ${icon('send')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button data-action="dashTab" data-tab="wallet" style="margin-top: 16px; background: none; border: none; color: #14b8a6; font-size: 0.85rem; cursor: pointer; padding: 4px 0; display: flex; align-items: center; gap: 6px;">
              Transaction History ${icon('chevron-down')}
            </button>
          </div>

          <!-- Right: Engagement Center -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px;">
            <h3 style="margin: 0 0 20px; font-size: 1.05rem; font-weight: 700; color: #ffffff;">Engagement Center</h3>

            <!-- Daily Check-in -->
            <div style="margin-bottom: 20px;">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                <span style="font-size: 0.85rem; font-weight: 600; color: #ffffff;">Daily Check-in</span>
                <span style="font-size: 0.8rem; color: #14b8a6; font-weight: 600;">${streakCount} Weekly Streak</span>
              </div>
              <div style="background: rgba(255,255,255,0.06); border-radius: 6px; overflow: hidden; height: 6px; margin-bottom: 10px;">
                <div style="height: 100%; width: ${Math.min(100, (streakCount / 7) * 100)}%; background: linear-gradient(90deg, #14b8a6, #22c55e); border-radius: 6px; transition: width 0.4s;"></div>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span style="font-size: 0.8rem; color: #94a3b8;">Daily Check-in</span>
                ${checkinAvailable
                  ? `<button data-action="checkin" style="background: #22c55e; color: #0a1628; font-weight: 700; padding: 6px 14px; border-radius: 8px; border: none; cursor: pointer; font-size: 0.8rem;">Claim KES 5</button>`
                  : `<span style="color: #4ade80; font-size: 0.8rem; font-weight: 700;">Check-in: Claimed</span>`
                }
              </div>
            </div>

            <!-- Copy Referral Link box -->
            <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.1); border-radius: 14px; padding: 16px;">
              <div style="font-size: 0.85rem; font-weight: 600; color: #ffffff; margin-bottom: 10px;">Copy Referral Link</div>
              <div style="display: flex; gap: 8px; align-items: center;">
                <div style="flex: 1; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; padding: 10px 14px; color: #94a3b8; font-size: 0.82rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${refLink}</div>
                <button data-action="copyReferralLink" style="width: 40px; height: 40px; background: #14b8a6; border: none; border-radius: 10px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #0a1628; flex-shrink: 0; transition: background 0.2s;">
                  ${icon('copy')}
                </button>
              </div>
            </div>
          </div>

        </div>

        <!-- BOTTOM: Referral Network -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px; overflow-x: auto;">
          <div style="margin-bottom: 6px;">
            <h2 style="margin: 0 0 4px; font-size: 1.15rem; font-weight: 700; color: white;">Referral Network</h2>
            <p style="margin: 0; color: var(--muted); font-size: 0.85rem;">Your Referral Program</p>
          </div>
          <table style="width: 100%; border-collapse: collapse; text-align: left; min-width: 500px; margin-top: 16px;">
            <thead>
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.06); color: var(--muted); font-size: 0.82rem; font-weight: 600;">
                <th style="padding: 10px 16px;">Referral Name</th>
                <th style="padding: 10px 16px;">Username</th>
                <th style="padding: 10px 16px;">Referral Date</th>
                <th style="padding: 10px 16px;">Commission Earned</th>
              </tr>
            </thead>
            <tbody>
              ${referredRowsHtml}
            </tbody>
          </table>
        </div>

      </div>

      <!-- MOBILE DASHBOARD OVERVIEW VIEW -->
      <div class="mobile-overview-view">
        <!-- Mobile Welcome + Stats -->
        <div style="padding: 16px; display: flex; flex-direction: column; gap: 14px;">
          <div style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07); border-radius: 14px; padding: 16px;">
            <div style="font-size: 0.95rem; font-weight: 700; color: white; margin-bottom: 12px;">Welcome, ${username}!</div>
            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
              <span style="background: rgba(34,197,94,0.15); border: 1px solid rgba(34,197,94,0.3); color: #4ade80; padding: 3px 10px; border-radius: 6px; font-weight: 700; font-size: 11px;">✔ VERIFIED</span>
              <span style="background: rgba(14,165,233,0.15); border: 1px solid rgba(14,165,233,0.3); color: #38bdf8; padding: 3px 10px; border-radius: 6px; font-weight: 700; font-size: 11px;">LEVEL 1 BEGINNER</span>
            </div>
          </div>

          <!-- Balance card -->
          <div style="background: rgba(20,184,166,0.1); border: 1px solid rgba(20,184,166,0.25); border-radius: 14px; padding: 16px;">
            <div style="font-size: 0.8rem; color: #94a3b8; margin-bottom: 4px;">Your Balance</div>
            <div style="font-size: 2rem; font-weight: 800; color: white; margin-bottom: 12px;">KES ${walletBalance}</div>
            <button data-action="withdrawMpesa" style="width:100%; background:#14b8a6; color:#0a1628; font-weight:800; padding:12px; border-radius:10px; border:none; font-size:15px; cursor:pointer;">
              Withdraw to M-Pesa
            </button>
            <p style="margin: 8px 0 0; text-align:center; color:rgba(255,255,255,0.45); font-size:0.75rem;">Minimum KES 150</p>
          </div>

          <!-- Daily Check-in -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 14px; padding: 16px;">
            <div style="font-size: 0.9rem; font-weight: 700; color: white; margin-bottom: 12px;">Daily Check-in</div>
            ${checkinAvailable
              ? `<button data-action="checkin" style="width:100%; background:#22c55e; color:#0a1628; font-weight:800; padding:12px; border-radius:10px; border:none; font-size:15px; cursor:pointer;">Claim KES 5</button>`
              : `<button disabled style="width:100%; background:rgba(255,255,255,0.05); color:rgba(255,255,255,0.2); font-weight:800; padding:12px; border-radius:10px; border:none; font-size:15px; cursor:not-allowed;">Claimed ✓</button>`
            }
          </div>

          <!-- Referral link -->
          <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 14px; padding: 16px;">
            <div style="font-size: 0.9rem; font-weight: 700; color: white; margin-bottom: 10px;">Your Referral Link</div>
            <div style="display: flex; gap: 8px; align-items: center;">
              <div style="flex:1; background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.1); border-radius:8px; padding:9px 12px; color:#94a3b8; font-size:0.78rem; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">${refLink}</div>
              <button data-action="copyReferralLink" style="width:38px;height:38px;background:#14b8a6;border:none;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#0a1628;flex-shrink:0;">
                ${icon('copy')}
              </button>
            </div>
          </div>

          <button data-action="dashTab" data-tab="market" style="background:#22c55e; color:#0a1628; font-weight:800; padding:14px; border-radius:30px; border:none; font-size:15px; cursor:pointer; margin-top:6px;">
            Explore Tasks
          </button>
        </div>
      </div>

    </div>
  `;
}

function marketplacePanel() {
  const allCategories = ["All", ...categories.map((category) => category.name)];
  const tasks = filteredTasks();
  const taskCount = tasks.length;
  const totalSlots = tasks.reduce((sum, t) => sum + (t.availableSlots || 0), 0);
  return `
    <div class="mp-header">
      <div class="mp-header-text">
        <h2>Task Marketplace</h2>
        <p>Browse and complete tasks to earn. Human-verified, quality-first micro-tasks.</p>
      </div>
      <div class="mp-header-stats">
        <div class="mp-stat-chip"><span>${taskCount}</span> Tasks</div>
        <div class="mp-stat-chip accent"><span>${totalSlots.toLocaleString("en-KE")}</span> Open slots</div>
      </div>
    </div>
    <section class="market-toolbar">
      <div class="search-box">
        ${icon("search")}
        <input placeholder="Search tasks, categories, crypto, design..." value="${escapeAttr(state.search)}" data-input="search" />
      </div>
      <div class="mp-filters-row">
        <select class="select-lite" data-input="sort">
          <option value="hot" ${state.sort === "hot" ? "selected" : ""}>Sort: Hot</option>
          <option value="reward-high" ${state.sort === "reward-high" ? "selected" : ""}>Highest payout</option>
          <option value="reward-low" ${state.sort === "reward-low" ? "selected" : ""}>Lowest payout</option>
          <option value="participants" ${state.sort === "participants" ? "selected" : ""}>Most participants</option>
          <option value="slots" ${state.sort === "slots" ? "selected" : ""}>Most available slots</option>
        </select>
        <select class="select-lite" data-input="filterDifficulty">
          <option value="all" ${state.filterDifficulty === "all" ? "selected" : ""}>Difficulty: All</option>
          ${DIFFICULTY_LEVELS.map(d => `<option value="${d}" ${state.filterDifficulty === d ? "selected" : ""}>${d}</option>`).join("")}
        </select>
        <select class="select-lite" data-input="filterDuration">
          <option value="all" ${state.filterDuration === "all" ? "selected" : ""}>Duration: All</option>
          ${DURATION_BUCKETS.map(d => `<option value="${d}" ${state.filterDuration === d ? "selected" : ""}>${d}</option>`).join("")}
        </select>
        <select class="select-lite" data-input="filterCountry">
          <option value="all" ${state.filterCountry === "all" ? "selected" : ""}>Country: All</option>
          ${TASK_COUNTRIES.map(c => `<option value="${c}" ${state.filterCountry === c ? "selected" : ""}>${c}</option>`).join("")}
        </select>
      </div>
    </section>
    <div class="category-strip">
      ${allCategories
        .map(
          (category) => `
            <button class="${state.activeCategory === category ? "is-active" : ""}" data-category="${escapeAttr(category)}">${category}</button>
          `,
        )
        .join("")}
    </div>
    <section class="task-grid">
      ${tasks.map(taskCard).join("") || `<div class="empty-state">${icon("search")} No matching tasks found. Try adjusting your filters.</div>`}
    </section>
  `;
}

function specialCategoriesPanel() {
  const task = specialTaskData();
  const unlocked = Boolean(profile.unlockedTasks[task.id]);
  return `
    <section class="special-panel" style="--g1:${task.glow[0]}; --g2:${task.glow[1]}">
      <div>
        <p class="section-kicker">CONTRACT JOBS</p>
        <h2>${task.category}</h2>
        <p>${escapeHtml(task.instruction)}</p>
        <div class="special-metrics">
          <span>${icon("coins")} Payout ${task.payoutLabel}</span>
          <span>${icon("badge-check")} Applications only</span>
          <span>${icon("clock-3")} Reviews: 6am to 11am daily</span>
        </div>
      </div>
      <button class="btn ${unlocked ? "btn-primary btn-glow" : "btn-ghost"}" data-action="openTask" data-task="${task.id}">
        ${icon(unlocked ? "external-link" : "lock-keyhole")}
        <span>${unlocked ? "Open Application" : "Unlock Application"}</span>
      </button>
    </section>
  `;
}

function ecosystemPanel() {
  const links = globalConfig.ecosystemLinks || (typeof defaultEcosystemLinks !== 'undefined' ? defaultEcosystemLinks : []);
  return `
    <section class="dash-panel">
      <div class="panel-head">
        <div>
          <p class="section-kicker">ECOSYSTEM</p>
          <h2>TASKBRIDGE platforms</h2>
        </div>
        ${isAdmin() ? `<button class="text-btn" data-tab="admin" data-admin-target="ecosystem">Edit platforms</button>` : ""}
      </div>
      <div class="ecosystem-grid">
        ${
          links.length
            ? links.map(ecosystemCard).join("")
            : `<div class="empty-state">Platforms will appear here after admin adds them.</div>`
        }
      </div>
    </section>
  `;
}

function ecosystemCard(item) {
  const url = String(item.url || "").trim();
  return `
    <article class="ecosystem-card">
      <span>${icon("globe-2")}</span>
      <div>
        <h3>${escapeHtml(item.title)}</h3>
        <p>${escapeHtml(item.description || "TASKBRIDGE ecosystem platform.")}</p>
      </div>
      ${
        url
          ? `<a class="btn btn-primary btn-small" href="${escapeAttr(url)}" target="_blank" rel="noreferrer">${icon("external-link")} Open</a>`
          : `<button class="btn btn-ghost btn-small" disabled>${icon("lock-keyhole")} Coming Soon</button>`
      }
    </article>
  `;
}

function filteredTasks() {
  const term = state.search.trim().toLowerCase();
  let tasks = taskSeed().filter((task) => {
    const hasContent = !!task.contentPayload;
    if (!hasContent) return false;
    
    const categoryMatch = state.activeCategory === "All" || task.category === state.activeCategory;
    const textMatch = !term || `${task.title} ${task.category} ${task.instruction}`.toLowerCase().includes(term);
    const diffMatch = state.filterDifficulty === "all" || task.difficulty === state.filterDifficulty;
    const durMatch = state.filterDuration === "all" || task.estimatedTime === state.filterDuration;
    const countryMatch = state.filterCountry === "all" || task.country === state.filterCountry;
    const levelMatch = state.filterLevel === "all" || task.workerLevel === state.filterLevel;
    
    return categoryMatch && textMatch && diffMatch && durMatch && countryMatch && levelMatch;
  });
  if (state.sort === "reward-high") tasks = tasks.sort((a, b) => b.reward - a.reward);
  if (state.sort === "reward-low") tasks = tasks.sort((a, b) => a.reward - b.reward);
  if (state.sort === "participants") tasks = tasks.sort((a, b) => b.participants - a.participants);
  if (state.sort === "slots") tasks = tasks.sort((a, b) => (b.availableSlots || 0) - (a.availableSlots || 0));
  if (state.sort === "hot") tasks = tasks.sort((a, b) => Number(b.badge === "HOT") - Number(a.badge === "HOT"));
  return tasks.slice(0, 80);
}

function difficultyColor(d) {
  if (d === "Beginner") return { bg: "rgba(34,197,94,0.12)", text: "#4ade80", border: "rgba(34,197,94,0.25)" };
  if (d === "Intermediate") return { bg: "rgba(59,130,246,0.12)", text: "#60a5fa", border: "rgba(59,130,246,0.25)" };
  if (d === "Advanced") return { bg: "rgba(245,158,11,0.12)", text: "#fbbf24", border: "rgba(245,158,11,0.25)" };
  return { bg: "rgba(239,68,68,0.12)", text: "#f87171", border: "rgba(239,68,68,0.25)" };
}

function taskCard(task) {
  const unlocked = Boolean(profile.unlockedTasks[task.id] || isAdmin());
  const submitted = profile.submissions.find((submission) => submission.taskId === task.id);
  const cta = submitted ? "View Details" : unlocked ? "Start Assignment" : "Start Task";
  const ctaIcon = submitted ? "eye" : unlocked ? "play-circle" : "arrow-right";
  const dc = difficultyColor(task.difficulty || "Beginner");
  const badgeClass = task.badge === "HOT" ? "badge-hot" : task.badge === "DISCOUNT" ? "badge-discount" : "badge-new";
  return `
    <article class="task-card" style="--g1:${task.glow[0]}; --g2:${task.glow[1]}">
      <div class="task-thumb" style="background-image: linear-gradient(135deg, rgba(5,8,22,.55), rgba(37,99,235,.32)), url('${task.image}')">
        <div class="task-thumb-top">
          <span class="task-icon-chip">${icon(task.icon)}</span>
          <b class="task-badge ${badgeClass}">${task.badge}</b>
        </div>
        <div class="task-reward-chip">
          ${icon("coins")} <strong>${payoutText(task)}</strong>
        </div>
      </div>
      <div class="task-body">
        <div class="task-meta">
          <span>${task.category}</span>
          ${task.verificationRequired ? `<span class="verified-tag">${icon("shield-check")} Verified</span>` : ""}
        </div>
        <h3>${task.title}</h3>
        <p class="line-clamp-desc">${task.instruction}</p>
        <div class="task-chips">
          <span class="task-chip" style="background:${dc.bg}; color:${dc.text}; border-color:${dc.border}">${task.difficulty || "Beginner"}</span>
          <span class="task-chip">${icon("clock-3")} ${task.estimatedTime || "10–20 min"}</span>
          <span class="task-chip">${icon("target")} ${task.requiredAccuracy || 85}%</span>
          <span class="task-chip">${icon("map-pin")} ${task.country || "Global"}</span>
        </div>
        <div class="task-foot">
          <span>${icon("users")} ${task.participants.toLocaleString("en-KE")}</span>
          <span>${icon("layers")} ${(task.availableSlots || 100).toLocaleString("en-KE")} slots</span>
          <span>${icon("list-checks")} ${task.questionCount || 10} Qs</span>
        </div>
        <div style="display: flex; gap: 8px;">
          <button class="btn ${submitted ? "btn-outline-success" : unlocked ? "btn-primary" : "btn-ghost"} btn-wide" style="flex:1;" data-action="openTask" data-task="${task.id}">
            ${icon(ctaIcon)}
            <span>${cta}</span>
          </button>
          <button class="btn btn-ghost" style="flex:0 0 auto; padding: 0 12px;" onclick="const url = window.location.origin + '/?action=signup'; const text = 'Check out this Task on TaskBridge: ${task.title}. Log in or sign up to view and apply.\\n' + url; navigator.share ? navigator.share({title: '${task.title}', text, url}) : (navigator.clipboard.writeText(text), alert('Link copied to clipboard!')); event.stopPropagation();">
            ${icon("share")}
          </button>
        </div>
        ${isAdmin() ? `
          <div style="display: flex; gap: 8px; margin-top: 8px;">
            <button class="btn btn-ghost btn-small" style="flex:1;" data-action="editTask" data-task="${task.id}">${icon("pencil")} Edit</button>
            <button class="btn btn-ghost btn-small" style="flex:1; color: #f87171;" data-action="deleteTask" data-task="${task.id}">${icon("trash-2")} Remove</button>
          </div>
        ` : ""}
      </div>
    </article>
  `;
}

function taskDetailView() {
  if (!profile.active) return accessView();
  const task = getTask(state.selectedTaskId);
  const unlocked = Boolean(profile.verifiedWorker || profile.unlockedTasks[task.id]);
  const submissions = profile.submissions.filter((submission) => submission.taskId === task.id);
  
  if (task.special) {
    return `
      <section class="dashboard-page detail-page">
        <main class="dashboard-main detail-main">
          <button class="btn btn-ghost btn-small" data-action="dashboard" data-tab="special" style="margin-bottom: 20px;">${icon("arrow-left")} Back to Special Categories</button>
          <div class="detail-hero" style="--g1:${task.glow ? task.glow[0] : '#3b82f6'}; --g2:${task.glow ? task.glow[1] : '#10b981'}; background: linear-gradient(135deg, rgba(37,99,235,0.1), rgba(16,185,129,0.05)); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 32px; display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
            <div style="max-width: 700px;">
              <p class="section-kicker" style="color: var(--blue-2); font-weight: 900; letter-spacing: 1px; margin-bottom: 12px;">CONTRACT JOBS</p>
              <h1 style="font-size: clamp(1.8rem, 3vw, 2.4rem); margin: 0 0 12px; font-weight: 950; line-height: 1.2;">${task.title}</h1>
              <p style="color: var(--muted); font-size: 1.05rem; line-height: 1.6; margin: 0;">${escapeHtml(task.instruction)}</p>
            </div>
            <div style="background: rgba(5,8,22,0.6); padding: 20px; border-radius: 16px; border: 1px solid rgba(255,255,255,0.1); min-width: 220px; text-align: right; flex-shrink: 0;">
              <span style="color: var(--muted); font-size: 0.85rem; font-weight: 800; text-transform: uppercase;">Payout</span>
              <strong style="display: block; font-size: 1.8rem; color: #4ade80; margin: 4px 0 0;">${task.payoutLabel}</strong>
            </div>
          </div>
          <div class="grid-two" style="margin-top: 24px; gap: 24px; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));">
            <section class="dash-panel" style="padding: 24px;">
              <div class="panel-head" style="margin-bottom: 20px;">
                <h2 style="font-size: 1.3rem;">${unlocked ? "Application instructions" : "Unlock this Application"}</h2>
                <span class="status-pill" style="${unlocked ? 'color:#4ade80;background:rgba(34,197,94,0.1)' : 'color:#fbbf24;background:rgba(251,191,36,0.1)'}">${unlocked ? "Unlocked" : "Locked"}</span>
              </div>
              ${
                unlocked
                  ? specialApplicationPanel(task)
                  : unlockPanel(task)
              }
            </section>
            <section class="dash-panel" style="padding: 24px;">
              <h2 style="font-size: 1.1rem; margin-bottom: 16px;">Category details</h2>
              <div class="detail-list" style="display: flex; flex-direction: column; gap: 12px;">
                <div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("badge-check")}</span> ${REVIEW_WINDOW_TEXT}</div>
                <div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("coins")}</span> Payout: ${task.payoutLabel}</div>
                <div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("shield")}</span> Only Admin can edit details</div>
              </div>
            </section>
          </div>
        </main>
      </section>
    `;
  }

  return `
    <section class="dashboard-page detail-page">
      <main class="dashboard-main detail-main">
        <button class="btn btn-ghost btn-small" data-action="dashboard" data-tab="market" style="margin-bottom: 20px;">${icon("arrow-left")} Back to Marketplace</button>
        
        <div class="detail-hero" style="--g1:${task.glow ? task.glow[0] : '#3b82f6'}; --g2:${task.glow ? task.glow[1] : '#10b981'}; background: linear-gradient(135deg, rgba(37,99,235,0.1), rgba(16,185,129,0.05)); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 32px; display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
          <div style="max-width: 700px;">
            <div style="display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap;">
              <span class="task-chip">${icon("folder")} ${task.category}</span>
              <span class="task-chip">${icon("bar-chart")} Level ${task.level || '1'}</span>
              <span class="task-chip">${icon("map-pin")} ${task.country || 'Global'}</span>
            </div>
            <h1 style="font-size: clamp(1.8rem, 3vw, 2.4rem); margin: 0 0 12px; font-weight: 950; line-height: 1.2;">${task.title}</h1>
            <p style="color: var(--muted); font-size: 1.05rem; line-height: 1.6; margin: 0;">${task.instruction}</p>
          </div>
          <div style="background: rgba(5,8,22,0.6); padding: 20px; border-radius: 16px; border: 1px solid rgba(255,255,255,0.1); min-width: 220px; text-align: right; flex-shrink: 0;">
            <span style="color: var(--muted); font-size: 0.85rem; font-weight: 800; text-transform: uppercase;">Task Reward</span>
            <strong style="display: block; font-size: 1.8rem; color: #4ade80; margin: 4px 0 12px;">${payoutText(task)}</strong>
            <div style="display: flex; flex-direction: column; gap: 8px; text-align: left; font-size: 0.85rem; color: var(--muted);">
               <div style="display: flex; justify-content: space-between;"><span>Time:</span> <strong style="color: white;">${task.estimatedTime || '15 mins'}</strong></div>
               <div style="display: flex; justify-content: space-between;"><span>Slots:</span> <strong style="color: white;">${task.slots || 'Unlimited'}</strong></div>
            </div>
          </div>
        </div>

        <div class="grid-two" style="margin-top: 24px; gap: 24px; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));">
          <section class="dash-panel" style="padding: 24px; grid-column: span 2;">
            <div class="panel-head" style="margin-bottom: 20px;">
              <h2 style="font-size: 1.3rem;">${unlocked ? "Task Workspace" : "Verification Required"}</h2>
              <span class="status-pill" style="${unlocked ? 'color:#4ade80;background:rgba(34,197,94,0.1)' : 'color:#fbbf24;background:rgba(251,191,36,0.1)'}">${unlocked ? "Workspace Unlocked" : "Locked"}</span>
            </div>
            ${
              unlocked
                ? assignmentForm(task, submissions)
                : unlockPanel(task)
            }
          </section>
          
          <aside style="display: flex; flex-direction: column; gap: 24px; grid-column: span 1;">
            <section class="dash-panel" style="padding: 24px;">
              <h2 style="font-size: 1.1rem; margin-bottom: 16px;">Requirements & Quality</h2>
              <div class="detail-list" style="display: flex; flex-direction: column; gap: 12px;">
                <div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("check-circle")}</span> Minimum ${task.accuracy || '90'}% Accuracy</div>
                <div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("check-circle")}</span> Stable Internet Connection</div>
                <div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("badge-check")}</span> ${REVIEW_WINDOW_TEXT}</div>
                ${task.badge ? `<div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem; color: var(--muted);"><span style="color:var(--blue-2);">${icon("tag")}</span> ${task.badge} opportunity</div>` : ""}
                ${unlocked && task.externalLink ? `<div style="display: flex; gap: 10px; align-items: center; font-size: 0.9rem;"><span style="color:var(--blue-2);">${icon("external-link")}</span> <a href="${escapeAttr(task.externalLink)}" target="_blank" rel="noreferrer" style="color: #60a5fa;">External Application Link</a></div>` : ""}
              </div>
            </section>
            
            <section class="dash-panel" style="padding: 24px;">
              <h2 style="font-size: 1.1rem; margin-bottom: 16px;">Your Submissions</h2>
              ${submissions.length ? submissionList("user", 10, task.id) : `<p class="muted" style="margin: 0; font-size: 0.9rem;">No submissions yet. Complete the workspace to submit.</p>`}
            </section>
          </aside>
        </div>
      </main>
    </section>
  `;
}

function unlockPanel(task) {
  if (!task.contentPayload) {
    return `
      <div class="pay-card" style="text-align: center; max-width: 480px; margin: 0 auto; padding: 32px 20px;">
        <h3 style="color: #f87171;">Task Unavailable</h3>
        <p style="color: var(--muted); margin-bottom: 24px;">This task does not have any content attached and cannot be started.</p>
        <button class="btn btn-primary" onclick="setRoute('dashboard')">Return to Tasks</button>
      </div>
    `;
  }
  return `
    <div class="pay-card" style="text-align: center; max-width: 480px; margin: 0 auto; padding: 32px 20px;">
      <div style="width: 64px; height: 64px; border-radius: 50%; background: rgba(59,130,246,0.1); border: 1px solid rgba(59,130,246,0.2); display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; color: #60a5fa;">
        ${icon("shield-check")}
      </div>
      <h3 style="font-size: 1.5rem; margin: 0 0 12px;">Human Verification Required</h3>
      <p style="color: var(--muted); font-size: 0.95rem; line-height: 1.6; margin: 0 0 24px;">
        To maintain platform quality and prevent bots, we require a one-time human verification. This unlocks your workspace and grants lifetime access to premium tasks.
      </p>
      
      <div style="background: rgba(34,197,94,0.08); border: 1px solid rgba(34,197,94,0.2); padding: 16px; border-radius: 16px; margin-bottom: 24px; text-align: left;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid rgba(34,197,94,0.2);">
          <span style="color: #4ade80; font-weight: 800;">Verification Fee</span>
          <strong style="color: white; font-size: 1.3rem;">KES 9</strong>
        </div>
        <ul style="margin: 0; padding-left: 20px; color: var(--text); font-size: 0.88rem; line-height: 1.8;">
          <li><strong style="color: white;">Lifetime Access</strong> to premium paying tasks</li>
          <li><strong style="color: white;">Verified Worker</strong> badge on your profile</li>
          <li><strong style="color: white;">Faster</strong> task approvals and priority support</li>
        </ul>
      </div>

      <form class="glass-form" data-form="taskPayment" data-task="${task.id}">
        <div class="field" style="text-align: left;">
          <label for="taskPayPhone">M-Pesa Number</label>
          <input class="input" id="taskPayPhone" name="payPhone" inputmode="tel" required value="${escapeAttr(profile.phone)}" placeholder="e.g. 0712345678" style="background: rgba(5,8,22,0.6);" />
        </div>
        <p class="muted" style="font-size: 0.8rem; margin: 12px 0;">KES 9 will be deducted via STK push.</p>
        <button class="btn btn-primary btn-glow btn-wide" type="submit" style="height: 54px; font-size: 1.05rem;">${icon("fingerprint")} VERIFY & UNLOCK WORKSPACE</button>
      </form>
    </div>
  `;
}

function renderContentViewer(task) {
  if (!task.contentPayload) return '';
  const type = task.contentType || 'text';
  const payload = task.contentPayload;
  
  let html = `<div style="background: rgba(15,23,42,0.6); border: 1px solid var(--border); border-radius: 12px; padding: 16px; margin-bottom: 16px;">`;
  html += `<h4 style="margin: 0 0 12px; color: #cbd5e1; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.5px;">Task Content</h4>`;
  
  if (type === 'conversation') {
    html += `<div style="display: flex; flex-direction: column; gap: 12px; max-height: 400px; overflow-y: auto; padding-right: 8px;">`;
    payload.forEach(msg => {
      const isUser = msg.role === 'user';
      html += `
        <div style="display: flex; flex-direction: column; align-items: ${isUser ? 'flex-end' : 'flex-start'};">
          <div style="background: ${isUser ? 'rgba(59,130,246,0.2)' : 'rgba(255,255,255,0.05)'}; border: 1px solid ${isUser ? 'rgba(59,130,246,0.3)' : 'rgba(255,255,255,0.1)'}; padding: 12px 16px; border-radius: 12px; max-width: 85%;">
            <div style="font-size: 0.75rem; color: ${isUser ? '#93c5fd' : '#94a3b8'}; margin-bottom: 4px; font-weight: 600; text-transform: uppercase;">${msg.role} <span style="font-weight: 400; opacity: 0.7; margin-left: 6px;">${msg.timestamp || ''}</span></div>
            <div style="color: #f1f5f9; font-size: 0.95rem; line-height: 1.5;">${escapeHtml(msg.text)}</div>
          </div>
        </div>
      `;
    });
    html += `</div>`;
  } else if (type === 'image') {
    html += `<div style="text-align: center;"><img src="${escapeAttr(payload)}" style="max-width: 100%; max-height: 400px; border-radius: 8px; border: 1px solid var(--border);" /></div>`;
  } else if (type === 'audio') {
    html += `<audio controls src="${escapeAttr(payload)}" style="width: 100%; border-radius: 8px;"></audio>`;
  } else if (type === 'video') {
    html += `<video controls src="${escapeAttr(payload)}" style="width: 100%; max-height: 400px; border-radius: 8px; background: black;"></video>`;
  } else {
    html += `<div style="background: rgba(0,0,0,0.3); padding: 16px; border-radius: 8px; color: #f1f5f9; font-size: 0.95rem; line-height: 1.6; white-space: pre-wrap;">${escapeHtml(String(payload))}</div>`;
  }
  
  html += `</div>`;
  return html;
}

function renderAnswerTemplate(task, savedContent) {
  const tpl = task.answerTemplate || 'text_response';
  const schema = task.answerSchema || {};
  let html = `<div class="field"><label style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;"><span style="font-size: 1.05rem; color: white;">Your Response</span><span class="workspace-save-status" style="font-size: 0.7rem; color: #4ade80; font-weight: 800; background: rgba(34,197,94,0.1); padding: 4px 8px; border-radius: 6px;">● ${savedContent ? 'Restored Draft' : 'Autosaving'}</span></label>`;
  
  let savedObj = {};
  if (savedContent && typeof savedContent === 'string' && savedContent.startsWith('{')) {
    try { savedObj = JSON.parse(savedContent); } catch(e){}
  } else if (savedContent && typeof savedContent === 'string') {
    savedObj = { answer: savedContent };
  }
  
  switch(tpl) {
    case 'yes_no':
      html += `
        <div style="display: flex; gap: 16px;">
          <label style="flex: 1; cursor: pointer; background: rgba(255,255,255,0.05); padding: 16px; border-radius: 8px; border: 1px solid var(--border); text-align: center; font-weight: 600;">
            <input type="radio" name="answer" value="Yes" ${savedObj.answer === 'Yes' ? 'checked' : ''} required /> Yes
          </label>
          <label style="flex: 1; cursor: pointer; background: rgba(255,255,255,0.05); padding: 16px; border-radius: 8px; border: 1px solid var(--border); text-align: center; font-weight: 600;">
            <input type="radio" name="answer" value="No" ${savedObj.answer === 'No' ? 'checked' : ''} required /> No
          </label>
        </div>`;
      break;
    case 'multiple_choice':
    case 'radio_buttons':
      const opts = schema.options || ['Option A', 'Option B'];
      html += `<div style="display: flex; flex-direction: column; gap: 8px;">`;
      opts.forEach(opt => {
        html += `<label style="display: flex; align-items: center; gap: 12px; cursor: pointer; background: rgba(255,255,255,0.03); padding: 12px 16px; border-radius: 8px; border: 1px solid var(--border);">
          <input type="radio" name="answer" value="${escapeAttr(opt)}" ${savedObj.answer === opt ? 'checked' : ''} required />
          <span>${escapeHtml(opt)}</span>
        </label>`;
      });
      html += `</div>`;
      break;
    case 'rating':
      html += `
        <div style="display: flex; align-items: center; gap: 8px; font-size: 2rem; color: #fbbf24;">
          ${[1,2,3,4,5].map(n => `<label style="cursor: pointer;"><input type="radio" name="answer" value="${n}" style="display:none;" required ${savedObj.answer == n ? 'checked' : ''}/>★</label>`).join('')}
        </div>
        <p style="font-size: 0.8rem; color: var(--muted); margin-top: 8px;">Select 1 to 5 stars.</p>
      `;
      break;
    case 'custom_dynamic_form':
      const fields = schema.fields || [];
      html += `<div style="display: flex; flex-direction: column; gap: 16px;">`;
      fields.forEach(f => {
        const val = savedObj[f.name] || '';
        html += `<div class="field" style="margin-bottom: 0;">
          <label style="font-size: 0.9rem; margin-bottom: 6px;">${escapeHtml(f.label)}</label>`;
        if (f.type === 'select') {
          html += `<select name="custom_${escapeAttr(f.name)}" class="input" ${f.required ? 'required' : ''}>
            <option value="">-- Select --</option>
            ${(f.options||[]).map(o => `<option value="${escapeAttr(o)}" ${val === o ? 'selected' : ''}>${escapeHtml(o)}</option>`).join('')}
          </select>`;
        } else if (f.type === 'number') {
          html += `<input type="number" name="custom_${escapeAttr(f.name)}" class="input" min="${f.min||0}" max="${f.max||100}" value="${escapeAttr(val)}" ${f.required ? 'required' : ''} />`;
        } else {
          html += `<input type="text" name="custom_${escapeAttr(f.name)}" class="input" value="${escapeAttr(val)}" ${f.required ? 'required' : ''} />`;
        }
        html += `</div>`;
      });
      html += `</div>`;
      break;
    case 'bounding_box':
    case 'polygon':
    case 'highlight_text':
    case 'map_pin':
      html += `<div style="background: rgba(59,130,246,0.05); border: 1px dashed #60a5fa; padding: 24px; border-radius: 12px; text-align: center;">
        <div style="color: #60a5fa; margin-bottom: 8px;">${icon("edit")}</div>
        <div style="font-weight: 600; margin-bottom: 4px;">Interactive Annotation Mode Active</div>
        <div style="font-size: 0.85rem; color: var(--muted); margin-bottom: 16px;">Please use the canvas overlay in the content viewer to draw ${tpl.replace('_', ' ')}s.</div>
        <input type="hidden" name="answer" value="[Annotated Data]" required />
      </div>`;
      break;
    case 'code_editor':
      html += `<textarea class="textarea" name="answer" required placeholder="Write your code here..." style="font-family: monospace; background: #0f172a; color: #38bdf8; min-height: 250px;">${escapeHtml(savedObj.answer||'')}</textarea>`;
      break;
    case 'spreadsheet':
      html += `<textarea class="textarea" name="answer" required placeholder="CSV format (Col1, Col2, Col3...)" style="font-family: monospace; min-height: 150px;">${escapeHtml(savedObj.answer||'')}</textarea>`;
      break;
    default:
      html += `<textarea class="textarea" id="answer" name="answer" required placeholder="Type your comprehensive response..." style="min-height: 200px; background: rgba(0,0,0,0.2); font-size: 0.95rem; line-height: 1.6;">${escapeHtml(savedObj.answer || savedContent)}</textarea>`;
  }
  
  html += `</div>`;
  
  if (['image_upload', 'video_upload', 'audio_recorder', 'file_upload'].includes(tpl) || !schema.fields) {
    const isRequired = ['image_upload', 'video_upload', 'audio_recorder', 'file_upload'].includes(tpl) ? 'required' : '';
    html += `
      <div class="field" style="background: rgba(5,8,22,0.4); border: 1px dashed var(--border); border-radius: 12px; padding: 20px; margin-top: 16px;">
        <label for="assignmentFile" style="margin-bottom: 12px;">Attach Evidence ${isRequired ? '' : '(Optional)'}</label>
        <input class="input file-input" id="assignmentFile" name="assignmentFile" type="file" ${isRequired} />
        <p style="color: var(--muted); margin: 8px 0 0; font-size: 0.8rem;">Supported formats: .jpg, .png, .pdf, .csv (Max 5MB).</p>
      </div>
    `;
  }
  
  return html;
}

function assignmentForm(task, submissions) {
  const pending = submissions.some((submission) => submission.status === "pending");
  
  // Load draft from localStorage if available
  let savedContent = "";
  try {
    const draftStr = localStorage.getItem(`taskbridge_draft_${task.id}`);
    if (draftStr) {
      const draft = JSON.parse(draftStr);
      savedContent = draft.content || "";
    }
  } catch (e) {}

  return `
    <div class="assignment-box" style="display: flex; flex-direction: column; gap: 20px;">
      <div class="info-box" style="background: rgba(96,165,250,0.08); border-color: rgba(96,165,250,0.2); padding: 16px; border-radius: 12px; display: flex; gap: 12px; align-items: flex-start;">
        <span style="color: #60a5fa; margin-top: 2px;">${icon("clock")}</span>
        <div>
          <strong style="display: block; color: white; margin-bottom: 4px;">Workspace Active</strong>
          <p style="margin: 0; font-size: 0.88rem; color: var(--muted); line-height: 1.5;">Time tracking started. Read the instructions carefully and complete all required fields. Your work is autosaved locally.</p>
        </div>
      </div>
      
      ${
        pending
          ? `
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 48px 20px; background: rgba(5,8,22,0.4); border: 1px dashed rgba(74,222,128,0.3); border-radius: 16px;">
              <div style="width: 80px; height: 80px; border-radius: 50%; background: rgba(34,197,94,0.1); border: 2px solid rgba(34,197,94,0.3); color: #4ade80; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; box-shadow: 0 0 40px rgba(34,197,94,0.2);">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
              </div>
              <h3 style="font-size: 1.6rem; color: white; margin: 0 0 12px;">Submission Successful!</h3>
              <p style="color: var(--muted); font-size: 1.05rem; max-width: 400px; margin: 0 0 24px; line-height: 1.5;">Your workspace data has been securely saved and submitted for review.</p>
              
              <div style="background: rgba(59,130,246,0.08); border: 1px solid rgba(59,130,246,0.2); padding: 16px; border-radius: 12px; max-width: 480px; text-align: left;">
                <h4 style="color: #60a5fa; margin: 0 0 8px; font-size: 0.95rem; display: flex; align-items: center; gap: 8px;">${icon("clock")} Review Process</h4>
                <p style="margin: 0; color: var(--text); font-size: 0.88rem; line-height: 1.6;">
                  Admin review is currently <strong>in progress</strong>. ${REVIEW_WINDOW_TEXT} Once approved, your wallet will be credited instantly and you'll receive an email notification.
                </p>
              </div>
              
              <div style="margin-top: 32px; display: flex; gap: 16px;">
                <button class="btn btn-ghost" onclick="setRoute('dashboard', {tab: 'market'})">Browse More Tasks</button>
                <button class="btn btn-outline-success" onclick="setRoute('dashboard', {tab: 'tasks'})">View My Submissions</button>
              </div>
            </div>
          `
          : `
            <form data-form="assignment" data-task="${task.id}" style="display: flex; flex-direction: column; gap: 20px;">
              ${renderContentViewer(task)}
              
              <div class="workspace-template" style="background: rgba(5,8,22,0.4); border: 1px solid var(--border); border-radius: 12px; padding: 20px;">
                ${renderAnswerTemplate(task, savedContent)}
              </div>
              
              <div style="display: flex; gap: 12px; margin-top: 12px;">
                <button class="btn btn-ghost" type="button" style="flex: 1;" onclick="setRoute('dashboard')">${icon("x")} Cancel</button>
                <button class="btn btn-primary btn-glow" type="submit" style="flex: 2; height: 52px; font-size: 1.05rem;">${icon("send")} Submit for Review</button>
              </div>
            </form>
          `
      }
    </div>
  `;
}

function specialApplicationPanel(task) {
  return `
    <div class="assignment-box">
      <p>${escapeHtml(task.instruction)}</p>
      <div class="info-box">
        ${icon("clock-3")}
        <p>${REVIEW_WINDOW_TEXT} Admin will review applications and distribute payouts during this window.</p>
      </div>
      ${
        task.externalLink
          ? `<a class="btn btn-primary btn-glow btn-wide" href="${escapeAttr(task.externalLink)}" target="_blank" rel="noreferrer">${icon("external-link")} Apply Now</a>`
          : `<button class="btn btn-ghost btn-wide" disabled>${icon("lock-keyhole")} Application link coming soon</button>`
      }
    </div>
  `;
}

// ── Jobs & Opportunities Panel ──────────────────────────────────────────────
async function showJobDetails(jobId) {
  const job = allOpportunities.find(o => o.id === jobId);
  if (!job) return;

  let overlay = document.querySelector('.payment-modal-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'payment-modal-overlay';
    document.body.appendChild(overlay);
  }

  const days = daysUntilDeadline(job.deadline);
  const dlText = days === 0 ? "Closes today!" :
                 days === 1 ? "Closes tomorrow" :
                 days < 0 ? "Closed" :
                 `Closes in ${days} days`;
  const isUrgent = days <= 5;

  overlay.innerHTML = `
    <div class="job-details-modal-card">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 16px;">
        <div style="display: flex; gap: 14px; align-items: center;">
          <div style="width: 52px; height: 52px; border-radius: 12px; background: ${job.orgColor?.bg || 'rgba(255,255,255,0.05)'}; color: ${job.orgColor?.text || 'white'}; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 1.25rem;">
            ${escapeHtml(job.orgShort || '')}
          </div>
          <div>
            <h3 style="margin: 0; color: white; font-size: 1.25rem; font-weight: 800;">${escapeHtml(job.title)}</h3>
            <p style="margin: 4px 0 0; color: var(--muted); font-size: 0.9rem; display: flex; align-items: center; gap: 6px;">
              ${escapeHtml(job.organization)}
              ${job.verified ? `<span style="color: #4ade80; display: inline-flex;">${icon('badge-check')}</span>` : ''}
            </p>
          </div>
        </div>
        <button onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')" style="background: none; border: none; color: var(--muted); cursor: pointer; font-size: 1.75rem; line-height: 1; padding: 0 4px;">&times;</button>
      </div>

      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 16px; margin: 8px 0; padding: 12px; background: rgba(255,255,255,0.02); border-radius: 12px; border: 1px solid rgba(255,255,255,0.05); font-size: 0.85rem;">
        <div><strong style="color: white; display:block; margin-bottom: 2px;">Location</strong> ${escapeHtml(job.location)}</div>
        <div><strong style="color: white; display:block; margin-bottom: 2px;">Salary / Stipend</strong> ${escapeHtml(job.salary)}</div>
        <div><strong style="color: white; display:block; margin-bottom: 2px;">Deadline</strong> <span style="${isUrgent ? 'color: #fb923c; font-weight: 700;' : ''}">${dlText}</span></div>
        <div><strong style="color: white; display:block; margin-bottom: 2px;">Type</strong> ${escapeHtml(job.type)}</div>
      </div>

      <div style="max-height: 40vh; overflow-y: auto; padding-right: 8px; display: flex; flex-direction: column; gap: 16px;">
        <div>
          <h4 style="margin: 0 0 6px; color: white;">About the Role</h4>
          <p>${escapeHtml(job.description)}</p>
        </div>
        <div>
          <h4 style="margin: 0 0 6px; color: white;">Requirements & Qualifications</h4>
          <ul style="margin: 0; padding-left: 20px;">
            ${job.requirements.map(req => `<li>${escapeHtml(req)}</li>`).join("")}
          </ul>
        </div>
        <div>
          <h4 style="margin: 0 0 6px; color: white;">Duties & Responsibilities</h4>
          <ul style="margin: 0; padding-left: 20px;">
            ${job.duties.map(duty => `<li>${escapeHtml(duty)}</li>`).join("")}
          </ul>
        </div>
        <div style="background: rgba(37,99,235,0.05); border: 1px solid rgba(37,99,235,0.15); border-radius: 12px; padding: 16px;">
          <h4 style="margin: 0 0 8px; color: #93c5fd; display: flex; align-items: center; gap: 6px;">
            ${icon('info')} How to Apply
          </h4>
          <ol style="margin: 0; padding-left: 20px;">
            ${job.howToApply.map(step => `<li>${escapeHtml(step)}</li>`).join("")}
          </ol>
        </div>
      </div>

      <div style="display: flex; gap: 12px; justify-content: flex-end; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 16px; margin-top: 8px;">
        ${isAdmin() ? `<button class="btn btn-ghost" style="color: #f87171; border-color: rgba(248,113,113,0.2); display: inline-flex; align-items: center; gap: 6px;" onclick="deleteJobListing('${job.id}')">${icon('trash-2')} Delete Job</button>` : ''}
        <button class="btn btn-ghost" onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')">Close</button>
        <button class="btn btn-primary" onclick="showJobApplyForm('${job.id}')" style="display: inline-flex; align-items: center; gap: 6px; background: #2563eb; color: white;">
          ${icon('pencil')} Apply Now
        </button>
      </div>
    </div>
  `;

  overlay.classList.add('is-active');
  refreshIcons();
}

window.showJobApplyForm = (jobId) => {
  const job = allOpportunities.find(o => o.id === jobId);
  if (!job) return;

  const card = document.querySelector('.job-details-modal-card');
  if (!card) return;

  card.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; margin-bottom: 12px;">
      <h3 style="margin: 0; color: white; font-size: 1.25rem;">Apply for ${escapeHtml(job.title)}</h3>
      <button onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')" style="background: none; border: none; color: var(--muted); cursor: pointer; font-size: 1.75rem; line-height: 1; padding: 0 4px;">&times;</button>
    </div>
    <form id="job-apply-form" style="display: flex; flex-direction: column; gap: 12px;" onsubmit="event.preventDefault(); handleJobApplySubmit('${job.id}')">
      <div style="display: flex; flex-direction: column; gap: 4px;">
        <label style="color: var(--muted); font-size: 0.85rem;">Full Name</label>
        <input class="input" type="text" id="app-name" required value="${escapeAttr(profile.name || '')}" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
      </div>

      <div style="display: flex; flex-direction: column; gap: 4px;">
        <label style="color: var(--muted); font-size: 0.85rem;">Email Address</label>
        <input class="input" type="email" id="app-email" required value="${escapeAttr(profile.email || '')}" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
      </div>

      <div style="display: flex; flex-direction: column; gap: 4px;">
        <label style="color: var(--muted); font-size: 0.85rem;">Phone Number (M-Pesa)</label>
        <input class="input" type="tel" id="app-phone" required value="${escapeAttr(profile.phone || '')}" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
      </div>

      <div style="display: flex; flex-direction: column; gap: 4px;">
        <label style="color: var(--muted); font-size: 0.85rem;">Cover Letter / Pitch</label>
        <textarea class="textarea" id="app-cover" required placeholder="Why are you a good fit for this job?" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white; min-height: 80px; resize: vertical;"></textarea>
      </div>

      <div style="display: flex; flex-direction: column; gap: 4px;">
        <label style="color: var(--muted); font-size: 0.85rem;">CV / Portfolio URL</label>
        <input class="input" type="url" id="app-portfolio" placeholder="Link to Google Drive CV, GitHub, or Portfolio" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
      </div>

      <div style="display: flex; gap: 12px; justify-content: flex-end; margin-top: 8px;">
        <button type="button" class="btn btn-ghost" onclick="showJobDetails('${job.id}')">Back to Details</button>
        <button type="submit" class="btn btn-primary" style="background: #2563eb; color: white;">Submit Application</button>
      </div>
    </form>
  `;
  refreshIcons();
};

window.handleJobApplySubmit = (jobId) => {
  const name = document.getElementById('app-name').value;
  const email = document.getElementById('app-email').value;
  const phone = document.getElementById('app-phone').value;
  const coverLetter = document.getElementById('app-cover').value;
  const portfolioUrl = document.getElementById('app-portfolio').value;
  
  submitJobApplication(jobId, {
    applicantName: name,
    applicantEmail: email,
    applicantPhone: phone,
    coverLetter,
    portfolioUrl
  });
};

function submitJobApplication(jobId, data) {
  const job = allOpportunities.find(o => o.id === jobId);
  if (!job) return;
  
  profile.jobApplications = profile.jobApplications || [];
  profile.jobApplications.push({
    id: `app-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    jobId: job.id,
    jobTitle: job.title,
    organization: job.organization,
    applicantName: data.applicantName,
    applicantEmail: data.applicantEmail,
    applicantPhone: data.applicantPhone,
    coverLetter: data.coverLetter,
    portfolioUrl: data.portfolioUrl || "",
    submittedAt: new Date().toISOString(),
    status: "pending"
  });
  
  saveProfile();
  showToast("Application submitted successfully!");
  
  // Send notification email to applicant + admin
  fetch(`${API_BASE_URL}/api/notify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      action: 'job_application_submitted',
      email: data.applicantEmail,
      name: data.applicantName,
      jobTitle: job.title
    })
  }).catch(e => console.error('Notify job_application_submitted error:', e));
  
  document.querySelector('.payment-modal-overlay').classList.remove('is-active');
  render();
}

window.deleteJobListing = async (jobId) => {
  if (!confirm("Are you sure you want to delete this job listing?")) return;
  try {
    await deleteDoc(doc(db, "opportunities", jobId));
    showToast("Job listing deleted successfully.");
    document.querySelector('.payment-modal-overlay').classList.remove('is-active');
    await loadOpportunities();
    render();
  } catch (err) {
    console.error("Error deleting job listing:", err);
    showToast("Failed to delete job listing from Firestore.");
  }
};

window.showAddJobForm = () => {
  let overlay = document.querySelector('.payment-modal-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'payment-modal-overlay';
    document.body.appendChild(overlay);
  }

  overlay.innerHTML = `
    <div class="job-details-modal-card" style="max-height: 90vh; overflow-y: auto;">
      <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; margin-bottom: 16px;">
        <h3 style="margin: 0; color: white; font-size: 1.25rem;">Add New Job Listing</h3>
        <button onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')" style="background: none; border: none; color: var(--muted); cursor: pointer; font-size: 1.75rem; line-height: 1; padding: 0 4px;">&times;</button>
      </div>
      <form id="add-job-form" style="display: flex; flex-direction: column; gap: 12px;" onsubmit="event.preventDefault(); handleAddJobSubmit()">
        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Job Title</label>
          <input class="input" type="text" id="add-job-title" required style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Organization / Company</label>
          <input class="input" type="text" id="add-job-org" required style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Organization Short Name (e.g. KRA, AMREF)</label>
          <input class="input" type="text" id="add-job-orgshort" required style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Category</label>
          <select class="input" id="add-job-category" style="background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;">
            ${OPPORTUNITY_CATEGORIES.filter(c => c.id !== 'all').map(c => `<option value="${c.id}">${c.label}</option>`).join("")}
          </select>
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Location</label>
          <input class="input" type="text" id="add-job-location" required placeholder="e.g. Nairobi, Upper Hill" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Salary / Stipend</label>
          <input class="input" type="text" id="add-job-salary" required placeholder="e.g. KSh 45,000 p.m. or Competitive" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Deadline Date (YYYY-MM-DD)</label>
          <input class="input" type="date" id="add-job-deadline" required style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Type (e.g. Full-Time, Internship)</label>
          <input class="input" type="text" id="add-job-type" required placeholder="e.g. Full-Time | Permanent" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white;" />
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Description</label>
          <textarea class="textarea" id="add-job-desc" required placeholder="Brief description of the job..." style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white; min-height: 80px; resize: vertical;"></textarea>
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Requirements (One per line)</label>
          <textarea class="textarea" id="add-job-requirements" required placeholder="Diploma in IT&#10;2 years experience" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white; min-height: 80px; resize: vertical;"></textarea>
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">Duties (One per line)</label>
          <textarea class="textarea" id="add-job-duties" required placeholder="Perform tests&#10;Coordinate activities" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white; min-height: 80px; resize: vertical;"></textarea>
        </div>

        <div style="display: flex; flex-direction: column; gap: 4px;">
          <label style="color: var(--muted); font-size: 0.85rem;">How To Apply Steps (One per line)</label>
          <textarea class="textarea" id="add-job-howtoapply" required placeholder="Email to: jobs@org.com&#10;Subject: Developer" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; padding: 10px; color: white; min-height: 80px; resize: vertical;"></textarea>
        </div>

        <div style="display: flex; gap: 12px; justify-content: flex-end; margin-top: 8px;">
          <button type="button" class="btn btn-ghost" onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')">Cancel</button>
          <button type="submit" class="btn btn-primary" style="background: #22c55e; color: #0a1628; font-weight: 800;">Save Job Listing</button>
        </div>
      </form>
    </div>
  `;

  overlay.classList.add('is-active');
  refreshIcons();
};

window.handleAddJobSubmit = async () => {
  const title = document.getElementById('add-job-title').value;
  const org = document.getElementById('add-job-org').value;
  const orgshort = document.getElementById('add-job-orgshort').value;
  const category = document.getElementById('add-job-category').value;
  const location = document.getElementById('add-job-location').value;
  const salary = document.getElementById('add-job-salary').value;
  const deadline = document.getElementById('add-job-deadline').value;
  const type = document.getElementById('add-job-type').value;
  const desc = document.getElementById('add-job-desc').value;
  const reqs = document.getElementById('add-job-requirements').value.split('\n').filter(l => l.trim());
  const duties = document.getElementById('add-job-duties').value.split('\n').filter(l => l.trim());
  const how = document.getElementById('add-job-howtoapply').value.split('\n').filter(l => l.trim());
  
  const jobId = `opp-${Date.now()}`;
  const newJob = {
    id: jobId,
    title,
    organization: org,
    orgShort: orgshort,
    orgColor: { bg: "rgba(255,255,255,0.05)", text: "white" },
    category,
    tags: [category.charAt(0).toUpperCase() + category.slice(1), type.split('|')[0].trim()],
    location,
    salary,
    deadline,
    postedAt: new Date().toISOString(),
    type,
    vacancies: 1,
    featured: false,
    verified: true,
    remote: location.toLowerCase().includes('remote'),
    experienceLevel: "Entry Level",
    description: desc,
    requirements: reqs,
    duties,
    howToApply: how,
    applyUrl: "internal",
    source: "TaskBridge Admin"
  };

  try {
    await setDoc(doc(db, "opportunities", jobId), newJob);
    showToast("New job listing added successfully.");
    document.querySelector('.payment-modal-overlay').classList.remove('is-active');
    await loadOpportunities();
    render();
  } catch (err) {
    console.error("Error adding job listing:", err);
    showToast("Failed to add job listing to Firestore.");
  }
};

function jobsPanel() {
  const activeCat = state.jobsFilter || "all";
  const searchVal = (state.jobsSearch || "").trim().toLowerCase();

  // Filter pipeline
  let filtered = allOpportunities;
  
  // Category filter
  if (activeCat !== "all") {
    filtered = filtered.filter(opp => opp.category === activeCat);
  }

  // Search filter
  if (searchVal) {
    filtered = filtered.filter(opp => {
      const haystack = [opp.title, opp.organization, opp.location, ...opp.tags].join(" ").toLowerCase();
      return haystack.includes(searchVal);
    });
  }

  return `
    <div class="jobs-panel" style="padding: 0 0 120px;">
      <!-- Header Banner -->
      <div style="background: linear-gradient(135deg, rgba(37,99,235,0.15), rgba(20,184,166,0.1)); border-radius: 20px; padding: 28px 24px; margin-bottom: 24px; border: 1px solid rgba(255,255,255,0.07);">
        <div style="display: flex; align-items: center; gap: 14px; margin-bottom: 10px;">
          <div style="width: 46px; height: 46px; border-radius: 12px; background: linear-gradient(135deg, #2563eb, #1d4ed8); display: flex; align-items: center; justify-content: center; color: white; flex-shrink:0;">
            ${icon('briefcase')}
          </div>
          <div>
            <h2 style="margin: 0; font-size: 1.4rem; font-weight: 800; color: white;">Jobs & Opportunities</h2>
            <p style="margin: 0; color: var(--muted); font-size: 0.9rem;">Government jobs, internships, scholarships & remote work across Africa</p>
          </div>
        </div>
        <div style="display: flex; gap: 10px; margin-top: 16px; flex-wrap: wrap;">
          <span style="background: rgba(37,99,235,0.2); border: 1px solid rgba(37,99,235,0.3); color: #93c5fd; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase;">${allOpportunities.length} OPPORTUNITIES</span>
          <span style="background: rgba(34,197,94,0.15); border: 1px solid rgba(34,197,94,0.25); color: #4ade80; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase;">VERIFIED SOURCES</span>
          <span style="background: rgba(20,184,166,0.15); border: 1px solid rgba(20,184,166,0.25); color: #2dd4bf; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase;">UPDATED DAILY</span>
        </div>
      </div>

      ${isAdmin() ? `
        <div style="margin-bottom: 24px; display: flex; justify-content: flex-end;">
          <button class="btn btn-primary" onclick="showAddJobForm()" style="background: #22c55e; color: #0a1628; font-weight: 800; display: inline-flex; align-items: center; gap: 6px; border: none; padding: 10px 18px; border-radius: 10px; cursor: pointer;">
            ${icon('plus')} Add New Job Listing
          </button>
        </div>
      ` : ''}

      <!-- Search Bar -->
      <div style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; padding: 16px; margin-bottom: 24px; display: flex; gap: 12px; flex-wrap: wrap;">
        <div style="flex: 1; min-width: 260px; position: relative; display: flex; align-items: center;">
          <span style="position: absolute; left: 14px; color: var(--muted); display: flex; align-items: center;">${icon('search')}</span>
          <input type="text" data-input="jobsSearch" placeholder="Search by job title, company, keyword..." value="${escapeAttr(state.jobsSearch || '')}" style="
            width: 100%; padding: 12px 16px 12px 42px; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.08);
            border-radius: 10px; color: white; font-size: 0.9rem; outline: none; transition: border-color 0.2s;
          " onfocus="this.style.borderColor='rgba(37,99,235,0.5)'" onblur="this.style.borderColor='rgba(255,255,255,0.08)'" />
        </div>
      </div>

      <!-- Category Filter Tabs -->
      <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 24px; padding: 0 4px;">
        ${OPPORTUNITY_CATEGORIES.map(cat => `
          <button data-action="filterJobs" data-filter="${cat.id}" style="
            padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; cursor: pointer;
            border: 1px solid ${activeCat === cat.id ? '#2563eb' : 'rgba(255,255,255,0.08)'};
            background: ${activeCat === cat.id ? 'rgba(37,99,235,0.2)' : 'rgba(255,255,255,0.02)'};
            color: ${activeCat === cat.id ? '#93c5fd' : 'var(--muted)'};
            transition: all 0.2s;
            display: inline-flex; align-items: center; gap: 6px;
          ">
            ${cat.label}
          </button>
        `).join("")}
      </div>

      <!-- Job Cards Grid -->
      <div style="display: grid; grid-template-columns: 1fr; gap: 16px;">
        ${filtered.map(opp => {
          const days = daysUntilDeadline(opp.deadline);
          const dlText = days === 0 ? "Closes today!" :
                         days === 1 ? "Closes tomorrow" :
                         days < 0 ? "Closed" :
                         `${days} days left`;
          const isUrgent = days <= 5;
          const orgBg = opp.orgColor?.bg || "rgba(255,255,255,0.05)";
          const orgText = opp.orgColor?.text || "white";

          return `
            <div data-action="viewJob" data-id="${opp.id}" style="
              background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06);
              border-radius: 18px; padding: 22px; cursor: pointer; transition: all 0.2s;
              position: relative; overflow: hidden; display: flex; flex-direction: column; gap: 14px;
              ${opp.featured ? 'border-left: 3px solid #2563eb;' : ''}
            " onmouseover="this.style.background='rgba(255,255,255,0.04)'; this.style.borderColor='rgba(255,255,255,0.1)'" onmouseout="this.style.background='rgba(255,255,255,0.02)'; this.style.borderColor='rgba(255,255,255,0.06)'">
              
              <!-- Top Section -->
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;">
                <div style="display: flex; gap: 14px; align-items: center;">
                  <div style="width: 46px; height: 46px; border-radius: 10px; background: ${orgBg}; color: ${orgText}; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 1.1rem; flex-shrink: 0;">
                    ${opp.orgShort}
                  </div>
                  <div>
                    <h3 style="margin: 0; color: white; font-size: 1.05rem; font-weight: 700; line-height: 1.4;">${escapeHtml(opp.title)}</h3>
                    <p style="margin: 3px 0 0; color: var(--muted); font-size: 0.85rem; display: flex; align-items: center; gap: 6px;">
                      ${escapeHtml(opp.organization)}
                      ${opp.verified ? `<span style="color: #22c55e; display: inline-flex;">${icon('badge-check')}</span>` : ''}
                    </p>
                  </div>
                </div>
                
                <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 6px; flex-shrink: 0;">
                  ${opp.featured ? `<span style="background: rgba(37,99,235,0.15); color: #93c5fd; border: 1px solid rgba(37,99,235,0.25); font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 6px; letter-spacing: 0.5px; text-transform: uppercase;">FEATURED</span>` : ""}
                  <span style="
                    font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 6px;
                    background: ${days < 0 ? 'rgba(239,68,68,0.12)' : isUrgent ? 'rgba(249,115,22,0.12)' : 'rgba(34,197,94,0.08)'};
                    color: ${days < 0 ? '#f87171' : isUrgent ? '#fb923c' : '#4ade80'};
                    border: 1px solid ${days < 0 ? 'rgba(239,68,68,0.2)' : isUrgent ? 'rgba(249,115,22,0.2)' : 'rgba(34,197,94,0.15)'};
                  ">${dlText}</span>
                </div>
              </div>

              <!-- Meta Row -->
              <div style="display: flex; flex-wrap: wrap; gap: 14px; font-size: 0.82rem; color: var(--muted); border-top: 1px solid rgba(255,255,255,0.04); padding-top: 12px; margin-top: 2px;">
                <span style="display: flex; align-items: center; gap: 4px;">${icon('map-pin')} ${escapeHtml(opp.location)}</span>
                <span style="display: flex; align-items: center; gap: 4px;">${icon('banknote')} ${escapeHtml(opp.salary)}</span>
                <span style="display: flex; align-items: center; gap: 4px;">${icon('clock')} ${escapeHtml(opp.type)}</span>
                <span style="display: flex; align-items: center; gap: 4px; margin-left: auto;">Posted ${timeAgo(opp.postedAt)}</span>
              </div>

              <!-- Tags -->
              <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                ${opp.tags.map(tag => {
                  const tagCol = OPPORTUNITY_TAG_COLORS[tag] || "green";
                  let bg = "rgba(34,197,94,0.08)";
                  let color = "#4ade80";
                  if (tagCol === "amber") { bg = "rgba(245,158,11,0.08)"; color = "#fbbf24"; }
                  if (tagCol === "purple") { bg = "rgba(168,85,247,0.08)"; color = "#c084fc"; }
                  if (tagCol === "blue") { bg = "rgba(59,130,246,0.08)"; color = "#60a5fa"; }

                  return `
                    <span style="font-size: 11px; font-weight: 600; padding: 3px 9px; border-radius: 8px; background: ${bg}; color: ${color};">${escapeHtml(tag)}</span>
                  `;
                }).join("")}
                ${opp.vacancies > 1 ? `<span style="font-size: 11px; font-weight: 600; padding: 3px 9px; border-radius: 8px; background: rgba(255,255,255,0.05); color: var(--muted);">${opp.vacancies} Vacancies</span>` : ''}
              </div>

            </div>
          `;
        }).join("")}
        ${filtered.length === 0 ? `
          <div style="text-align: center; padding: 64px 32px; color: var(--muted); background: rgba(255,255,255,0.01); border-radius: 18px; border: 1px solid rgba(255,255,255,0.04);">
            <div style="font-size: 2rem; margin-bottom: 12px; color: rgba(255,255,255,0.1);">${icon('search-code')}</div>
            <h4 style="margin: 0 0 6px; color: white;">No opportunities found</h4>
            <p style="margin: 0; font-size: 0.9rem;">We couldn't find any opportunities matching your current filters or search query.</p>
          </div>
        ` : ""}
      </div>
    </div>
  `;
}


// ── Taskbridge Institute Panel ────────────────────────────────────────────────
function institutePanel() {
  // Auto-sync learner details to localStorage so they are logged in if they click any link
  localStorage.setItem("taskbridgeAcademyLearner", JSON.stringify({
    full_name: profile.name,
    email: profile.email,
    phone: profile.phone,
    id: profile.uid || "local-user"
  }));

  // Fetch courses dynamically if not loaded yet
  if (!state.academyCourses) {
    state.academyCourses = [];
    state.loadingAcademyCourses = true;
    fetch(`${API_BASE_URL}/api/academy/courses`)
      .then(res => res.json())
      .then(data => {
        state.academyCourses = data.courses || [];
        state.loadingAcademyCourses = false;
        render(); // trigger global render
      })
      .catch(err => {
        console.error("Failed to load courses:", err);
        state.loadingAcademyCourses = false;
        render();
      });
  }

  if (state.loadingAcademyCourses) {
    return `
      <div class="institute-panel" style="padding: 0 0 120px; text-align: center;">
        <div style="margin: 40px auto; padding: 20px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; max-width: 400px;">
          <p style="color: var(--muted); margin: 0;">Loading courses from Taskbridge Institute...</p>
        </div>
      </div>
    `;
  }

  // Fallback to static list if API fails or is empty
  const courses = state.academyCourses && state.academyCourses.length > 0 
    ? state.academyCourses 
    : [
        {
          id: "digital-marketing-toolkit",
          title: "Digital Marketing & Freelance Toolkit",
          intro: "Build practical marketing skills and a freelancer toolkit for Kenyan SMEs and remote clients.",
          duration: "8 weeks", originalPrice: 12000, price: 6000, discount: 50,
          benefits: ["Plan campaigns", "Write persuasive copy", "Package services", "Build a freelance pipeline"],
        },
        {
          id: "fullstack-web-dev",
          title: "Certified Fullstack Web Developer",
          intro: "Learn how to build, ship, and maintain modern fullstack applications for clients and employers.",
          duration: "24 weeks", originalPrice: 25000, price: 15000, discount: 40,
          benefits: ["Build complete web apps", "Deploy real projects", "Create developer portfolio"],
        },
        {
          id: "ai-business-analyst",
          title: "AI-Powered Business Analyst",
          intro: "Use AI tools responsibly to research, document, analyze, and present business decisions.",
          duration: "12 weeks", originalPrice: 18000, price: 9900, discount: 45,
          benefits: ["Use AI for research", "Write better reports", "Clarify requirements"],
        }
      ];

  return `
    <div class="institute-panel" style="padding: 0 0 120px;">
      <!-- Hero Header -->
      <div style="background: linear-gradient(135deg, rgba(124,58,237,0.2), rgba(37,99,235,0.1)); border-radius: 20px; padding: 32px 24px; margin-bottom: 28px; border: 1px solid rgba(124,58,237,0.2); position:relative; overflow:hidden;">
        <div style="position:absolute; top:-20px; right:-20px; width:150px; height:150px; background: radial-gradient(circle, rgba(124,58,237,0.15), transparent 70%); border-radius: 50%;"></div>
        <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px;">
          <div style="width: 52px; height: 52px; border-radius: 14px; background: linear-gradient(135deg, #7c3aed, #6d28d9); display: flex; align-items: center; justify-content: center; color: white; font-size: 24px; flex-shrink:0; box-shadow: 0 6px 20px rgba(124,58,237,0.35);">
            ${icon('graduation-cap')}
          </div>
          <div>
            <h2 style="margin: 0 0 4px; font-size: 1.5rem; font-weight: 900; color: white;">Taskbridge Institute</h2>
            <p style="margin: 0; color: #c4b5fd; font-size: 0.9rem;">Learn. Certify. Earn. Africa's skills-to-income platform.</p>
          </div>
        </div>
        <p style="color: #e2e8f0; font-size: 0.95rem; line-height: 1.6; margin-bottom: 20px;">
          The Taskbridge Institute provides professional skills training designed specifically for African freelancers. 
          Complete a course, earn a certificate, and unlock higher-paying tasks on the platform.
        </p>
        <div style="display: flex; gap: 10px; flex-wrap: wrap;">
          <span style="background: rgba(124,58,237,0.2); border: 1px solid rgba(124,58,237,0.35); color: #c4b5fd; padding: 6px 14px; border-radius: 20px; font-size: 12px; font-weight: 700;">CERTIFIED COURSES</span>
          <span style="background: rgba(34,197,94,0.15); border: 1px solid rgba(34,197,94,0.25); color: #4ade80; padding: 6px 14px; border-radius: 20px; font-size: 12px; font-weight: 700;">EARN MORE AFTER</span>
          <span style="background: rgba(14,165,233,0.15); border: 1px solid rgba(14,165,233,0.25); color: #38bdf8; padding: 6px 14px; border-radius: 20px; font-size: 12px; font-weight: 700;">SELF-PACED</span>
        </div>
      </div>

      <!-- Course Cards -->
      <h3 style="margin: 0 0 16px; font-size: 1.1rem; font-weight: 700; color: #e2e8f0;">Available Courses</h3>
      <div style="display: grid; grid-template-columns: 1fr; gap: 16px; margin-bottom: 28px;">
        ${courses.map(course => {
          const discountPercent = course.discount || 0;
          const originalPrice = course.originalPrice || (course.price * 1.5);
          const price = course.price;
          const benefits = course.benefits || [];

          return `
            <div style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px; position: relative; overflow: hidden; display: flex; flex-direction: column; gap: 14px;">
              ${discountPercent ? `<span style="position: absolute; top: 16px; right: 16px; background: rgba(124,58,237,0.15); color: #c4b5fd; border: 1px solid rgba(124,58,237,0.25); font-size: 10px; font-weight: 800; padding: 4px 10px; border-radius: 8px; letter-spacing: 0.5px;">${discountPercent}% OFF</span>` : ""}
              <div style="display: flex; align-items: flex-start; gap: 16px;">
                <div style="width: 48px; height: 48px; border-radius: 12px; background: rgba(124,58,237,0.1); border: 1px solid rgba(124,58,237,0.2); display: flex; align-items: center; justify-content: center; color: #c4b5fd; flex-shrink: 0;">
                  ${icon('graduation-cap')}
                </div>
                <div style="flex: 1;">
                  <h4 style="margin: 0 0 8px; font-size: 1.05rem; font-weight: 700; color: white;">${escapeHtml(course.title)}</h4>
                  <p style="margin: 0 0 14px; color: var(--muted); font-size: 0.88rem; line-height: 1.5;">${escapeHtml(course.intro || course.desc || '')}</p>
                  
                  <!-- Benefits -->
                  ${benefits.length > 0 ? `
                    <ul style="margin: 0 0 14px; padding-left: 20px; color: var(--muted); font-size: 0.85rem; line-height: 1.5;">
                      ${benefits.map(b => `<li>${escapeHtml(b)}</li>`).join("")}
                    </ul>
                  ` : ''}

                  <div style="display: flex; flex-wrap: wrap; gap: 12px; font-size: 0.82rem; color: var(--muted); margin-bottom: 16px; align-items: center;">
                    <span>${icon('clock')} ${course.duration}</span>
                    <span style="color: #4ade80; font-weight: 700;">
                      ${originalPrice ? `<span style="text-decoration: line-through; color: var(--muted); margin-right: 6px; font-weight: normal;">KES ${originalPrice.toLocaleString()}</span>` : ''}
                      KES ${price.toLocaleString()}
                    </span>
                  </div>
                  
                  <a href="/academy/welcome.html" target="_blank" style="
                    display: inline-flex; align-items: center; gap: 6px;
                    background: linear-gradient(135deg, #7c3aed, #6d28d9);
                    color: white; padding: 10px 20px; border-radius: 10px;
                    font-size: 13px; font-weight: 700; text-decoration: none;
                    box-shadow: 0 4px 14px rgba(124,58,237,0.3);
                  ">${icon('arrow-right')} Enroll Now</a>
                </div>
              </div>
            </div>
          `;
        }).join("")}
      </div>

      <!-- Why Join Banner -->
      <div style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 18px; padding: 22px;">
        <h4 style="margin: 0 0 16px; font-weight: 700; color: white;">${icon('star')} Why join Taskbridge Institute?</h4>
        <div style="display: flex; flex-direction: column; gap: 12px;">
          ${[
            ["badge-check", "#4ade80", "Earn a verified digital certificate recognised across Africa"],
            ["trending-up", "#38bdf8", "Unlock premium tasks with higher payouts after completing a course"],
            ["users", "#c4b5fd", "Join a community of 5,000+ trained African freelancers"],
            ["clock", "#fb923c", "Self-paced — study at your own speed, on any device"],
          ].map(([ic, col, text]) => `
            <div style="display: flex; align-items: center; gap: 12px; color: var(--muted); font-size: 0.9rem;">
              <span style="color: ${col}; flex-shrink:0;">${icon(ic)}</span> ${text}
            </div>
          `).join("")}
        </div>
      </div>
    </div>
  `;
}

function walletPanel() {
  const tCount = profile.transactions ? profile.transactions.length : 0;
  const wBalance = stats().walletBalance;
  const refCount = (profile.referredUsers || []).length;
  const refLink = `taskbridge.co.ke/refer/${profile.referralCode || profile.username || 'you'}`;
  const checkinAvailable = canCheckIn();
  const streakCount = profile.wallet?.checkinRewards ? Math.floor(profile.wallet.checkinRewards / 5) : 0;
  const days = ['Mon','Tue','Wed','Thu','Fri','Sat'];
  const greeting = getKenyanGreeting();
  const firstName = escapeHtml((profile.name || profile.username || 'User').split(' ')[0]);
  const dateJoined = profile.createdAt ? new Date(profile.createdAt).toLocaleDateString('en-GB', {day: 'numeric', month: 'long', year: 'numeric'}) : new Date().toLocaleDateString('en-GB', {day: 'numeric', month: 'long', year: 'numeric'});

  return `
    <div style="display: flex; flex-direction: column; gap: 20px; padding: 0 4px 80px;">

      <!-- TOP: Welcome + Profile Card -->
      <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 12px;">
        <div>
          <h1 style="margin: 0 0 4px; font-size: 1.35rem; font-weight: 700; color: #ffffff; line-height: 1.35;">
            ${greeting}, <span style="color: #14b8a6;">${firstName}</span>
          </h1>
          <p style="margin: 0; font-size: 0.85rem; color: #64748b;">Your Wallet &amp; Finance overview</p>
        </div>
        <div style="display: flex; align-items: center; gap: 12px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07); border-radius: 14px; padding: 10px 14px; flex-wrap: wrap; max-width: 100%;">
          <div style="position: relative; width: 44px; height: 44px; border-radius: 50%; overflow: hidden; border: 2px solid #22c55e; flex-shrink: 0; cursor: pointer;" onclick="document.getElementById('avatar-upload').click()">
            <img src="${profile.customAvatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${profile.username}`}" style="width:100%;height:100%; object-fit: cover;" />
            <div style="position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,0.5); font-size: 9px; text-align: center; padding: 2px 0; color: #fff;">Edit</div>
            <input type="file" id="avatar-upload" style="display: none;" accept="image/*" onchange="window.handleAvatarUpload(event)" />
          </div>
          <div style="display: flex; flex-direction: column; gap: 4px; min-width: 0;">
            <span style="font-size: 0.8rem; color: #94a3b8; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;">${escapeHtml(profile.email || '')}</span>
            <div style="font-size: 0.8rem; color: #14b8a6; font-weight: 700; margin-top: 2px;">
              Portal Code: <span style="font-family:monospace; background:rgba(20,184,166,0.15); padding:2px 6px; border-radius:4px;">${escapeHtml(profile.portalCode || 'N/A')}</span>
              <span style="color: #94a3b8; font-weight: 500; margin-left: 8px; font-size: 0.75rem;">Joined: ${dateJoined}</span>
            </div>
            <div style="display: flex; gap: 6px; flex-wrap: wrap;">
              <span style="background: rgba(34,197,94,0.15); border: 1px solid rgba(34,197,94,0.35); color: #4ade80; padding: 2px 8px; border-radius: 6px; font-weight: 700; font-size: 10px; white-space: nowrap;">✔ VERIFIED ACCOUNT</span>
              <span style="background: rgba(14,165,233,0.15); border: 1px solid rgba(14,165,233,0.35); color: #38bdf8; padding: 2px 8px; border-radius: 6px; font-weight: 700; font-size: 10px; white-space: nowrap;">LEVEL ${profile.level || 1} ${profile.levelLabel || 'BEGINNER'}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- STAT CARDS — auto-fit stacks on small screens -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 14px;">
        <!-- Balance Card -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 16px; padding: 18px 16px;">
          <div style="font-size: 0.8rem; font-weight: 600; color: #94a3b8; margin-bottom: 4px;">Available Balance</div>
          <div style="font-size: 1.9rem; font-weight: 800; color: #ffffff; margin: 6px 0 4px; line-height: 1.1;">${money(wBalance)}</div>
          <div style="font-size: 0.75rem; color: #64748b;">Available Funds</div>
        </div>
        <!-- Referral Earnings Card -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 16px; padding: 18px 16px;">
          <div style="font-size: 0.8rem; font-weight: 600; color: #94a3b8; margin-bottom: 4px;">Referral Earnings</div>
          <div style="font-size: 1.9rem; font-weight: 800; color: #ffffff; margin: 6px 0 4px; line-height: 1.1;">${money(profile.wallet?.referralEarnings || 0)}</div>
          <div style="font-size: 0.75rem; color: #64748b;">${refCount} referrals made</div>
        </div>
        <!-- Check-in Streak Card -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 16px; padding: 18px 16px;">
          <div style="font-size: 0.8rem; font-weight: 600; color: #94a3b8; margin-bottom: 10px;">Engagement Streaks</div>
          <div style="display: flex; gap: 5px; align-items: center; flex-wrap: wrap;">
            <div style="display: flex; flex-direction: column; align-items: center; gap: 3px;">
              <div style="width: 26px; height: 26px; border-radius: 50%; background: #14b8a6; display: flex; align-items: center; justify-content: center; color: white; font-size: 11px;">✓</div>
              <span style="font-size: 9px; color: #94a3b8;">Day 1</span>
            </div>
            ${days.map(d => `
              <div style="display: flex; flex-direction: column; align-items: center; gap: 3px;">
                <div style="width: 26px; height: 26px; border-radius: 50%; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);"></div>
                <span style="font-size: 9px; color: #64748b;">${d}</span>
              </div>
            `).join('')}
          </div>
        </div>
      </div>

      <!-- WALLET HUB + ENGAGEMENT CENTER — stacks on mobile -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px;">
        <!-- Wallet Hub -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px;">
          <h3 style="margin: 0 0 16px; font-size: 1rem; font-weight: 700; color: #ffffff;">Wallet &amp; Finance Hub</h3>
          <!-- Balance + Withdraw -->
          <div style="background: linear-gradient(145deg, rgba(20,184,166,0.18), rgba(13,148,136,0.1)); border: 1px solid rgba(20,184,166,0.25); border-radius: 14px; padding: 16px 18px; margin-bottom: 16px;">
            <div style="font-size: 0.8rem; color: rgba(255,255,255,0.6); margin-bottom: 4px;">Balance</div>
            <div style="font-size: 1.7rem; font-weight: 800; color: #ffffff; margin-bottom: 12px;">${money(wBalance)}</div>
            <button data-action="withdrawMpesa" style="width:100%; background: #14b8a6; color: #0a1628; font-weight: 800; padding: 11px; border-radius: 10px; border: none; font-size: 14px; cursor: pointer; transition: all 0.2s;">
              Withdraw to M-Pesa
            </button>
            <p style="margin: 7px 0 0; text-align: center; color: rgba(255,255,255,0.45); font-size: 0.75rem;">Minimum KES 150</p>
          </div>
          <!-- M-Pesa Quick Transfer — clean stacked layout -->
          <div>
            <div style="font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 10px;">M-Pesa Quick Transfer</div>
            <input id="mpesa-quick-phone" type="tel" placeholder="Phone e.g. 07XXXXXXXX" style="width: 100%; box-sizing: border-box; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 10px 14px; color: white; font-size: 0.85rem; outline: none; margin-bottom: 8px;" />
            <div style="display: flex; gap: 8px; align-items: center;">
              <input id="mpesa-quick-input" type="number" min="1" placeholder="Amount (KES)" style="flex: 1; min-width: 0; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 10px 14px; color: white; font-size: 0.85rem; outline: none;" />
              <button data-action="withdrawMpesa" style="width: 42px; height: 42px; background: #14b8a6; border: none; border-radius: 10px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #0a1628; flex-shrink: 0;">
                ${icon('send')}
              </button>
            </div>
          </div>
        </div>

        <!-- Engagement Center -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px;">
          <h3 style="margin: 0 0 16px; font-size: 1rem; font-weight: 700; color: #ffffff;">Engagement Center</h3>
          <div style="margin-bottom: 20px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 0.85rem; font-weight: 600; color: #ffffff;">Daily Check-in</span>
              <span style="font-size: 0.8rem; color: #14b8a6; font-weight: 600;">${streakCount} Weekly Streak</span>
            </div>
            <div style="background: rgba(255,255,255,0.06); border-radius: 6px; overflow: hidden; height: 6px; margin-bottom: 10px;">
              <div style="height: 100%; width: ${Math.min(100, (streakCount / 7) * 100)}%; background: linear-gradient(90deg, #14b8a6, #22c55e); border-radius: 6px;"></div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span style="font-size: 0.8rem; color: #94a3b8;">Daily Check-in</span>
              ${checkinAvailable
                ? `<button data-action="checkin" style="background: #22c55e; color: #0a1628; font-weight: 700; padding: 6px 14px; border-radius: 8px; border: none; cursor: pointer; font-size: 0.8rem;">Claim KES 5</button>`
                : `<span style="color: #4ade80; font-size: 0.8rem; font-weight: 700;">Check-in: Claimed</span>`
              }
            </div>
          </div>
          <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.1); border-radius: 14px; padding: 16px;">
            <div style="font-size: 0.85rem; font-weight: 600; color: #ffffff; margin-bottom: 10px;">Copy Referral Link</div>
            <div style="display: flex; gap: 8px; align-items: center;">
              <div style="flex: 1; min-width: 0; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; padding: 10px 14px; color: #94a3b8; font-size: 0.82rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${refLink}</div>
              <button data-action="copyReferralLink" style="width: 40px; height: 40px; background: #14b8a6; border: none; border-radius: 10px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #0a1628; flex-shrink: 0;">
                ${icon('copy')}
              </button>
            </div>
          </div>
        </div>
      </div>

      ${paymentDetailsPanel()}

      <!-- Transaction History -->
      <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <h2 style="margin: 0; font-size: 1.1rem; font-weight: 700; color: white;">Transaction History</h2>
          <span style="background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); color: #94a3b8; padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600;">${tCount} entries</span>
        </div>
        <div style="display: flex; flex-direction: column; gap: 8px;">
          ${
            tCount
              ? profile.transactions.slice().reverse().slice(0, 15).map(t => `
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 14px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06); border-radius: 12px; transition: background 0.15s; gap: 8px;">
                  <div style="display: flex; gap: 10px; align-items: center; min-width: 0; flex: 1;">
                    <div style="width: 34px; height: 34px; border-radius: 50%; background: ${t.amount > 0 ? 'rgba(74,222,128,0.15)' : 'rgba(248,113,113,0.15)'}; border: 1px solid ${t.amount > 0 ? 'rgba(74,222,128,0.3)' : 'rgba(248,113,113,0.3)'}; display: flex; align-items: center; justify-content: center; color: ${t.amount > 0 ? '#4ade80' : '#f87171'}; flex-shrink: 0;">
                      ${icon(t.icon || (t.amount > 0 ? 'arrow-down-left' : 'arrow-up-right'))}
                    </div>
                    <div style="min-width: 0;">
                      <div style="font-weight: 600; color: white; font-size: 0.88rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${escapeHtml(t.desc)}</div>
                      <div style="font-size: 0.75rem; color: #64748b;">${new Date(t.at).toLocaleDateString('en-GB', {day:'2-digit',month:'short',year:'numeric'})}</div>
                    </div>
                  </div>
                  <span style="font-weight: 700; font-size: 0.95rem; color: ${t.amount > 0 ? '#4ade80' : '#f87171'}; flex-shrink: 0;">${t.amount > 0 ? '+' : ''}${t.amount}</span>
                </div>
              `).join('')
              : `<div style="padding: 40px; text-align: center; color: #64748b;">No transactions yet.</div>`
          }
        </div>
      </div>
    </div>
  `;
}

function referralPanel() {
  syncReferralEarnings();
  saveProfile();
  const link = referralLink();
  const eligible = profile.wallet.referralEarnings >= 50;
  const refCount = (profile.referredUsers || []).length;
  const greeting = getKenyanGreeting();
  const firstName = escapeHtml((profile.name || profile.username || 'User').split(' ')[0]);
  const refLink = `taskbridge.co.ke/refer/${profile.referralCode || profile.username || 'you'}`;
  const referred = profile.referredUsers || [];

  const referredRowsHtml = referred.length > 0
    ? referred.slice().reverse().map(item => {
        const nameVal = escapeHtml(item.name || 'New user');
        const usernameVal = escapeHtml(item.username || (item.name ? item.name.toLowerCase().replace(/\s+/g,'') : 'user'));
        let dateVal = '—';
        try { if (item.at) dateVal = new Date(item.at).toLocaleDateString('en-GB', {day:'2-digit',month:'short',year:'numeric'}); } catch(e){}
        const commissionVal = money(item.amount || REFERRAL_PAYOUT);
        const initialsVal = (item.name || 'NU').split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase();
        return `
          <tr style="border-bottom: 1px solid rgba(255,255,255,0.04); font-size: 0.9rem; transition: background 0.15s;">
            <td style="padding: 14px 16px;">
              <div style="display: flex; align-items: center; gap: 12px;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, #14b8a6, #0d9488); display: flex; align-items: center; justify-content: center; color: white; font-weight: 700; font-size: 13px; flex-shrink:0;">${initialsVal}</div>
                <span style="color: white; font-weight: 600;">${nameVal}</span>
              </div>
            </td>
            <td style="padding: 14px 16px; color: #94a3b8;">@${usernameVal}</td>
            <td style="padding: 14px 16px; color: #94a3b8;">${dateVal}</td>
            <td style="padding: 14px 16px; color: #4ade80; font-weight: 600;">${commissionVal}</td>
          </tr>
        `;
      }).join('')
    : `<tr><td colspan="4" style="padding: 40px; text-align: center; color: #64748b;">
        <div style="display:flex; flex-direction: column; align-items: center; gap: 8px;">
          <span style="font-size: 1.5rem;">🤝</span>
          <strong style="color: rgba(255,255,255,0.5);">No referrals yet. Start sharing!</strong>
          <a href="${link}" style="color: #14b8a6; font-size: 0.85rem; text-decoration: underline;">${refLink}</a>
        </div>
      </td></tr>`;

  return `
    <div style="display: flex; flex-direction: column; gap: 20px; padding: 0 4px 80px;">

      <!-- TOP: Greeting -->
      <div>
        <h1 style="margin: 0 0 4px; font-size: 1.35rem; font-weight: 700; color: #ffffff;">
          ${greeting}, <span style="color: #14b8a6;">${firstName}</span>
        </h1>
        <p style="margin: 0; font-size: 0.85rem; color: #64748b;">Your Referral Network overview</p>
      </div>

      <!-- STAT CARDS -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 16px;">
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px 24px;">
          <div style="font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 6px;">Total Referrals</div>
          <div style="font-size: 2.2rem; font-weight: 800; color: #ffffff; margin: 8px 0 4px;">${refCount}</div>
          <div style="font-size: 0.8rem; color: #64748b;">People referred</div>
        </div>
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px 24px;">
          <div style="font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 6px;">Total Earned</div>
          <div style="font-size: 2.2rem; font-weight: 800; color: #ffffff; margin: 8px 0 4px;">${money(profile.wallet?.referralEarnings || 0)}</div>
          <div style="font-size: 0.8rem; color: #64748b;">Commission earned</div>
        </div>
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 22px 24px;">
          <div style="font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 6px;">Commission Rate</div>
          <div style="font-size: 2.2rem; font-weight: 800; color: #14b8a6; margin: 8px 0 4px;">${money(REFERRAL_PAYOUT)}</div>
          <div style="font-size: 0.8rem; color: #64748b;">Per active referral</div>
        </div>
      </div>

      <!-- REFERRAL LINK + WITHDRAWAL -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px;">
        <!-- Share Link Card -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px;">
          <h3 style="margin: 0 0 8px; font-size: 1.05rem; font-weight: 700; color: #ffffff;">Your Referral Link</h3>
          <p style="margin: 0 0 16px; color: #64748b; font-size: 0.85rem;">Earn ${money(REFERRAL_PAYOUT)} for each person who signs up via your link.</p>
          <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 12px;">
            <div style="flex: 1; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; padding: 10px 14px; color: #94a3b8; font-size: 0.82rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${refLink}</div>
            <button data-action="copyReferralLink" style="width: 40px; height: 40px; background: #14b8a6; border: none; border-radius: 10px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #0a1628; flex-shrink: 0;">
              ${icon('copy')}
            </button>
          </div>
          <p style="margin: 0; color: #64748b; font-size: 0.78rem;">Your code: <strong style="color: #14b8a6;">${escapeHtml(getReferralCode())}</strong></p>
        </div>

        <!-- Withdrawal Condition Card -->
        <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px;">
          <h3 style="margin: 0 0 8px; font-size: 1.05rem; font-weight: 700; color: #ffffff;">Withdrawal Condition</h3>
          <p style="margin: 0 0 14px; color: #94a3b8; font-size: 0.85rem;">Earn ${money(REFERRAL_PAYOUT)} per active referral. Min withdrawal: KES 50.</p>
          <p style="margin: 0 0 16px; color: #64748b; font-size: 0.8rem;"><strong style="color: #94a3b8;">Note:</strong> Payments are processed between 6am–11am EAT.</p>
          <button class="${eligible ? '' : ''}" data-action="withdrawReferrals" style="width: 100%; background: ${eligible ? '#14b8a6' : 'rgba(255,255,255,0.06)'}; color: ${eligible ? '#0a1628' : '#64748b'}; font-weight: 800; padding: 12px; border-radius: 10px; border: 1px solid ${eligible ? 'transparent' : 'rgba(255,255,255,0.1)'}; cursor: ${eligible ? 'pointer' : 'not-allowed'}; font-size: 14px; transition: all 0.2s;">
            ${icon('banknote')} Withdraw Referral Earnings
          </button>
        </div>
      </div>

      <!-- Referral Network Table -->
      <div style="background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.07); border-radius: 18px; padding: 24px; overflow-x: auto;">
        <div style="margin-bottom: 16px;">
          <h2 style="margin: 0 0 4px; font-size: 1.1rem; font-weight: 700; color: white;">Referral Network</h2>
          <p style="margin: 0; color: #64748b; font-size: 0.85rem;">People who signed up using your referral link</p>
        </div>
        <table style="width: 100%; border-collapse: collapse; text-align: left; min-width: 500px;">
          <thead>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.06); color: #64748b; font-size: 0.82rem; font-weight: 600;">
              <th style="padding: 10px 16px;">Referral Name</th>
              <th style="padding: 10px 16px;">Username</th>
              <th style="padding: 10px 16px;">Referral Date</th>
              <th style="padding: 10px 16px;">Commission Earned</th>
            </tr>
          </thead>
          <tbody>${referredRowsHtml}</tbody>
        </table>
      </div>

    </div>
  `;
}

function paymentDetailsPanel() {
  return `
    <section class="dash-panel narrow-panel">
      <div class="panel-head">
        <h3 style="margin: 0; font-size: 1.05rem; font-weight: 700; color: #ffffff; letter-spacing: 0.3px;">Safaricom M-Pesa withdrawal details</h3>
        <span class="status-pill">Secure payout profile</span>
      </div>
      <form data-form="paymentDetails">
        <div class="field">
          <label for="mpesaName">Full Name</label>
          <input class="input" id="mpesaName" name="mpesaName" required value="${escapeAttr(profile.paymentDetails.mpesaName || profile.name)}" />
        </div>
        <div class="field">
          <label for="mpesaPhone">Safaricom M-Pesa Number</label>
          <input class="input" id="mpesaPhone" name="mpesaPhone" inputmode="tel" required value="${escapeAttr(profile.paymentDetails.mpesaPhone || profile.phone)}" />
        </div>
        <div class="field">
          <label for="withdrawalNote">Withdrawal details</label>
          <textarea class="textarea" id="withdrawalNote" name="withdrawalNote" placeholder="Optional notes for admin">${escapeHtml(profile.paymentDetails.withdrawalNote)}</textarea>
        </div>
        <button class="btn btn-primary btn-glow" type="submit">${icon("save")} Save Details</button>
      </form>
    </section>
  `;
}

function adminPanel() {
  if (!isAdmin()) {
    return `
      <section class="dash-panel narrow-panel no-access-panel">
        <span>${icon("shield")}</span>
        <h2>No Access only Admin</h2>
      </section>
    `;
  }
  const tabs = [
    ["reviews", "Review Submissions"],
    ["tasks", "Manage Tasks"],
    ["users", "Users & Referrals"],
    ["withdrawals", "Withdrawal Requests"],
    ["jobapps", "Job Applications"],
  ];
  const panels = {
    reviews: adminReviewPanel,
    tasks: adminTaskPanel,
    users: adminUsersPanel,
    withdrawals: adminWithdrawalsPanel,
    jobapps: adminJobsPanel,
  };
  return `
    <div style="background: var(--tb-surface); border: 1px solid var(--tb-border); border-radius: 8px; padding: 16px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
      <div>
        <h3 style="margin-bottom: 4px; display: flex; align-items: center; gap: 8px;">${icon("shield")} Maintenance Mode</h3>
        <p style="font-size: 13px; color: var(--tb-text-muted);">When enabled, regular users will see a maintenance screen. Admins will still have full access.</p>
      </div>
      <button class="btn ${globalConfig.maintenanceMode ? 'btn-primary' : 'btn-ghost'}" onclick="toggleMaintenanceMode(${!globalConfig.maintenanceMode})">
        ${globalConfig.maintenanceMode ? 'Turn Off Maintenance' : 'Turn On Maintenance'}
      </button>
    </div>
    <div class="admin-tabs">
      ${tabs
        .map(
          ([key, label]) => `<button class="${state.adminTab === key ? "is-active" : ""}" data-admin-tab="${key}">${label}</button>`,
        )
        .join("")}
    </div>
    ${(panels[state.adminTab] || adminReviewPanel)()}
  `;
}

window.toggleMaintenanceMode = async (enabled) => {
  globalConfig.maintenanceMode = enabled;
  await saveGlobalConfig();
  showToast(enabled ? "Maintenance mode ENABLED" : "Maintenance mode DISABLED");
  render();
};

function maintenanceView() {
  return `
    <section class="auth-page">
      <div class="auth-shell">
        <div class="auth-copy">
          <p class="section-kicker">Under Maintenance</p>
          <h1>We'll be right back.</h1>
        </div>
        <div class="glass-form" style="text-align: center; padding: 40px 20px;">
          <div style="font-size: 48px; margin-bottom: 20px;">🚧</div>
          <h2 style="margin-bottom: 15px;">Site Updating</h2>
          <p style="color: var(--tb-text-muted); line-height: 1.6; margin-bottom: 20px;">
            TaskBridge is currently undergoing scheduled maintenance to bring you new features and improvements. Please check back soon!
          </p>
          <button class="btn btn-ghost" onclick="window.location.reload()">Refresh Page</button>
        </div>
      </div>
    </section>
  `;
}

function productsPanel() {
  const products = productsSeed();
  return `
    <section class="dash-panel">
      <div class="panel-head">
        <h2>Premium Products</h2>
        <span class="status-pill">${products.length} available</span>
      </div>
      <div class="task-grid">
        ${products.map(productCard).join("")}
      </div>
    </section>
  `;
}

function productCard(prod) {
  const cta = prod.unlocked ? "Access Now" : `Unlock`;
  return `
    <article class="task-card" style="--g1:#8b5cf6; --g2:#d946ef">
      <div class="task-thumb" style="background-image: linear-gradient(135deg, rgba(5,8,22,.18), rgba(139,92,246,.42)), url('${prod.image}')">
        <span>${icon("shopping-bag")}</span>
        <b>18+</b>
      </div>
      <div class="task-body">
        <div class="task-meta">
          <span>Premium Access</span>
        </div>
        <h3 style="font-size: 1.1rem;">${prod.title}</h3>
        <p style="white-space: pre-wrap;" class="line-clamp-desc">${escapeHtml(prod.desc)}</p>
        <div style="flex-grow: 1;"></div>
        <div class="task-foot" style="margin-bottom: 8px;">
          <span>${icon("coins")} Fee: Ksh${prod.fee}</span>
        </div>
        <button class="btn ${prod.unlocked ? "btn-primary btn-glow" : "btn-ghost"} btn-wide" data-action="${prod.unlocked ? "openProduct" : "payProduct"}" data-product="${prod.id}">
          ${icon(prod.unlocked ? "external-link" : "lock-keyhole")}
          <span>${cta}</span>
        </button>
      </div>
    </article>
  `;
}

function productPaymentView() {
  if (!profile.active) return accessView();
  const prod = getProduct(state.selectedProductId);
  if (!prod) return dashboardView();
  
  return `
    <section class="auth-page">
      <div class="dash-panel narrow-panel" style="animation: scaleIn 0.3s ease;">
        <button class="icon-btn" data-action="home" style="margin-bottom: 1rem;" aria-label="Go back">${icon("arrow-left")}</button>
        <p class="section-kicker">UNLOCK PRODUCT</p>
        <h2>${prod.title}</h2>
        <p style="margin: 0.5rem 0 1.5rem;" class="muted">Access fee is KES ${prod.fee}</p>
        
        <form class="auth-form" data-form="productPayment" data-product="${prod.id}">
          <div class="field">
            <label>M-Pesa Number</label>
            <input class="input" type="tel" name="payPhone" required value="${escapeAttr(profile.phone || "")}" placeholder="07XX XXX XXX" />
          </div>
          <div class="info-box" style="margin-bottom: 1.5rem;">
            ${icon("shield")}
            <p>You will receive an M-Pesa prompt on your phone to complete the KES ${prod.fee} payment.</p>
          </div>
          <button class="btn btn-primary btn-glow" type="submit">${icon("banknote")} Pay KES ${prod.fee}</button>
        </form>
      </div>
    </section>
  `;
}

function adminReviewPanel() {
  const submissions = [...profile.submissions].sort((a, b) => new Date(b.submittedAt) - new Date(a.submittedAt));
  const now = new Date();
  const currentHour = now.getHours();
  const isActive = currentHour >= 6 && currentHour < 11;
  const statusClass = isActive ? "status-approved" : "status-pending";
  const statusLabel = isActive ? "ACTIVE (6am - 11am)" : "CLOSED (Active 6am - 11am)";
  
  return `
    <section class="dash-panel">
      <div class="panel-head">
        <div>
          <h2>Assignment review queue</h2>
          <p class="muted" style="margin-top: 4px; font-size: 0.9rem;">${REVIEW_WINDOW_TEXT}</p>
        </div>
        <span class="status-pill ${statusClass}">${statusLabel}</span>
      </div>
      <div class="submission-grid">
        ${
          submissions.length
            ? submissions.map(adminSubmissionCard).join("")
            : `<div class="empty-state">No submissions yet.</div>`
        }
      </div>
    </section>
  `;
}

function adminSubmissionCard(submission) {
  const task = getTask(submission.taskId);
  return `
    <form class="submission-card" data-form="adminReview" data-submission="${submission.id}">
      <div class="submission-head">
        <span class="status-pill status-${submission.status}">${submission.status}</span>
        <small>${new Date(submission.submittedAt).toLocaleString()}</small>
      </div>
      <h3>${task.title}</h3>
      <p>${escapeHtml(submission.answer).slice(0, 180)}${submission.answer.length > 180 ? "..." : ""}</p>
      <div class="detail-list compact">
        <div>${icon("user")} <span>${escapeHtml(submission.userName)}</span></div>
        <div>${icon("mail")} <span>${escapeHtml(submission.userEmail || "No email")}</span></div>
        <div>${icon("phone")} <span>${escapeHtml(submission.userPhone || "No phone")}</span></div>
        <div>${icon("paperclip")} <span>${escapeHtml(submission.fileName || "No file uploaded")}</span></div>
        <div>${icon("clock-3")} <span>Review window: 6am to 11am daily</span></div>
      </div>
      <div class="field-grid">
        <div class="field">
          <label>Score (%)</label>
          <input class="input" name="score" type="number" min="0" max="100" value="${submission.score || ""}" placeholder="0-100" />
        </div>
        <div class="field">
          <label>Payout Amount (KES)</label>
          <input class="input" name="payout" type="number" min="0" value="${submission.payout || task.reward}" placeholder="Amount" />
        </div>
      </div>
      <div class="field">
        <label>Comment / Reason</label>
        <input class="input" name="comment" value="${escapeAttr(submission.comment || "")}" placeholder="Admin feedback / Reason for score" />
      </div>
      <div class="form-row" style="flex-wrap: wrap;">
        <button class="btn btn-primary" name="decision" value="approved" type="submit" style="flex: 1;">${icon("check")} Approve</button>
        <button class="btn btn-ghost" name="decision" value="bonus" type="submit" style="flex: 1; border: 1px solid #4ade80; color: #4ade80;">${icon("gift")} Bonus</button>
        <button class="btn btn-ghost" name="decision" value="revision" type="submit" style="flex: 1; border: 1px solid #fbbf24; color: #fbbf24;">${icon("edit")} Revision</button>
        <button class="btn btn-ghost" name="decision" value="rejected" type="submit" style="flex: 1; color: #f87171;">${icon("x")} Reject</button>
      </div>
    </form>
  `;
}

function adminTaskPanel() {
  const editTask = state.editTaskId ? getTask(state.editTaskId) : null;
  return `
    <div class="grid-two">
      <section class="dash-panel">
        <div class="panel-head">
          <h2>${editTask?.custom ? "Edit custom task" : "Add new task"}</h2>
          ${editTask?.custom ? `<button class="text-btn" data-action="cancelEdit">Cancel edit</button>` : ""}
        </div>
        <form data-form="adminTask">
          <input type="hidden" name="taskId" value="${escapeAttr(editTask?.custom ? editTask.id : "")}" />
          <div class="field">
            <label>Task title</label>
            <input class="input" name="title" required value="${escapeAttr(editTask?.custom ? editTask.title : "")}" />
          </div>
          <div class="field-grid">
            <div class="field">
              <label>Category</label>
              <select class="input" name="category">
                ${categories.map((category) => `<option ${editTask?.category === category.name ? "selected" : ""}>${category.name}</option>`).join("")}
              </select>
            </div>
            <div class="field">
              <label>Unlock price</label>
              <select class="input" name="unlockFee">
                <option value="10" ${editTask?.unlockFee === 10 ? "selected" : ""}>KES 10</option>
                <option value="20" ${editTask?.unlockFee === 20 ? "selected" : ""}>KES 20</option>
              </select>
            </div>
            <div class="field">
              <label>Payout</label>
              <input class="input" name="reward" type="number" min="400" max="2000" step="50" required value="${escapeAttr(editTask?.custom ? editTask.reward : 400)}" />
              <small>Minimum KES 400, maximum KES 2,000.</small>
            </div>
          </div>
          <div class="field">
            <label>Task image URL</label>
            <input class="input" name="image" placeholder="https://..." value="${escapeAttr(editTask?.custom ? editTask.image : "")}" />
          </div>
          <div class="field">
            <label>External link</label>
            <input class="input" name="externalLink" placeholder="Optional application link" value="${escapeAttr(editTask?.custom ? editTask.externalLink : "")}" />
          </div>
          <div class="field">
            <label>Assignment instructions</label>
            <textarea class="textarea" name="instruction" required>${escapeHtml(editTask?.custom ? editTask.instruction : "")}</textarea>
          </div>
          <button class="btn btn-primary btn-glow" type="submit">${icon("save")} ${editTask?.custom ? "Save Task" : "Add Task"}</button>
        </form>
      </section>
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Custom tasks</h2>
          <span class="status-pill">${(profile.customTasks || []).length} added</span>
        </div>
        <div class="custom-task-list">
          ${
            (profile.customTasks || []).length
              ? profile.customTasks
                  .map(
                    (task) => `
                      <div class="custom-task-row">
                        <div>
                          <strong>${escapeHtml(task.title)}</strong>
                          <small>${escapeHtml(task.category)} - Payout ${money(task.reward)}</small>
                        </div>
                        <div>
                          <button class="icon-btn mini" data-action="editTask" data-task="${task.id}" aria-label="Edit task">${icon("pencil")}</button>
                          <button class="icon-btn mini" data-action="deleteTask" data-task="${task.id}" aria-label="Delete task">${icon("trash-2")}</button>
                        </div>
                      </div>
                    `,
                  )
                  .join("")
              : `<div class="empty-state">No custom admin tasks yet.</div>`
          }
        </div>
      </section>
    </div>
  `;
}

function adminSpecialPanel() {
  const task = specialTaskData();
  return `
    <section class="dash-panel narrow-panel">
      <div class="panel-head">
        <div>
          <p class="section-kicker">CONTRACT JOBS</p>
          <h2>${task.category}</h2>
        </div>
        <span class="status-pill">Access fee ${money(task.unlockFee)}</span>
      </div>
      <form data-form="adminSpecial">
        <div class="field">
          <label>Description</label>
          <textarea class="textarea" name="description" required>${escapeHtml(task.instruction)}</textarea>
        </div>
        <div class="field">
          <label>Application link</label>
          <input class="input" name="applicationLink" placeholder="https://..." value="${escapeAttr(task.externalLink)}" />
        </div>
        <div class="info-box">
          ${icon("coins")}
          <p>Payout is fixed on the user side as KES 15,000 to KES 50,000 per month. Applications are the only task in this category.</p>
        </div>
        <button class="btn btn-primary btn-glow" type="submit">${icon("save")} Save Special Category</button>
      </form>
    </section>
  `;
}

function adminEcosystemPanel() {
  const links = globalConfig.ecosystemLinks || (typeof defaultEcosystemLinks !== 'undefined' ? defaultEcosystemLinks : []);
  const editItem = state.editEcosystemId ? links.find((item) => item.id === state.editEcosystemId) : null;
  return `
    <div class="grid-two">
      <section class="dash-panel">
        <div class="panel-head">
          <h2>${editItem ? "Edit ecosystem platform" : "Add ecosystem platform"}</h2>
          ${editItem ? `<button class="text-btn" data-action="cancelEditEcosystem">Cancel edit</button>` : ""}
        </div>
        <form data-form="adminEcosystem">
          <input type="hidden" name="id" value="${escapeAttr(editItem ? editItem.id : "")}" />
          <div class="field">
            <label>Platform name</label>
            <input class="input" name="title" required placeholder="WhatsApp Channel" value="${escapeAttr(editItem ? editItem.title : "")}" />
          </div>
          <div class="field">
            <label>Button link</label>
            <input class="input" name="url" required placeholder="https://..." value="${escapeAttr(editItem ? editItem.url : "")}" />
          </div>
          <div class="field">
            <label>Description</label>
            <textarea class="textarea" name="description" required placeholder="Short description users will see">${escapeHtml(editItem ? editItem.description : "")}</textarea>
          </div>
          <button class="btn btn-primary btn-glow" type="submit">${icon("save")} ${editItem ? "Save Platform" : "Add Platform"}</button>
        </form>
      </section>
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Current platforms</h2>
          <span class="status-pill">${links.length} links</span>
        </div>
        <div class="custom-task-list">
          ${
            links.length
              ? links
                  .map(
                    (item) => `
                      <div class="custom-task-row">
                        <div>
                          <strong>${escapeHtml(item.title)}</strong>
                          <small>${escapeHtml(item.url || "No link yet")}</small>
                        </div>
                        <div>
                          <button class="icon-btn mini" data-action="editEcosystem" data-ecosystem="${escapeAttr(item.id)}" aria-label="Edit platform">${icon("pencil")}</button>
                          <button class="icon-btn mini" data-action="deleteEcosystem" data-ecosystem="${escapeAttr(item.id)}" aria-label="Delete platform">${icon("trash-2")}</button>
                        </div>
                      </div>
                    `,
                  )
                  .join("")
              : `<div class="empty-state">No ecosystem links yet.</div>`
          }
        </div>
      </section>
    </div>
  `;
}

function adminProductsPanel() {
  const products = productsSeed();
  const editProd = state.editProductId ? getProduct(state.editProductId) : null;
  return `
    <div class="grid-two">
      <section class="dash-panel">
        <div class="panel-head">
          <h2>${editProd ? "Edit Product" : "Select a product to edit"}</h2>
          ${editProd ? `<button class="text-btn" data-action="cancelEditProduct">Cancel edit</button>` : ""}
        </div>
        ${editProd ? `
        <form data-form="adminProduct">
          <input type="hidden" name="productId" value="${escapeAttr(editProd.id)}" />
          <div class="field">
            <label>Product image URL</label>
            <input class="input" name="image" placeholder="https://..." value="${escapeAttr(editProd.image)}" />
          </div>
          <div class="field">
            <label>Access URL/Link</label>
            <input class="input" name="url" placeholder="https://..." value="${escapeAttr(editProd.url)}" />
          </div>
          <div class="field">
            <label>Description</label>
            <textarea class="textarea" name="desc" style="min-height: 120px;" required>${escapeHtml(editProd.desc)}</textarea>
          </div>
          <button class="btn btn-primary btn-glow" type="submit">${icon("save")} Save Product</button>
        </form>
        ` : `
        <div class="empty-state">Click 'Edit' on a product below.</div>
        `}
      </section>
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Premium Products</h2>
        </div>
        <div class="custom-task-list">
          ${products.map(prod => `
            <div class="custom-task-row">
              <div>
                <strong>${escapeHtml(prod.title)}</strong>
                <small>Fee: Ksh${prod.fee}</small>
              </div>
              <button class="icon-btn mini" data-action="editProduct" data-product="${prod.id}" aria-label="Edit product">${icon("pencil")}</button>
            </div>
          `).join("")}
        </div>
      </section>
    </div>
  `;
}

async function fetchAllUsersForAdmin() {
  try {
    const snapshot = await getDocs(collection(db, "users"));
    state.allUsers = snapshot.docs.map(d => ({ ...d.data(), _docId: d.id }));
  } catch (err) {
    console.warn("Could not fetch users:", err);
    state.allUsers = [profile]; // mock with self if failing
  }
}

function adminUsersPanel() {
  const users = state.allUsers || [];
  
  const allWithdrawals = [];
  users.forEach(u => {
    if (u.transactions) {
      const withdrawals = u.transactions.filter(t => t.label.toLowerCase().includes("withdraw"));
      withdrawals.forEach(w => allWithdrawals.push({...w, user: u}));
    }
  });
  allWithdrawals.sort((a, b) => new Date(b.at) - new Date(a.at));

  return `
    <div class="grid-two">
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Users & Referrals</h2>
          <span class="status-pill">${users.length} users</span>
        </div>
        <div class="submission-list">
          ${users.length ? users.map(user => `
            <div class="submission-row">
              <div>
                <strong>${escapeHtml(user.name || user.email || "Unknown")}</strong>
                <small>${escapeHtml(user.email || "")} | Phone: ${escapeHtml(user.phone || 'N/A')}</small>
                <small>Invited by: ${escapeHtml(user.referredBy || 'None')} | Paid Access: ${user.active ? 'Yes' : 'No'}</small>
              </div>
              <div style="text-align: right;">
                <b>Wallet</b>
                <small>Earnings: ${money((user.wallet?.taskEarnings || 0) + (user.wallet?.referralEarnings || 0) + (user.wallet?.checkinRewards || 0))}</small>
                <small>Pending Withdraw: ${money(user.wallet?.pendingWithdrawals || 0)}</small>
              </div>
            </div>
          `).join("") : '<div class="empty-state">Loading users...</div>'}
        </div>
      </section>
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Recent Withdrawals</h2>
        </div>
        <div class="transaction-list">
          ${allWithdrawals.length ? allWithdrawals.slice(0, 50).map(w => `
            <div class="transaction-row">
              <span>${icon(w.icon || "banknote")}</span>
              <div>
                <strong>${escapeHtml(w.user.name || w.user.email)} - ${escapeHtml(w.label)}</strong>
                <small>${new Date(w.at).toLocaleString()} | M-Pesa: ${escapeHtml(w.user.paymentDetails?.mpesaPhone || w.user.phone || "N/A")}</small>
                <small>Note: ${escapeHtml(w.user.paymentDetails?.withdrawalNote || "None")}</small>
              </div>
              <b>${w.amount >= 0 ? "+" : "-"}${money(Math.abs(w.amount))}</b>
            </div>
          `).join("") : '<div class="empty-state">No withdrawal activities found.</div>'}
        </div>
      </section>
    </div>
  `;
}

function adminJobsPanel() {
  const users = state.allUsers || [];

  // Collect all job applications across all users
  const allApps = [];
  users.forEach(u => {
    (u.jobApplications || []).forEach(app => {
      allApps.push({ ...app, user: u });
    });
  });
  allApps.sort((a, b) => new Date(b.submittedAt) - new Date(a.submittedAt));

  const pending = allApps.filter(a => !a.status || a.status === 'pending');
  const reviewed = allApps.filter(a => a.status && a.status !== 'pending');

  const renderApp = (app) => `
    <div style="padding: 16px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.07); border-radius: 12px; margin-bottom: 10px; display: flex; gap: 14px; flex-wrap: wrap;">
      <div style="flex: 1; min-width: 220px;">
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
          <strong style="color: white; font-size: 1rem;">${escapeHtml(app.applicantName || app.user?.name || 'Unknown')}</strong>
          <span style="background: ${app.status === 'shortlisted' ? 'rgba(34,197,94,0.15)' : app.status === 'rejected' ? 'rgba(248,113,113,0.12)' : 'rgba(251,191,36,0.12)'}; color: ${app.status === 'shortlisted' ? '#4ade80' : app.status === 'rejected' ? '#f87171' : '#fbbf24'}; padding: 2px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; text-transform: uppercase;">${app.status || 'pending'}</span>
        </div>
        <div style="font-size: 12px; color: var(--tb-text-muted); margin-bottom: 6px;">
          ${icon('briefcase')} <strong style="color: #93c5fd;">${escapeHtml(app.jobTitle || 'N/A')}</strong> &middot; ${escapeHtml(app.organization || '')}
        </div>
        <div style="font-size: 12px; color: var(--tb-text-muted); margin-bottom: 6px;">
          ${icon('mail')} ${escapeHtml(app.applicantEmail || '')} &nbsp;|&nbsp; ${icon('phone')} ${escapeHtml(app.applicantPhone || '')}
        </div>
        ${app.coverLetter ? `<p style="font-size: 13px; color: #cbd5e1; line-height: 1.5; margin: 8px 0 0; background: rgba(255,255,255,0.03); border-left: 3px solid rgba(255,255,255,0.1); padding: 8px 12px; border-radius: 0 8px 8px 0; max-height: 80px; overflow: hidden;">${escapeHtml(app.coverLetter)}</p>` : ''}
      </div>
      <div style="display: flex; flex-direction: column; gap: 8px; align-items: flex-end; justify-content: flex-start;">
        <span style="font-size: 11px; color: var(--tb-text-muted);">${new Date(app.submittedAt).toLocaleDateString('en-KE', { day:'numeric', month:'short', year:'numeric' })}</span>
        ${app.portfolioUrl ? `<a href="${escapeHtml(app.portfolioUrl)}" target="_blank" style="display: inline-flex; align-items: center; gap: 4px; font-size: 12px; color: #60a5fa; text-decoration: none; background: rgba(37,99,235,0.1); border: 1px solid rgba(37,99,235,0.2); padding: 5px 10px; border-radius: 6px;">${icon('external-link')} CV/Portfolio</a>` : '<span style="font-size: 11px; color: #475569;">No CV link</span>'}
        <div style="display: flex; gap: 6px;">
          <button onclick="updateJobAppStatus('${app.user?._docId || ''}','${app.id}','shortlisted')" style="background: rgba(34,197,94,0.1); border: 1px solid rgba(34,197,94,0.2); color: #4ade80; padding: 5px 10px; border-radius: 6px; font-size: 12px; cursor: pointer; font-weight: 700;">Shortlist</button>
          <button onclick="updateJobAppStatus('${app.user?._docId || ''}','${app.id}','rejected')" style="background: rgba(248,113,113,0.08); border: 1px solid rgba(248,113,113,0.15); color: #f87171; padding: 5px 10px; border-radius: 6px; font-size: 12px; cursor: pointer; font-weight: 700;">Reject</button>
        </div>
      </div>
    </div>
  `;

  return `
    <div style="display: flex; flex-direction: column; gap: 20px;">
      <section class="dash-panel">
        <div class="panel-head">
          <h2>${icon('user-check')} Pending Applications</h2>
          <span class="status-pill" style="background: rgba(251,191,36,0.15); color: #fbbf24;">${pending.length} pending</span>
        </div>
        <p style="color: var(--tb-text-muted); font-size: 13px; margin: 0 0 16px;">All job applications awaiting review. Shortlist or reject applicants below.</p>
        <div>
          ${pending.length ? pending.map(renderApp).join('') : '<div class="empty-state" style="text-align: center; padding: 40px; color: var(--tb-text-muted);">No pending applications. 🎉</div>'}
        </div>
      </section>
      <section class="dash-panel">
        <div class="panel-head">
          <h2>${icon('archive')} Reviewed Applications</h2>
          <span class="status-pill" style="background: rgba(100,116,139,0.15); color: #94a3b8;">${reviewed.length} reviewed</span>
        </div>
        <div>
          ${reviewed.length ? reviewed.slice(0, 50).map(renderApp).join('') : '<div class="empty-state">No reviewed applications yet.</div>'}
        </div>
      </section>
    </div>
  `;
}

window.updateJobAppStatus = async (userDocId, appId, newStatus) => {
  if (!userDocId || !appId) { showToast('Missing application info.'); return; }
  try {
    const userDocRef = doc(db, 'users', userDocId);
    const userSnap = await getDoc(userDocRef);
    if (!userSnap.exists()) { showToast('User not found.'); return; }
    const userData = userSnap.data();
    const apps = userData.jobApplications || [];
    const idx = apps.findIndex(a => a.id === appId);
    if (idx === -1) { showToast('Application not found.'); return; }
    apps[idx].status = newStatus;
    userData.jobApplications = apps;
    await setDoc(userDocRef, userData);
    showToast(`Application marked as ${newStatus}.`);
    
    // Send status update email to applicant
    const app = apps[idx];
    fetch(`${API_BASE_URL}/api/notify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'job_application_updated',
        email: app.applicantEmail || userData.email,
        name: app.applicantName || userData.name || '',
        jobTitle: app.jobTitle || ''
      })
    }).catch(e => console.error('Notify job_application_updated error:', e));
    
    await fetchAllUsersForAdmin();
    render();
  } catch (err) {
    console.error('Error updating job application:', err);
    showToast('Failed to update application status.');
  }
};

function adminWithdrawalsPanel() {
  const users = state.allUsers || [];
  
  const pendingWithdrawals = [];
  users.forEach(u => {
    if (u.transactions) {
      u.transactions.forEach(t => {
        if (t.label && t.label.toLowerCase().includes("withdraw") && (!t.status || t.status === 'pending')) {
          pendingWithdrawals.push({ ...t, user: u });
        }
      });
    }
  });
  pendingWithdrawals.sort((a, b) => new Date(b.at) - new Date(a.at));

  const paidWithdrawals = [];
  users.forEach(u => {
    if (u.transactions) {
      u.transactions.forEach(t => {
        if (t.label && t.label.toLowerCase().includes("withdraw") && t.status === 'paid') {
          paidWithdrawals.push({ ...t, user: u });
        }
      });
    }
  });
  paidWithdrawals.sort((a, b) => new Date(b.at) - new Date(a.at));

  return `
    <div style="display: flex; flex-direction: column; gap: 20px;">
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Pending Withdrawal Requests</h2>
          <span class="status-pill" style="background: rgba(251,146,60,0.15); color: #fb923c;">${pendingWithdrawals.length} pending</span>
        </div>
        <p style="color: var(--tb-text-muted); font-size: 13px; margin: 0 0 16px;">Review and mark withdrawals as paid after sending M-Pesa. Payments should be processed between 6am\u201311am EAT.</p>
        <div class="submission-list">
          ${pendingWithdrawals.length ? pendingWithdrawals.map(w => `
            <div class="submission-row" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; padding: 16px; background: rgba(251,146,60,0.04); border: 1px solid rgba(251,146,60,0.15); border-radius: 12px; margin-bottom: 8px;">
              <div style="flex: 1; min-width: 200px;">
                <strong style="color: white;">${escapeHtml(w.user.name || w.user.email || "Unknown")}</strong>
                <div style="font-size: 12px; color: var(--tb-text-muted); margin-top: 4px;">
                  M-Pesa: <strong style="color: #4ade80;">${escapeHtml(w.user.paymentDetails?.mpesaPhone || w.user.phone || "N/A")}</strong>
                </div>
                <div style="font-size: 12px; color: var(--tb-text-muted);">
                  ${escapeHtml(w.label)} \u00b7 ${new Date(w.at).toLocaleString()}
                </div>
              </div>
              <div style="text-align: right; display: flex; align-items: center; gap: 12px;">
                <b style="color: #fb923c; font-size: 1.1rem;">KES ${Math.abs(w.amount)}</b>
                <button class="btn btn-primary" onclick="markWithdrawalPaid('${w.user._docId || ''}', '${w.id}')" style="background: #22c55e; color: #0a1628; font-weight: 700; padding: 8px 16px; border-radius: 8px; border: none; cursor: pointer; font-size: 13px;">
                  \u2713 Mark Paid
                </button>
              </div>
            </div>
          `).join("") : '<div class="empty-state" style="text-align: center; padding: 40px; color: var(--tb-text-muted);">No pending withdrawal requests. \ud83c\udf89</div>'}
        </div>
      </section>
      <section class="dash-panel">
        <div class="panel-head">
          <h2>Recently Paid</h2>
          <span class="status-pill" style="background: rgba(34,197,94,0.15); color: #4ade80;">${paidWithdrawals.length} paid</span>
        </div>
        <div class="submission-list">
          ${paidWithdrawals.length ? paidWithdrawals.slice(0, 30).map(w => `
            <div class="submission-row" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; padding: 12px 16px; opacity: 0.7;">
              <div>
                <strong>${escapeHtml(w.user.name || w.user.email || "Unknown")}</strong>
                <div style="font-size: 12px; color: var(--tb-text-muted);">${escapeHtml(w.label)} \u00b7 ${new Date(w.at).toLocaleString()}</div>
              </div>
              <div style="display: flex; align-items: center; gap: 8px;">
                <b style="color: #4ade80;">KES ${Math.abs(w.amount)}</b>
                <span style="background: rgba(34,197,94,0.15); color: #4ade80; padding: 3px 10px; border-radius: 6px; font-size: 11px; font-weight: 700;">PAID</span>
              </div>
            </div>
          `).join("") : '<div class="empty-state">No paid withdrawals yet.</div>'}
        </div>
      </section>
    </div>
  `;
}

window.markWithdrawalPaid = async (userDocId, txId) => {
  if (!userDocId || !txId) {
    showToast("Missing user or transaction information.");
    return;
  }
  if (!confirm("Confirm you have sent payment for this withdrawal?")) return;
  
  try {
    const userDocRef = doc(db, "users", userDocId);
    const userSnap = await getDoc(userDocRef);
    if (!userSnap.exists()) {
      showToast("User not found in database.");
      return;
    }
    const userData = userSnap.data();
    const txIndex = (userData.transactions || []).findIndex(t => t.id === txId);
    if (txIndex === -1) {
      showToast("Transaction not found.");
      return;
    }
    
    userData.transactions[txIndex].status = "paid";
    const withdrawAmount = Math.abs(userData.transactions[txIndex].amount);
    userData.wallet = userData.wallet || {};
    userData.wallet.pendingWithdrawals = Math.max(0, (userData.wallet.pendingWithdrawals || 0) - withdrawAmount);
    
    await setDoc(userDocRef, userData);
    showToast("Withdrawal marked as PAID successfully!");
    
    await fetchAllUsersForAdmin();
    render();
  } catch (err) {
    console.error("Error marking withdrawal as paid:", err);
    showToast("Failed to update withdrawal status.");
  }
};

function transactionList(limit) {
  const records = [...profile.transactions].reverse().slice(0, limit);
  if (!records.length) return `<div class="empty-state">No transactions yet.</div>`;
  return `
    <div class="transaction-list">
      ${records
        .map(
          (item) => `
            <div class="transaction-row">
              <span>${icon(item.icon || "receipt")}</span>
              <div>
                <strong>${escapeHtml(item.label)}</strong>
                <small>${new Date(item.at).toLocaleString()}</small>
              </div>
              <b>${item.amount >= 0 ? "+" : "-"}${money(Math.abs(item.amount))}</b>
            </div>
          `,
        )
        .join("")}
    </div>
  `;
}

function submissionList(scope, limit, taskId = "") {
  const records = profile.submissions
    .filter((submission) => !taskId || submission.taskId === taskId)
    .slice()
    .reverse()
    .slice(0, limit);
  if (!records.length) return `<div class="empty-state">No submissions yet.</div>`;
  return `
    <div class="submission-list ${scope}">
      ${records
        .map((submission) => {
          const task = getTask(submission.taskId);
          return `
            <div class="submission-row">
              <span class="status-dot status-${submission.status}"></span>
              <div>
                <strong>${task.title}</strong>
                <small>${submission.status} - ${new Date(submission.submittedAt).toLocaleString()}</small>
              </div>
              <b>${submission.score ? `${submission.score}%` : "12h"}</b>
            </div>
          `;
        })
        .join("")}
    </div>
  `;
}

function simpleInfoView(title, copy) {
  return `
    <section class="auth-page">
      <div class="dash-panel narrow-panel">
        <p class="section-kicker">TASKBRIDGE</p>
        <h1>${title}</h1>
        <p class="muted">${copy}</p>
        <button class="btn btn-primary btn-glow" data-action="home">${icon("home")} Home</button>
      </div>
    </section>
  `;
}

function initials(name) {
  const parts = String(name || "TB").trim().split(/\s+/);
  return parts.slice(0, 2).map((part) => part[0]).join("").toUpperCase();
}

function addTransaction(label, amount, iconName = "receipt", status = null) {
  const tx = {
    id: `tx-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    label,
    amount,
    icon: iconName,
    at: new Date().toISOString(),
  };
  if (status) {
    tx.status = status;
  }
  profile.transactions.push(tx);
}

function showToast(message) {
  const old = document.querySelector(".toast");
  if (old) old.remove();
  const toast = document.createElement("div");
  toast.className = "toast";
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 3200);
}

function getFormData(form) {
  return Object.fromEntries(new FormData(form).entries());
}

function generatePortalCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = 'TB-';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

async function handleSignup(form) {
  const data = getFormData(form);
  const email = String(data.email || "").trim();
  const password = String(data.password || "").trim();
  
  profile.name = String(data.name || profile.name).trim();
  profile.username = String(data.username || profile.username).trim();
  profile.email = email;
  profile.phone = String(data.phone || profile.phone).trim();
  if (!profile.joinedAt) profile.joinedAt = new Date().toISOString();
  if (!profile.portalCode) profile.portalCode = generatePortalCode();
  
  if (ADMIN_EMAILS.includes(email)) {
    if (password !== "admin123") {
      showToast("Invalid admin password.");
      return;
    }
    profile.isAdmin = true;
    profile.active = true;
  } else {
    profile.active = false;
  }
  
  getReferralCode();
  profile.referredBy = pendingReferralCode();
  
  if (profile.phone) {
    try {
      const q = query(collection(db, "users"), where("phone", "==", profile.phone));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        showToast("account already exists , proceed to log in");
        setRoute("login");
        return;
      }
    } catch (err) {}
  }
  
  try {
    await createUserWithEmailAndPassword(auth, email, password);
    
    // Trigger welcome email via worker
    fetch(`${API_BASE_URL}/api/auth/send-welcome`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: profile.email, name: profile.name, portalCode: profile.portalCode })
    }).catch(e => console.error("Welcome email failed", e));
    
  } catch (e) {
    if (e.code === 'auth/email-already-in-use') {
      showToast("Account already exists, please log in");
      setRoute("login");
    } else if (e.code === 'auth/weak-password') {
      showToast("Password is too weak");
    } else if (e.code === 'auth/invalid-email') {
      showToast("Invalid email address");
    } else {
      showToast("Signup failed. Please try again.");
      console.error("Signup error:", e);
    }
    return;
  }
  
  await saveProfile();
  if (consumePendingAcademyRedirect()) return;
  setRoute("dashboard");
}

async function handleLogin(form) {
  const data = getFormData(form);
  const email = String(data.email || "").trim();
  const password = String(data.password || "").trim();
  if (email === "admin@taskbridge.com" && password !== "admin123") {
    showToast("Invalid admin password.");
    return;
  }
  
  try {
    await signInWithEmailAndPassword(auth, email, password);
    showToast("Logged in successfully.");
  } catch (err) {
    console.error("Login error:", err);
    showToast("Invalid email or password.");
    return;
  }
  
  if (auth.currentUser) {
    try {
      const docRef = doc(db, 'users', auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        profile = mergeProfile(defaultProfile, docSnap.data());
      }
    } catch (err) {
      console.warn("Could not load profile from Firestore:", err);
    }
  }
  
  profile.email = email;
  if (!profile.username) profile.username = email.split("@")[0] || "user";
  
  if (ADMIN_EMAILS.includes(email)) {
    profile.isAdmin = true;
    profile.active = true;
  }
  
  if (profile.active) {
    welcomeUser();
    await saveProfile();
    if (consumePendingAcademyRedirect()) { showToast(state.welcomeMessage); return; }
    setRoute("dashboard");
    showToast(state.welcomeMessage);
  } else {
    await saveProfile();
    if (consumePendingAcademyRedirect()) return;
    setRoute("dashboard");
  }
}

async function handleForgotPassword() {
  const overlay = document.querySelector('.payment-modal-overlay') || (() => {
    const el = document.createElement('div');
    el.className = 'payment-modal-overlay';
    document.body.appendChild(el);
    return el;
  })();

  const inputId = 'reset-email-' + Date.now();

  overlay.innerHTML = `
    <div class="payment-modal-card" style="max-width: 420px;">
      <div style="font-size: 36px; margin-bottom: 12px;">🔒</div>
      <h2 style="margin-bottom: 6px;">Reset Password</h2>
      <p style="font-size: 13px; color: var(--tb-text-muted); margin-bottom: 18px;">Enter the email address you signed up with. We'll send you a secure link to reset your password.</p>
      <div class="field" style="margin-bottom: 14px;">
        <input id="${inputId}" class="input" type="email" placeholder="your@email.com" style="width: 100%; padding: 10px 14px; font-size: 14px;" />
      </div>
      <p id="${inputId}-msg" style="font-size: 12px; min-height: 18px; margin-bottom: 10px; color: var(--tb-text-muted);"></p>
      <button class="btn btn-primary btn-wide" id="${inputId}-btn" style="margin-bottom: 10px;">Send Reset Link</button>
      <button class="btn btn-ghost btn-wide" id="${inputId}-close">Back to Login</button>
    </div>
  `;
  overlay.classList.add('is-active');

  const sendBtn = document.getElementById(`${inputId}-btn`);
  const closeBtn = document.getElementById(`${inputId}-close`);
  const msgEl = document.getElementById(`${inputId}-msg`);
  const emailInput = document.getElementById(inputId);

  // Pre-fill from the login form if they already typed their email
  const loginEmailInput = document.getElementById('loginEmail');
  if (loginEmailInput && loginEmailInput.value) {
    emailInput.value = loginEmailInput.value;
  }

  sendBtn.addEventListener('click', async () => {
    const email = emailInput.value.trim();
    if (!email) {
      msgEl.style.color = '#ef4444';
      msgEl.textContent = 'Please enter your email address.';
      return;
    }

    sendBtn.disabled = true;
    sendBtn.textContent = 'Sending...';
    msgEl.style.color = 'var(--tb-text-muted)';
    msgEl.textContent = '';

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const resData = await response.json();
      if (!response.ok || !resData.success) {
        throw new Error(resData.message || 'Failed to send password reset email.');
      }
      
      overlay.innerHTML = `
        <div class="payment-modal-card" style="max-width: 420px;">
          <div style="font-size: 36px; margin-bottom: 12px;">✅</div>
          <h2 style="margin-bottom: 6px;">Check Your Email</h2>
          <p style="font-size: 13px; color: var(--tb-text-muted); margin-bottom: 10px;">A password reset link has been sent to:</p>
          <p style="font-size: 15px; font-weight: 600; color: var(--tb-accent); margin-bottom: 18px;">${email}</p>
          <p style="font-size: 12px; color: var(--tb-text-muted); margin-bottom: 18px;">Open the link in your email to set a new password. If you don't see it, check your spam folder.</p>
          <button class="btn btn-primary btn-wide" onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')">Back to Login</button>
        </div>
      `;
    } catch (err) {
      sendBtn.disabled = false;
      sendBtn.textContent = 'Send Reset Link';
      msgEl.style.color = '#ef4444';
      msgEl.textContent = err.message || 'Something went wrong. Please try again.';
      console.error('Password reset error:', err);
    }
  });

  closeBtn.addEventListener('click', () => {
    overlay.classList.remove('is-active');
  });
}

async function handleGoogleAuth() {
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    
    const docRef = doc(db, 'users', user.uid);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      profile = mergeProfile(defaultProfile, docSnap.data());
      if (profile.active) {
        welcomeUser();
        await saveProfile();
        if (consumePendingAcademyRedirect()) { showToast(state.welcomeMessage); return; }
        setRoute("dashboard");
        showToast(state.welcomeMessage);
      } else {
        await saveProfile();
        if (consumePendingAcademyRedirect()) return;
        setRoute("dashboard");
      }
    } else {
      profile.email = user.email || "";
      profile.name = user.displayName || "";
      profile.username = (user.displayName || user.email || "google-user").split("@")[0].replace(/\s+/g, "");
      profile.phone = user.phoneNumber || "";
      profile.active = false;
      if (!profile.joinedAt) profile.joinedAt = new Date().toISOString();
      if (!profile.portalCode) profile.portalCode = generatePortalCode();
      getReferralCode();
      profile.referredBy = pendingReferralCode();
      
      // Trigger welcome email via worker
      fetch(`${API_BASE_URL}/api/auth/send-welcome`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: profile.email, name: profile.name, portalCode: profile.portalCode })
      }).catch(e => console.error("Welcome email failed", e));
      
      await saveProfile();
      if (consumePendingAcademyRedirect()) return;
      setRoute("dashboard");
    }
  } catch (err) {
    console.warn("Google Auth failed, bypassing for testing mode.", err);
    profile.name = profile.name || "Google User";
    profile.username = profile.username || "google-user";
    profile.email = profile.email || "google-user@taskbridge.local";
    profile.active = false;
    if (!profile.joinedAt) profile.joinedAt = new Date().toISOString();
    if (!profile.portalCode) profile.portalCode = generatePortalCode();
    getReferralCode();
    profile.referredBy = pendingReferralCode();
    await saveProfile();
    if (consumePendingAcademyRedirect()) return;
    setRoute("dashboard");
  }
}

function showPaymentModal(onSuccess, phone, amount) {
  window._currentPaymentSuccess = onSuccess;
  let overlay = document.querySelector('.payment-modal-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'payment-modal-overlay';
    document.body.appendChild(overlay);
  }
  overlay.innerHTML = `
    <div class="payment-modal-card">
      <div class="modal-spinner"></div>
      <h2>Processing Payment.</h2>
      <p>Please complete payment on your phone [ M-Pesa ].</p>
      <p class="muted">Check your phone to enter M-Pesa PIN…</p>
    </div>
  `;
  overlay.classList.add('is-active');

  const reference = 'TASKBRIDGE-' + Date.now() + Math.floor(Math.random() * 1000);

  let pollCount = 0;
  const maxPolls = 24; // 2 minutes (every 5 seconds)
  let pollingActive = true;
  let transactionId = null;

  fetch(`${API_BASE_URL}/api/stk-push`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone, amount, reference }),
  })
    .then(async (res) => {
      const data = await res.json();
      console.log("STK Push Response:", data);
      
      if (data.error || data.success === false || !data.transaction_id) {
        pollingActive = false;
        const manualId = 'manual-verify-' + Date.now();
        overlay.innerHTML = `
          <div class="payment-modal-card" style="max-width: 420px;">
            <div style="font-size: 32px; margin-bottom: 10px;">📲</div>
            <h2 style="margin-bottom: 6px;">Pay via M-Pesa</h2>
            <p style="font-size: 13px; color: var(--tb-text-muted); margin-bottom: 16px;">${data.message || data.error || "Automatic push could not be sent."}</p>

            <div style="padding: 14px 16px; background: rgba(34,197,94,0.08); border: 1px solid rgba(34,197,94,0.25); border-radius: 10px; margin-bottom: 18px; text-align: left;">
              <p style="font-size: 13px; font-weight: 600; color: #16a34a; margin-bottom: 8px;">📋 Manual Payment Steps:</p>
              <ol style="font-size: 13px; line-height: 1.8; padding-left: 18px; margin: 0; color: var(--tb-text);">
                <li>Open <b>M-Pesa</b> on your phone</li>
                <li>Select <b>Lipa na M-Pesa → Pay Bill</b></li>
                <li>Business No: <b style="font-size:15px; color: #16a34a;">247247</b> (Equity) OR <b style="font-size:15px; color: #16a34a;">542542</b> (KCB) OR check your bank's Paybill</li>
                <li>Account No: <b style="font-size:15px; color: #16a34a;">01107188766150</b></li>
                <li>Amount: <b>KES ${amount}</b></li>
                <li>Enter PIN &amp; confirm</li>
              </ol>
            </div>

            <p style="font-size: 13px; margin-bottom: 8px; font-weight: 600;">After paying, enter your M-Pesa receipt code:</p>
            <div style="display: flex; gap: 8px; margin-bottom: 6px;">
              <input id="${manualId}" type="text" placeholder="e.g. QHY67XXXXX" maxlength="12"
                style="flex: 1; padding: 10px 14px; border: 1px solid var(--tb-border); border-radius: 8px; font-size: 14px; background: var(--tb-surface); color: var(--tb-text); text-transform: uppercase; letter-spacing: 1px;" />
              <button class="btn btn-primary" id="${manualId}-btn" style="white-space: nowrap; padding: 10px 16px;" onclick="verifyManualReceipt('${manualId}', '${phone}', ${amount})">
                Activate ✓
              </button>
            </div>
            <p id="${manualId}-msg" style="font-size: 12px; color: var(--tb-text-muted); min-height: 16px;"></p>

            <button class="btn btn-ghost" style="margin-top: 12px; width: 100%; font-size: 13px;" onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')">Close</button>
          </div>
        `;
      } else {
        transactionId = data.transaction_id;
      }
    })
    .catch((err) => {
      console.error("STK Push Error:", err);
      pollingActive = false;
    });

  const pollStatus = async () => {
    if (!pollingActive) return;

    if (pollCount >= maxPolls) {
      overlay.innerHTML = `
        <div class="payment-modal-card">
          <div style="font-size: 32px; margin-bottom: 15px;">❌</div>
          <h2>Payment Timeout</h2>
          <p>We did not receive confirmation of your payment in time.</p>
          <button class="btn btn-primary" onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')">Close</button>
        </div>
      `;
      return;
    }

    if (transactionId) {
      try {
        const res = await fetch(`${API_BASE_URL}/api/payment-status?transaction_id=${transactionId}`);
        const data = await res.json();
        
        // Strict verification: only consider it successful if we have a valid M-Pesa receipt code
        if (data.mpesa_receipt && String(data.mpesa_receipt).length > 5) {
          overlay.innerHTML = `
            <div class="payment-modal-card success-state">
              <div class="modal-success-icon">${icon("check")}</div>
              <h2>Payment Successful</h2>
              <p>Your M-Pesa payment has been received successfully.</p>
              <p>Receipt: ${data.mpesa_receipt}</p>
              <p>Activating your account.</p>
              <p class="muted">Access granted.</p>
            </div>
          `;
          setTimeout(() => {
            overlay.classList.remove('is-active');
            if (onSuccess) onSuccess();
          }, 2500);
          return; // Stop polling
        }
        
        // Handle explicitly failed or cancelled transactions
        if (data.status === 'FAILED' || data.status === 'Failed' || data.status === 'Cancelled') {
          overlay.innerHTML = `
            <div class="payment-modal-card">
              <div style="font-size: 32px; margin-bottom: 15px;">❌</div>
              <h2>Payment Failed</h2>
              <p>The M-Pesa payment failed or was cancelled.</p>
              <button class="btn btn-primary" onclick="document.querySelector('.payment-modal-overlay').classList.remove('is-active')">Close</button>
            </div>
          `;
          return; // Stop polling
        }
      } catch (e) {
        console.error(e);
      }
    }

    pollCount++;
    setTimeout(pollStatus, 5000);
  };

  setTimeout(pollStatus, 5000);
}

window.verifyManualReceipt = async (inputId, phone, amount) => {
  const receiptInput = document.getElementById(inputId);
  const msgLabel = document.getElementById(`${inputId}-msg`);
  const code = receiptInput.value.trim().toUpperCase();

  if (!code || code.length < 8) {
    msgLabel.style.color = '#ef4444';
    msgLabel.innerText = "Please enter a valid M-Pesa receipt code.";
    return;
  }

  msgLabel.style.color = 'var(--tb-text-muted)';
  msgLabel.innerText = "Verifying receipt...";
  document.getElementById(`${inputId}-btn`).disabled = true;

  try {
    // 1. Verify the receipt exists in the payhero_webhooks collection (meaning PayHero actually received it)
    const webhookQuery = query(collection(db, "payhero_webhooks"), where("mpesa_receipt", "==", code));
    const webhookSnap = await getDocs(webhookQuery);

    if (webhookSnap.empty) {
      msgLabel.style.color = '#ef4444';
      msgLabel.innerText = "Receipt not found. If you just paid, please wait 30 seconds and try again.";
      document.getElementById(`${inputId}-btn`).disabled = false;
      return;
    }

    // 2. Check if receipt has already been used by another account
    const usedQuery = query(collection(db, "used_receipts"), where("receipt", "==", code));
    const usedSnap = await getDocs(usedQuery);
    
    if (!usedSnap.empty) {
      msgLabel.style.color = '#ef4444';
      msgLabel.innerText = "This receipt has already been used by another account.";
      document.getElementById(`${inputId}-btn`).disabled = false;
      return;
    }

    // 3. Save it so it can't be used again
    const receiptDoc = doc(collection(db, "used_receipts"));
    await setDoc(receiptDoc, {
      receipt: code,
      email: profile.email || profile.phone,
      phone: phone,
      amount: amount,
      usedAt: new Date().toISOString()
    });

    msgLabel.style.color = '#16a34a';
    msgLabel.innerText = "Receipt verified successfully!";
    
    setTimeout(() => {
      document.querySelector('.payment-modal-overlay').classList.remove('is-active');
      if (window._currentPaymentSuccess) {
        window._currentPaymentSuccess();
      }
    }, 1500);

  } catch (err) {
    console.error(err);
    msgLabel.style.color = '#ef4444';
    msgLabel.innerText = "Verification failed. Please try again.";
    document.getElementById(`${inputId}-btn`).disabled = false;
  }
};

async function handleResetPassword(form) {
  const btn = form.querySelector('button[type="submit"]');
  const token = form.token.value;
  const newPassword = form.newPassword.value;
  const confirmPassword = form.confirmPassword.value;

  if (newPassword !== confirmPassword) {
    showToast("Passwords do not match.");
    return;
  }
  if (newPassword.length < 6) {
    showToast("Password must be at least 6 characters.");
    return;
  }
  
  btn.disabled = true;
  btn.textContent = "Updating...";

  try {
    const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, newPassword })
    });
    const data = await res.json();
    if (!res.ok || !data.success) {
      throw new Error(data.message || "Failed to reset password.");
    }
    showToast("Password updated! Please log in.");
    setRoute("login");
  } catch (err) {
    showToast(err.message);
    btn.disabled = false;
    btn.textContent = "Update Password";
  }
}

async function handleAccessPayment(form) {
  const data = getFormData(form);
  const phone = String(data.payPhone || profile.phone).trim();
  profile.phone = phone;
  showPaymentModal(async () => {
    profile.active = true;
    welcomeUser();
    addTransaction("Lifetime access activated", -100, "unlock");
    await saveProfile();
    
    // Send account activation email
    fetch(`${API_BASE_URL}/api/notify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'account_activated',
        email: profile.email,
        name: profile.name || profile.username || '',
        amount: 100,
        portalCode: profile.portalCode || ''
      })
    }).catch(e => console.error('Notify account_activated error:', e));
    
    state.dashTab = "home";
    setRoute("dashboard");
  }, phone, 100);
}

async function handleTaskPayment(form) {
  const task = getTask(form.getAttribute("data-task"));
  const data = getFormData(form);
  const phone = String(data.payPhone || profile.phone).trim();
  profile.phone = phone;
  showPaymentModal(async () => {
    profile.unlockedTasks[task.id] = true;
    addTransaction(`${task.title} unlocked`, -task.unlockFee, "lock-keyhole-open");
    await saveProfile();
    setRoute("task", { taskId: task.id });
  }, phone, task.unlockFee);
}

async function handleProductPayment(form) {
  const prod = getProduct(form.getAttribute("data-product"));
  const data = getFormData(form);
  const phone = String(data.payPhone || profile.phone).trim();
  profile.phone = phone;
  showPaymentModal(async () => {
    profile.unlockedProducts = profile.unlockedProducts || {};
    profile.unlockedProducts[prod.id] = true;
    addTransaction(`${prod.title} access unlocked`, -prod.fee, "shopping-bag");
    await saveProfile();
    setRoute("home");
  }, phone, prod.fee);
}

function handleAssignment(form) {
  const task = getTask(form.getAttribute("data-task"));
  const data = getFormData(form);
  const file = form.querySelector('input[type="file"]').files[0];
  
  // Schema Validation
  const schema = task.answerSchema || {};
  let finalAnswer = data.answer || "";
  
  if (task.answerTemplate === "custom_dynamic_form") {
    let customData = {};
    let missingRequired = false;
    (schema.fields || []).forEach(f => {
      const val = data[`custom_${f.name}`];
      if (f.required && (!val || val.trim() === "")) missingRequired = true;
      if (f.type === "number" && val) {
        if (f.min !== undefined && Number(val) < f.min) missingRequired = true;
        if (f.max !== undefined && Number(val) > f.max) missingRequired = true;
      }
      customData[f.name] = val;
    });
    
    if (missingRequired) {
      showToast("Validation Error: Please fill all required fields properly according to limits.");
      return;
    }
    finalAnswer = JSON.stringify(customData);
  } else if (task.answerTemplate === "rating") {
    const r = Number(data.answer);
    if (!r || r < 1 || r > 5) {
      showToast("Validation Error: Please select a valid star rating.");
      return;
    }
  } else if (task.answerTemplate === "multiple_choice" || task.answerTemplate === "radio_buttons") {
    if (schema.options && !schema.options.includes(data.answer)) {
      showToast("Validation Error: Please select a valid option.");
      return;
    }
  } else if (task.answerTemplate === "yes_no") {
    if (data.answer !== "Yes" && data.answer !== "No") {
      showToast("Validation Error: Please select Yes or No.");
      return;
    }
  } else {
    if ((!data.answer || data.answer.trim() === "") && !file) {
      showToast("Validation Error: Please provide a response or attach a file.");
      return;
    }
  }
  
  // Quality Control: Duplicate Check
  const isDuplicate = profile.submissions.some(s => s.taskId === task.id && (s.status === 'pending' || s.status === 'approved'));
  if (isDuplicate) {
    showToast("Quality Control: Duplicate submission detected.");
    return;
  }
  
  // Quality Control: Speed & Content Check (Simulated)
  let qcFlags = [];
  if (data.answer && data.answer.length < 50) {
    qcFlags.push("Short response");
  }

  profile.submissions.push({
    id: `sub-${Date.now()}`,
    taskId: task.id,
    userName: profile.name || "Applicant",
    userEmail: profile.email || "",
    userPhone: profile.phone || "",
    answer: finalAnswer,
    fileName: file ? file.name : "",
    status: "pending",
    score: "",
    comment: qcFlags.length ? `[System Flag] ${qcFlags.join(", ")}` : "",
    submittedAt: new Date().toISOString(),
    nextReviewAt: new Date(Date.now() + 12 * 60 * 60 * 1000).toISOString(),
  });
  saveProfile();
  
  // Clear the draft on successful submission
  try {
    localStorage.removeItem(`taskbridge_draft_${task.id}`);
  } catch (e) {}

  showToast("Assignment submitted. Admin reviews run from 6am to 11am daily.");
  setRoute("task", { taskId: task.id });
}

function handlePaymentDetails(form) {
  const data = getFormData(form);
  profile.paymentDetails = {
    mpesaName: String(data.mpesaName || "").trim(),
    mpesaPhone: String(data.mpesaPhone || "").trim(),
    withdrawalNote: String(data.withdrawalNote || "").trim(),
  };
  saveProfile();
  showToast("M-Pesa withdrawal details saved.");
  render();
}

function handleAdminReview(form, submitter) {
  if (!isAdmin()) {
    showToast("No Access only Admin");
    return;
  }
  const submission = profile.submissions.find((item) => item.id === form.getAttribute("data-submission"));
  if (!submission) return;
  const task = getTask(submission.taskId);
  const data = getFormData(form);
  const decision = submitter?.value || "approved";
  const wasApproved = submission.status === "approved" || submission.status === "bonus";
  submission.status = decision;
  submission.score = String(data.score || "");
  submission.comment = String(data.comment || "");
  const customPayout = Number(data.payout || task.reward);
  submission.payout = customPayout;
  
  let actualPayout = customPayout;
  if (decision === "bonus") {
    actualPayout += 50; // Add 50 KES bonus
  }
  
  if ((decision === "approved" || decision === "bonus") && !wasApproved) {
    profile.wallet.taskEarnings += actualPayout;
    addTransaction(`${task.title} payout ${decision === "bonus" ? "(+Bonus)" : "approved"}`, actualPayout, "badge-check");
  } else if (decision === "rejected" || decision === "revision") {
    // Handle rejection or revision
  }

  saveProfile();
  
  // Fake email notification trigger
  console.log(`[Email Notification Triggered] To: ${submission.userEmail || profile.email} | Status: ${decision} | Comment: ${submission.comment}`);
  
  showToast(`Submission ${decision}. Email notification sent.`);
  render();
}

async function handleAdminTask(form) {
  if (!isAdmin()) {
    showToast("No Access only Admin");
    return;
  }
  const data = getFormData(form);
  const category = categories.find((item) => item.name === data.category) || categories[0];
  const reward = Math.min(2000, Math.max(400, Number(data.reward || 400)));
  const task = {
    id: data.taskId || `custom-${Date.now()}`,
    category: String(data.category),
    title: String(data.title || "").trim(),
    unlockFee: Number(data.unlockFee || 10),
    reward,
    participants: 24,
    badge: "ADMIN",
    image: String(data.image || thumbnailImages[categories.indexOf(category)] || thumbnailImages[0]).trim(),
    icon: category.icon,
    glow: category.glow,
    instruction: String(data.instruction || "").trim(),
    externalLink: String(data.externalLink || "").trim(),
    custom: true,
  };
  globalConfig.customTasks = (globalConfig.customTasks || []).filter((item) => item.id !== task.id);
  globalConfig.customTasks.push(task);
  state.editTaskId = "";
  await saveGlobalConfig();
  showToast("Task saved.");
  render();
}

async function handleAdminSpecial(form) {
  if (!isAdmin()) {
    showToast("No Access only Admin");
    return;
  }
  const data = getFormData(form);
  globalConfig.specialTask = {
    description: String(data.description || "").trim(),
    applicationLink: String(data.applicationLink || "").trim(),
  };
  await saveGlobalConfig();
  showToast("Special category saved.");
  render();
}

async function handleAdminProduct(form) {
  if (!isAdmin()) {
    showToast("No Access only Admin");
    return;
  }
  const data = getFormData(form);
  const id = data.productId;
  globalConfig.customProducts = globalConfig.customProducts || {};
  globalConfig.customProducts[id] = {
    desc: String(data.desc || "").trim(),
    image: String(data.image || "").trim(),
    url: String(data.url || "").trim()
  };
  state.editProductId = "";
  await saveGlobalConfig();
  showToast("Product saved.");
  render();
}

async function handleAdminEcosystem(form) {
  if (!isAdmin()) {
    showToast("No Access only Admin");
    return;
  }
  const data = getFormData(form);
  const item = {
    id: `eco-${Date.now()}`,
    title: String(data.title || "").trim(),
    url: String(data.url || "").trim(),
    description: String(data.description || "").trim(),
  };
  globalConfig.ecosystemLinks = [...(globalConfig.ecosystemLinks || []), item];
  await saveGlobalConfig();
  showToast("Ecosystem platform added.");
  render();
}

function claimCheckIn() {
  if (!canCheckIn()) {
    showToast(`Next check-in unlocks in ${countdownText()}.`);
    return;
  }
  profile.lastCheckIn = new Date().toISOString();
  profile.wallet.checkinRewards += 5;
  addTransaction("Daily check-in payout", 5, "gift");
  saveProfile();
  showToast("KES 5 daily check-in payout added.");
  render();
}

function withdrawReferrals() {
  syncReferralEarnings();
  if (profile.wallet.referralEarnings < 50) {
    showToast("Minimum withdrawal for referral earnings is KES 50.");
    return;
  }
  const amount = profile.wallet.referralEarnings;
  
  profile.referralPaidOut = [
    ...(profile.referralPaidOut || []),
    ...profile.referredUsers.map(referralSignupKey),
  ];
  profile.wallet.referralEarnings = 0;
  profile.wallet.pendingWithdrawals += amount;
  addTransaction("Referral withdrawal requested", -amount, "banknote", "pending");
  saveProfile();
  showToast(`Withdrawal of KES ${amount} requested. Payments are processed between 6am\u201311am EAT.`);
  render();
}

function withdrawMpesa() {
  const balance = stats().walletBalance;
  if (balance < 150) {
    showToast("Minimum withdrawal is KES 150");
    return;
  }
  
  profile.wallet.taskEarnings = 0;
  profile.wallet.checkinRewards = 0;
  profile.wallet.referralEarnings = 0;
  profile.wallet.pendingWithdrawals += balance;
  
  addTransaction("M-Pesa withdrawal requested", -balance, "banknote", "pending");
  saveProfile();
  showToast(`Withdrawal of KES ${balance} requested. Payments are processed between 6am\u201311am EAT.`);
  render();
}

function withdrawTasks() {
  const taskAmount = profile.wallet.taskEarnings;
  const checkinEligible = profile.wallet.checkinRewards >= 500 ? profile.wallet.checkinRewards : 0;
  const amount = taskAmount + checkinEligible;
  if (!amount) {
    showToast("No eligible withdrawal balance. Check-in payouts require KES 500.");
    return;
  }
  profile.wallet.taskEarnings = 0;
  if (checkinEligible) profile.wallet.checkinRewards = 0;
  profile.wallet.pendingWithdrawals += amount;
  addTransaction("Withdrawal requested", -amount, "banknote", "pending");
  saveProfile();
  showToast(`Withdrawal of KES ${amount} requested. Payments are processed between 6am\u201311am EAT.`);
  render();
}

function resetSession() {
  profile = structuredClone(defaultProfile);
  saveProfile();
  // Clear Android WebView auto-login tokens
  localStorage.removeItem('tb_auth_token');
  localStorage.removeItem('tb_user_id');
  localStorage.removeItem('tb_native_app_session');
  localStorage.removeItem('taskbridgeAcademyLearner');
  syncNativeAppChrome();
  // Signal the native Android app that user logged out
  try { window.TaskBridgeApp?.onLogout(); } catch(e) {}
  setRoute("home");
}

let slideshowInterval = null;
function initSlideshow() {
  if (slideshowInterval) {
    clearInterval(slideshowInterval);
    slideshowInterval = null;
  }
  const slides = document.querySelectorAll('.live-slide');
  if (slides.length === 0) return;
  
  let currentIndex = 0;
  slideshowInterval = setInterval(() => {
    const slidesArr = document.querySelectorAll('.live-slide');
    if (slidesArr.length === 0) {
      clearInterval(slideshowInterval);
      slideshowInterval = null;
      return;
    }
    const activeSlide = document.querySelector('.live-slide.active');
    if (activeSlide) {
      activeSlide.classList.remove('active');
    }
    currentIndex = (currentIndex + 1) % slidesArr.length;
    const nextSlide = document.querySelector(`.live-slide[data-slide="${currentIndex}"]`);
    if (nextSlide) {
      nextSlide.classList.add('active');
    }
  }, 60000); // 1 minute interval
}

function render() {
  syncNativeAppChrome();
  const activeId = document.activeElement ? document.activeElement.id : null;
  const activeDataInput = document.activeElement ? document.activeElement.getAttribute("data-input") : null;
  const selectionStart = document.activeElement ? document.activeElement.selectionStart : null;
  const selectionEnd = document.activeElement ? document.activeElement.selectionEnd : null;

  const app = document.querySelector("#app");
  if (globalConfig.maintenanceMode && !isAdmin() && state.route !== "login") {
    renderHeader();
    app.innerHTML = maintenanceView();
    refreshIcons();
    return;
  }
  const routes = {
    home: landingView,
    signup: signupView,
    login: loginView,
    access: accessView,
    dashboard: dashboardView,
    'app-dashboard': dashboardView,
    task: taskDetailView,
    productPayment: productPaymentView,
    help: helpCentreView,
    'reset-password': resetPasswordView,
    terms: () => simpleInfoView("Terms", "Production terms should explain access fees, unlock fees, refunds, review timing, withdrawals, referrals, and applicant data handling."),
    privacy: () => simpleInfoView("Privacy", "Production privacy policy should describe how CVs, phone numbers, submissions, payment records, and payout details are protected."),
  };
  renderHeader();
  app.innerHTML = (routes[state.route] || landingView)();
  document.querySelector(".menu-popover")?.classList.toggle("is-open", state.menuOpen);
  document.querySelector("[data-action='menu']")?.setAttribute("aria-expanded", String(state.menuOpen));
  refreshIcons();
  initSlideshow();

  if (state.route === "home" && !isNativeAppSession() && !localStorage.getItem('tb_apk_prompt_shown')) {
    setTimeout(() => {
      if (state.route === "home" && typeof window.showApkInstallPopup === 'function') {
        window.showApkInstallPopup();
        localStorage.setItem('tb_apk_prompt_shown', 'true');
      }
    }, 3000);
  }

  if (activeId || activeDataInput) {
    let el = null;
    if (activeId) el = document.getElementById(activeId);
    if (!el && activeDataInput) el = document.querySelector(`[data-input="${activeDataInput}"]`);
    if (el) {
      el.focus();
      if (selectionStart !== null && selectionEnd !== null) {
        try {
          el.setSelectionRange(selectionStart, selectionEnd);
        } catch (e) {}
      }
    }
  }
}

function renderHeader() {
  const menu = document.querySelector(".menu-popover");
  const actions = document.querySelector(".header-actions");
  // Inject logo into header brand
  const brand = document.querySelector(".header-brand");
  if (brand && !brand.querySelector(".tb-nav-logo")) {
    brand.insertAdjacentHTML("afterbegin", `
      <div class="tb-nav-logo"><img src="data:image/png;base64,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" alt="TaskBridge Logo"/></div>
    `);
  }
  if (menu) {
    menu.innerHTML = profile.active
      ? `
        <button data-tab="market">Tasks</button>
        <button data-action="myProfile">My profile</button>
        <button data-tab="wallet">Wallet</button>
        <button data-tab="admin">Admin panel</button>
        <button data-action="logout">Sign Out</button>
      `
      : `
        <button data-action="signup">Find Work</button>
        <button data-action="signup">Hire Talent</button>
        <button data-action="academy">TaskBridge Academy</button>
        <button data-action="signup">Pricing</button>
        <button data-action="signup">Why TASKBRIDGE</button>
      `;
  }
  if (actions) {
    actions.innerHTML = profile.active
      ? `
        <button class="btn btn-ghost btn-small" data-action="dashboardHome">
          <span>Overview</span>
        </button>
        <button class="btn btn-primary btn-small" data-action="logout">
          ${icon("lock-keyhole")}
          <span>Sign Out</span>
        </button>
      `
      : `
        <button class="btn btn-ghost btn-small" data-action="login">
          <span>Log In</span>
        </button>
        <button class="btn btn-primary btn-small" data-action="start">
          ${icon("arrow-right")}
          <span>Sign Up</span>
        </button>
      `;
  }
}

document.addEventListener("click", async (event) => {
  const target = event.target.closest("[data-action], [data-tab], [data-admin-tab], [data-category]");
  if (!target) {
    if (state.menuOpen) {
      state.menuOpen = false;
      render();
    }
    if (state.mobileMenuOpen) {
      state.mobileMenuOpen = false;
      render();
    }
    return;
  }

  if (state.menuOpen && target.getAttribute("data-action") !== "menu") {
    // Don't close drawer when user is toggling jobs/finance sub-menus inside the drawer
    const tabVal = target.getAttribute("data-tab");
    if (tabVal !== "jobs" && tabVal !== "finance") {
      state.menuOpen = false;
    }
  }

  const tab = target.getAttribute("data-tab");
  if (tab) {
    if (tab === "institute") {
      // Require login/signup if not authenticated
      if (!auth.currentUser && !isNativeAppSession()) {
        // Store intent so we redirect to the academy after login/signup
        state.pendingRedirect = 'academy';
        setRoute("signup");
        return;
      }
      // Auto-sync learner details to localStorage so they are logged in if they click the link
      localStorage.setItem("taskbridgeAcademyLearner", JSON.stringify({
        full_name: profile.name || "",
        email: profile.email || "",
        phone: profile.phone || "",
        id: profile.uid || "local-user"
      }));
      window.location.href = "/academy/";
      return;
    }

    if (tab === "jobs") {
      // If clicked from mobile bottom nav, navigate directly to jobs panel
      if (target.closest('.bottom-nav')) {
        state.dashTab = "jobs";
        state.jobsMenuExpanded = false;
        setRoute("dashboard");
        return;
      }
      // Otherwise toggle the dropdown sub-menu in sidebar/drawer
      state.jobsMenuExpanded = !state.jobsMenuExpanded;
      render();
      return;
    }

    if (tab === "finance") {
      state.financeMenuExpanded = !state.financeMenuExpanded;
      render();
      return;
    }

    if (tab === "admin" && !isAdmin()) {
      showToast("No Access only Admin");
      state.dashTab = "home";
      setRoute("dashboard");
      return;
    }
    state.dashTab = tab;
    const adminTarget = target.getAttribute("data-admin-target");
    if (adminTarget) state.adminTab = adminTarget;
    
    if (tab === "referrals") {
      await syncReferralsFromFirestore();
      saveProfile();
    }
    
    setRoute("dashboard");
    return;
  }

  const adminTab = target.getAttribute("data-admin-tab");
  if (adminTab) {
    if (!isAdmin()) {
      showToast("No Access only Admin");
      return;
    }
    state.adminTab = adminTab;
    if (adminTab === "users" || adminTab === "withdrawals" || adminTab === "jobapps") {
      await fetchAllUsersForAdmin();
    }
    render();
    return;
  }

  const category = target.getAttribute("data-category");
  if (category) {
    state.activeCategory = category;
    render();
    return;
  }

  const action = target.getAttribute("data-action");
  if (action === "goToJobs") {
    window.location.href = "/opportunities";
    return;
  }
  if (action === "filterJobs") {
    const filterVal = target.getAttribute("data-filter") || "all";
    window.location.href = `/opportunities#${filterVal}`;
    return;
  }
  if (action === "viewJob") {
    const jobId = target.getAttribute("data-id");
    if (jobId) {
      showJobDetails(jobId);
    }
    return;
  }
  if (action === "menu") {
    state.menuOpen = !state.menuOpen;
    render();
    return;
  }
  if (action === "toggleTheme") {
    state.theme = state.theme === "dark" ? "light" : "dark";
    localStorage.setItem("theme", state.theme);
    if (state.theme === "dark") {
      document.body.classList.add("is-dark");
      document.body.classList.remove("is-light");
    } else {
      document.body.classList.add("is-light");
      document.body.classList.remove("is-dark");
    }
    render();
    return;
  }
  if (action === "heroMode") {
    state.heroMode = target.getAttribute("data-mode") || "work";
    render();
    return;
  }
  if (action === "signup" || action === "start") return setRoute("signup");
  if (action === "academy") {
    window.location.href = "/academy/";
    return;
  }
  if (action === "login") return setRoute("login");
  if (action === "togglePassword") {
    const btn = target.closest(".btn-toggle-password") || target;
    const input = btn.parentElement.querySelector("input");
    if (input.type === "password") {
      input.type = "text";
      btn.innerHTML = icon('eye-off');
    } else {
      input.type = "password";
      btn.innerHTML = icon('eye');
    }
    refreshIcons();
    return;
  }
  if (action === "home") {
    if (profile.active) {
      state.dashTab = "home";
      return setRoute("dashboard");
    }
    return setRoute("home");
  }
  if (action === "dashboard" || action === "dashboardHome") {
    state.dashTab = "home";
    return setRoute("dashboard");
  }
  if (action === "invite") {
    state.dashTab = "referrals";
    await syncReferralsFromFirestore();
    saveProfile();
    return setRoute("dashboard");
  }
  if (action === "myProfile") {
    state.dashTab = "payments";
    return setRoute("dashboard");
  }
  if (action === "forgotPassword") return handleForgotPassword();
  if (action === "googleAuth") return handleGoogleAuth();
  if (action === "testUnlock") {
    const task = getTask(target.getAttribute("data-task"));
    profile.unlockedTasks[task.id] = true;
    saveProfile();
    
    setRoute("task", { taskId: task.id });
    return;
  }
  if (action === "openTask") return setRoute("task", { taskId: target.getAttribute("data-task") });
  if (action === "checkin") return claimCheckIn();
  if (action === "withdrawReferrals") return withdrawReferrals();
  if (action === "withdrawTasks") return withdrawTasks();
  if (action === "withdrawMpesa") return withdrawMpesa();
  if (action === "focusMpesa") {
    state.dashTab = "wallet";
    setRoute("dashboard");
    setTimeout(() => { document.getElementById("mpesa-quick-input")?.focus(); }, 300);
    return;
  }
  if (action === "copyReferralLink") {
    const refLink = `${window.location.origin}/?ref=${getReferralCode()}`;
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(refLink);
    } else {
      const el = document.createElement("textarea");
      el.value = refLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    showToast("Referral link copied!");
    return;
  }
  if (action === "copyRef" || target.closest(".ref-link-box button")) {
    const text = document.querySelector(".ref-link input")?.value || "";
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const input = document.querySelector(".ref-link input");
      input?.select();
      document.execCommand("copy");
    }
    showToast("Referral link copied.");
    return;
  }
  if (action === "editTask") {
    if (!isAdmin()) return showToast("No Access only Admin");
    state.editTaskId = target.getAttribute("data-task");
    state.dashTab = "admin";
    state.adminTab = "tasks";
    render();
    return;
  }
  if (action === "cancelEdit") {
    state.editTaskId = "";
    render();
    return;
  }
  if (action === "deleteTask") {
    if (!isAdmin()) return showToast("No Access only Admin");
    const taskId = target.getAttribute("data-task");
    globalConfig.customTasks = (globalConfig.customTasks || []).filter((task) => task.id !== taskId);
    globalConfig.hiddenTasks = [...(globalConfig.hiddenTasks || []), taskId];
    await saveGlobalConfig();
    showToast("Task deleted.");
    render();
    return;
  }
  if (action === "editEcosystem") {
    if (!isAdmin()) return showToast("No Access only Admin");
    state.editEcosystemId = target.getAttribute("data-ecosystem");
    render();
    return;
  }
  if (action === "cancelEditEcosystem") {
    state.editEcosystemId = "";
    render();
    return;
  }
  if (action === "deleteEcosystem") {
    if (!isAdmin()) return showToast("No Access only Admin");
    const itemId = target.getAttribute("data-ecosystem");
    globalConfig.ecosystemLinks = (globalConfig.ecosystemLinks || []).filter((item) => item.id !== itemId);
    await saveGlobalConfig();
    showToast("Ecosystem platform deleted.");
    render();
    return;
  }
  if (action === "payProduct") {
    state.selectedProductId = target.getAttribute("data-product");
    setRoute("productPayment");
    return;
  }
  if (action === "openProduct") {
    const prod = getProduct(target.getAttribute("data-product"));
    if (prod && prod.url && prod.url !== "#") {
      window.open(prod.url, "_blank");
    } else {
      showToast("Admin needs to update the link for this product.");
    }
    return;
  }
  if (action === "editProduct") {
    if (!isAdmin()) return showToast("No Access only Admin");
    state.editProductId = target.getAttribute("data-product");
    render();
    return;
  }
  if (action === "cancelEditProduct") {
    state.editProductId = "";
    render();
    return;
  }
  // ── Mobile App Actions ──────────────────────────────────────────────────
  if (action === "openMobileMenu") {
    state.mobileMenuOpen = true;
    render();
    return;
  }
  if (action === "closeMobileMenu") {
    state.mobileMenuOpen = false;
    render();
    return;
  }
  if (action === "openMobileCategory") {
    const cat = target.getAttribute("data-cat");
    if (!cat) return;
    // Close the drawer if open
    state.mobileMenuOpen = false;
    if (cat === "TaskBridge Institute" || cat === "TBI") {
      window.location.href = "/academy/";
      return;
    }
    const catMap = {
      "Government Jobs": "government",
      "Private Sector": "private",
      "NGOs": "ngo",
      "International Jobs": "international",
      "International": "international",
      "Internships": "internship",
      "Attachments": "attachment",
      "Scholarships": "scholarship",
      "Side Hustle": "all",
      "Remote Jobs": "remote"
    };
    const catId = catMap[cat] || "all";
    window.location.href = `/opportunities#${catId}`;
    return;
  }
  if (action === "closeMobileCategory") {
    state.mobileSelectedCategory = null;
    state.mobileDetailFilter = "All";
    render();
    return;
  }
  if (action === "setMobileDetailFilter") {
    const filter = target.getAttribute("data-filter") || "All";
    state.mobileDetailFilter = filter;
    render();
    return;
  }
  if (action === "setMobileTab") {
    const mobileTab = target.getAttribute("data-tab");
    if (!mobileTab) return;
    // Close category panel when switching tabs
    state.mobileSelectedCategory = null;
    state.mobileDetailFilter = "All";
    // Close the drawer
    state.mobileMenuOpen = false;
    if (mobileTab === "institute" && isNativeAppSession()) {
      window.location.href = "/academy/";
      return;
    }
    if (mobileTab === "institute" && !auth.currentUser) {
      state.pendingRedirect = "academy";
      setRoute("signup");
      return;
    }
    if (mobileTab === "institute") {
      window.location.href = "/academy/";
      return;
    }
    state.dashTab = mobileTab;
    render();
    return;
  }
  if (action === "viewMobileJob") {
    const jobId = target.getAttribute("data-jobid");
    if (jobId) {
      showJobDetails(jobId);
    }
    return;
  }
  // ── End Mobile App Actions ───────────────────────────────────────────────

  if (action === "help") {
    setRoute("help");
    return;
  }
  if (action === "logout") {
    signOut(auth).then(() => {
      resetSession();
      showToast("Signed out.");
    });
    return;
  }
  if (action === "installApp") {
    window.handleApkDownload();
    return;
  }
  if (action === "copyRef") {
    const refInput = document.querySelector('#ref-link-input');
    if (refInput) {
      const text = refInput.value;
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        refInput.select();
        document.execCommand('copy');
      }
      showToast('Referral link copied.');
    }
    return;
  }
});

document.addEventListener("input", (event) => {
  const input = event.target.closest("[data-input]");
  if (input) {
    const type = input.getAttribute("data-input");
    if (type === "search") {
      state.search = input.value;
      if (state.dashTab !== "market" && state.dashTab !== "tasks") {
        state.dashTab = "market";
      }
    }
    if (type === "jobsSearch") state.jobsSearch = input.value;
    if (type === "sort") state.sort = input.value;
    if (type === "filterDifficulty") state.filterDifficulty = input.value;
    if (type === "filterDuration") state.filterDuration = input.value;
    if (type === "filterCountry") state.filterCountry = input.value;
    if (type === "filterLevel") state.filterLevel = input.value;
    render();
  }

  // Workspace Autosave Logic
  if (event.target.id === "answer" && event.target.closest("form[data-form='assignment']")) {
    const form = event.target.closest("form[data-form='assignment']");
    const statusEl = form.querySelector('.workspace-save-status');
    
    if (statusEl) {
      statusEl.textContent = '● Saving...';
      statusEl.style.color = '#fbbf24';
      statusEl.style.background = 'rgba(251,191,36,0.1)';
    }
    
    if (window.workspaceSaveTimeout) clearTimeout(window.workspaceSaveTimeout);
    
    window.workspaceSaveTimeout = setTimeout(() => {
      const taskId = form.getAttribute("data-task");
      const draft = {
        taskId: taskId,
        content: event.target.value,
        timestamp: Date.now()
      };
      localStorage.setItem(`taskbridge_draft_${taskId}`, JSON.stringify(draft));
      
      if (statusEl) {
        statusEl.textContent = '● Autosaved';
        statusEl.style.color = '#4ade80';
        statusEl.style.background = 'rgba(34,197,94,0.1)';
      }
    }, 1000);
  }
});

document.addEventListener("submit", async (event) => {
  event.preventDefault();
  const form = event.target;
  const name = form.getAttribute("data-form");
  if (name === "signup") return handleSignup(form);
  if (name === "login") return handleLogin(form);
  if (name === "resetPassword") return handleResetPassword(form);
  if (name === "accessPayment") return handleAccessPayment(form);
  if (name === "taskPayment") return handleTaskPayment(form);
  if (name === "assignment") return handleAssignment(form);
  if (name === "paymentDetails") return handlePaymentDetails(form);
  if (name === "adminReview") return handleAdminReview(form, event.submitter);
  if (name === "adminTask") return await handleAdminTask(form);
  if (name === "adminSpecial") return await handleAdminSpecial(form);
  if (name === "adminEcosystem") return await handleAdminEcosystem(form);
  if (name === "adminProduct") return await handleAdminProduct(form);
  if (name === "productPayment") return handleProductPayment(form);
});

window.addEventListener("hashchange", () => {
  const hash = window.location.hash.replace("#", "");
  if (hash === "terms") setRoute("terms");
  if (hash === "privacy") setRoute("privacy");
  if (hash === "signup") setRoute("signup");
  if (hash === "login") setRoute("login");
  if (hash.startsWith("reset-password")) setRoute("reset-password");
  if (hash === "dashboard" || hash === "app-dashboard") setRoute("dashboard");
  if (hash === "home" || hash === "") {
    if (profile.active || auth.currentUser) {
      state.dashTab = "home";
      setRoute("dashboard");
    } else {
      setRoute("home");
    }
  }
});

resolveReferralCode();

// ── Android WebView: if tb_auth_token was injected, skip landing page ──
if (isNativeAppSession() && localStorage.getItem('tb_user_id')) {
  state.route = 'dashboard';
  state.dashTab = 'home';
} else if (pendingReferralCode() && !profile.active) {
  state.route = "signup";
} else if (window.location.hash.startsWith("#reset-password")) {
  state.route = "reset-password";
}

function helpCentreView() {
  return `
    <section class="auth-page">
      <div class="dash-panel narrow-panel" style="animation: scaleIn 0.3s ease; text-align: center;">
        <button class="icon-btn" data-action="home" style="margin-bottom: 1rem; align-self: flex-start;" aria-label="Go back">${icon("arrow-left")}</button>
        <div style="font-size: 3rem; color: #22c55e; margin-bottom: 1rem;">${icon("message-circle")}</div>
        <h2>Help Centre</h2>
        <p style="margin: 1rem 0;" class="muted">For any inquiries, support, or issues, please reach out to us on WhatsApp:</p>
        <h3 style="font-size: 1.5rem; letter-spacing: 2px; margin-bottom: 1.5rem;">0719 105 828</h3>
        <a href="https://wa.me/254719105828" target="_blank" class="btn btn-primary btn-glow btn-wide" style="display: flex; justify-content: center; text-decoration: none;">
          Chat on WhatsApp
        </a>
      </div>
    </section>
  `;
}

render();
